export default [
  {

    "label": "北京",
    "value": "110000",
    "children": [
      {

        "label": "北京市",
        "value": "110100",
        "children": [
          {

            "label": "东城",
            "value": "110101",

          },
          {

            "label": "西城",
            "value": "110102",

          },
          {

            "label": "朝阳",
            "value": "110105",

          },
          {

            "label": "丰台",
            "value": "110106",

          },
          {

            "label": "石景山",
            "value": "110107",

          },
          {

            "label": "海淀",
            "value": "110108",

          },
          {

            "label": "门头沟",
            "value": "110109",

          },
          {

            "label": "房山",
            "value": "110111",

          },
          {

            "label": "通州",
            "value": "110112",

          },
          {

            "label": "顺义",
            "value": "110113",

          },
          {

            "label": "昌平",
            "value": "110114",

          },
          {

            "label": "大兴",
            "value": "110115",

          },
          {

            "label": "怀柔",
            "value": "110116",

          },
          {

            "label": "平谷",
            "value": "110117",

          },
          {

            "label": "密云",
            "value": "110228",

          },
          {

            "label": "延庆",
            "value": "110229",

          }
        ]
      }
    ]
  },
  {

    "label": "天津",
    "value": "120000",
    "children": [
      {

        "label": "天津市",
        "value": "120100",
        "children": [
          {

            "label": "和平",
            "value": "120101",

          },
          {

            "label": "河东",
            "value": "120102",

          },
          {

            "label": "河西",
            "value": "120103",

          },
          {

            "label": "南开",
            "value": "120104",

          },
          {

            "label": "河北",
            "value": "120105",

          },
          {

            "label": "红桥",
            "value": "120106",

          },
          {

            "label": "东丽",
            "value": "120110",

          },
          {

            "label": "西青",
            "value": "120111",

          },
          {

            "label": "津南",
            "value": "120112",

          },
          {

            "label": "北辰",
            "value": "120113",

          },
          {

            "label": "武清",
            "value": "120114",

          },
          {

            "label": "宝坻",
            "value": "120115",

          },
          {

            "label": "滨海新区",
            "value": "120116",

          },
          {

            "label": "宁河",
            "value": "120221",

          },
          {

            "label": "静海",
            "value": "120223",

          },
          {

            "label": "蓟县",
            "value": "120225",

          }
        ]
      }
    ]
  },
  {

    "label": "河北",
    "value": "130000",
    "children": [
      {

        "label": "石家庄",
        "value": "130100",
        "children": [
          {

            "label": "长安",
            "value": "130102",

          },
          {

            "label": "桥西",
            "value": "130104",

          },
          {

            "label": "新华",
            "value": "130105",

          },
          {

            "label": "井陉矿区",
            "value": "130107",

          },
          {

            "label": "裕华",
            "value": "130108",

          },
          {

            "label": "藁城",
            "value": "130109",

          },
          {

            "label": "鹿泉",
            "value": "130110",

          },
          {

            "label": "栾城",
            "value": "130111",

          },
          {

            "label": "井陉",
            "value": "130121",

          },
          {

            "label": "正定",
            "value": "130123",

          },
          {

            "label": "行唐",
            "value": "130125",

          },
          {

            "label": "灵寿",
            "value": "130126",

          },
          {

            "label": "高邑",
            "value": "130127",

          },
          {

            "label": "深泽",
            "value": "130128",

          },
          {

            "label": "赞皇",
            "value": "130129",

          },
          {

            "label": "无极",
            "value": "130130",

          },
          {

            "label": "平山",
            "value": "130131",

          },
          {

            "label": "元氏",
            "value": "130132",

          },
          {

            "label": "赵县",
            "value": "130133",

          },
          {

            "label": "辛集",
            "value": "130181",

          },
          {

            "label": "晋州",
            "value": "130183",

          },
          {

            "label": "新乐",
            "value": "130184",

          }
        ]
      },
      {

        "label": "唐山",
        "value": "130200",
        "children": [
          {

            "label": "路南",
            "value": "130202",

          },
          {

            "label": "路北",
            "value": "130203",

          },
          {

            "label": "古冶",
            "value": "130204",

          },
          {

            "label": "开平",
            "value": "130205",

          },
          {

            "label": "丰南",
            "value": "130207",

          },
          {

            "label": "丰润",
            "value": "130208",

          },
          {

            "label": "曹妃甸",
            "value": "130209",

          },
          {

            "label": "滦县",
            "value": "130223",

          },
          {

            "label": "滦南",
            "value": "130224",

          },
          {

            "label": "乐亭",
            "value": "130225",

          },
          {

            "label": "迁西",
            "value": "130227",

          },
          {

            "label": "玉田",
            "value": "130229",

          },
          {

            "label": "遵化",
            "value": "130281",

          },
          {

            "label": "迁安",
            "value": "130283",

          }
        ]
      },
      {

        "label": "秦皇岛",
        "value": "130300",
        "children": [
          {

            "label": "海港",
            "value": "130302",

          },
          {

            "label": "山海关",
            "value": "130303",

          },
          {

            "label": "北戴河",
            "value": "130304",

          },
          {

            "label": "青龙",
            "value": "130321",

          },
          {

            "label": "昌黎",
            "value": "130322",

          },
          {

            "label": "抚宁",
            "value": "130323",

          },
          {

            "label": "卢龙",
            "value": "130324",

          }
        ]
      },
      {

        "label": "邯郸",
        "value": "130400",
        "children": [
          {

            "label": "邯山",
            "value": "130402",

          },
          {

            "label": "丛台",
            "value": "130403",

          },
          {

            "label": "复兴",
            "value": "130404",

          },
          {

            "label": "峰峰矿区",
            "value": "130406",

          },
          {

            "label": "邯郸",
            "value": "130421",

          },
          {

            "label": "临漳",
            "value": "130423",

          },
          {

            "label": "成安",
            "value": "130424",

          },
          {

            "label": "大名",
            "value": "130425",

          },
          {

            "label": "涉县",
            "value": "130426",

          },
          {

            "label": "磁县",
            "value": "130427",

          },
          {

            "label": "肥乡",
            "value": "130428",

          },
          {

            "label": "永年",
            "value": "130429",

          },
          {

            "label": "邱县",
            "value": "130430",

          },
          {

            "label": "鸡泽",
            "value": "130431",

          },
          {

            "label": "广平",
            "value": "130432",

          },
          {

            "label": "馆陶",
            "value": "130433",

          },
          {

            "label": "魏县",
            "value": "130434",

          },
          {

            "label": "曲周",
            "value": "130435",

          },
          {

            "label": "武安",
            "value": "130481",

          }
        ]
      },
      {

        "label": "邢台",
        "value": "130500",
        "children": [
          {

            "label": "桥东",
            "value": "130502",

          },
          {

            "label": "桥西",
            "value": "130503",

          },
          {

            "label": "邢台",
            "value": "130521",

          },
          {

            "label": "临城",
            "value": "130522",

          },
          {

            "label": "内丘",
            "value": "130523",

          },
          {

            "label": "柏乡",
            "value": "130524",

          },
          {

            "label": "隆尧",
            "value": "130525",

          },
          {

            "label": "任县",
            "value": "130526",

          },
          {

            "label": "南和",
            "value": "130527",

          },
          {

            "label": "宁晋",
            "value": "130528",

          },
          {

            "label": "巨鹿",
            "value": "130529",

          },
          {

            "label": "新河",
            "value": "130530",

          },
          {

            "label": "广宗",
            "value": "130531",

          },
          {

            "label": "平乡",
            "value": "130532",

          },
          {

            "label": "威县",
            "value": "130533",

          },
          {

            "label": "清河",
            "value": "130534",

          },
          {

            "label": "临西",
            "value": "130535",

          },
          {

            "label": "南宫",
            "value": "130581",

          },
          {

            "label": "沙河",
            "value": "130582",

          }
        ]
      },
      {

        "label": "保定",
        "value": "130600",
        "children": [
          {

            "label": "新市",
            "value": "130602",

          },
          {

            "label": "北市",
            "value": "130603",

          },
          {

            "label": "南市",
            "value": "130604",

          },
          {

            "label": "满城",
            "value": "130621",

          },
          {

            "label": "清苑",
            "value": "130622",

          },
          {

            "label": "涞水",
            "value": "130623",

          },
          {

            "label": "阜平",
            "value": "130624",

          },
          {

            "label": "徐水",
            "value": "130625",

          },
          {

            "label": "定兴",
            "value": "130626",

          },
          {

            "label": "唐县",
            "value": "130627",

          },
          {

            "label": "高阳",
            "value": "130628",

          },
          {

            "label": "容城",
            "value": "130629",

          },
          {

            "label": "涞源",
            "value": "130630",

          },
          {

            "label": "望都",
            "value": "130631",

          },
          {

            "label": "安新",
            "value": "130632",

          },
          {

            "label": "易县",
            "value": "130633",

          },
          {

            "label": "曲阳",
            "value": "130634",

          },
          {

            "label": "蠡县",
            "value": "130635",

          },
          {

            "label": "顺平",
            "value": "130636",

          },
          {

            "label": "博野",
            "value": "130637",

          },
          {

            "label": "雄县",
            "value": "130638",

          },
          {

            "label": "涿州",
            "value": "130681",

          },
          {

            "label": "定州",
            "value": "130682",

          },
          {

            "label": "安国",
            "value": "130683",

          },
          {

            "label": "高碑店",
            "value": "130684",

          }
        ]
      },
      {

        "label": "张家口",
        "value": "130700",
        "children": [
          {

            "label": "桥东",
            "value": "130702",

          },
          {

            "label": "桥西",
            "value": "130703",

          },
          {

            "label": "宣化",
            "value": "130705",

          },
          {

            "label": "下花园",
            "value": "130706",

          },
          {

            "label": "宣化",
            "value": "130721",

          },
          {

            "label": "张北",
            "value": "130722",

          },
          {

            "label": "康保",
            "value": "130723",

          },
          {

            "label": "沽源",
            "value": "130724",

          },
          {

            "label": "尚义",
            "value": "130725",

          },
          {

            "label": "蔚县",
            "value": "130726",

          },
          {

            "label": "阳原",
            "value": "130727",

          },
          {

            "label": "怀安",
            "value": "130728",

          },
          {

            "label": "万全",
            "value": "130729",

          },
          {

            "label": "怀来",
            "value": "130730",

          },
          {

            "label": "涿鹿",
            "value": "130731",

          },
          {

            "label": "赤城",
            "value": "130732",

          },
          {

            "label": "崇礼",
            "value": "130733",

          }
        ]
      },
      {

        "label": "承德",
        "value": "130800",
        "children": [
          {

            "label": "双桥",
            "value": "130802",

          },
          {

            "label": "双滦",
            "value": "130803",

          },
          {

            "label": "鹰手营子矿区",
            "value": "130804",

          },
          {

            "label": "承德",
            "value": "130821",

          },
          {

            "label": "兴隆",
            "value": "130822",

          },
          {

            "label": "平泉",
            "value": "130823",

          },
          {

            "label": "滦平",
            "value": "130824",

          },
          {

            "label": "隆化",
            "value": "130825",

          },
          {

            "label": "丰宁",
            "value": "130826",

          },
          {

            "label": "宽城",
            "value": "130827",

          },
          {

            "label": "围场",
            "value": "130828",

          }
        ]
      },
      {

        "label": "沧州",
        "value": "130900",
        "children": [
          {

            "label": "新华",
            "value": "130902",

          },
          {

            "label": "运河",
            "value": "130903",

          },
          {

            "label": "沧县",
            "value": "130921",

          },
          {

            "label": "青县",
            "value": "130922",

          },
          {

            "label": "东光",
            "value": "130923",

          },
          {

            "label": "海兴",
            "value": "130924",

          },
          {

            "label": "盐山",
            "value": "130925",

          },
          {

            "label": "肃宁",
            "value": "130926",

          },
          {

            "label": "南皮",
            "value": "130927",

          },
          {

            "label": "吴桥",
            "value": "130928",

          },
          {

            "label": "献县",
            "value": "130929",

          },
          {

            "label": "孟村",
            "value": "130930",

          },
          {

            "label": "泊头",
            "value": "130981",

          },
          {

            "label": "任丘",
            "value": "130982",

          },
          {

            "label": "黄骅",
            "value": "130983",

          },
          {

            "label": "河间",
            "value": "130984",

          }
        ]
      },
      {

        "label": "廊坊",
        "value": "131000",
        "children": [
          {

            "label": "安次",
            "value": "131002",

          },
          {

            "label": "广阳",
            "value": "131003",

          },
          {

            "label": "固安",
            "value": "131022",

          },
          {

            "label": "永清",
            "value": "131023",

          },
          {

            "label": "香河",
            "value": "131024",

          },
          {

            "label": "大城",
            "value": "131025",

          },
          {

            "label": "文安",
            "value": "131026",

          },
          {

            "label": "大厂",
            "value": "131028",

          },
          {

            "label": "霸州",
            "value": "131081",

          },
          {

            "label": "三河",
            "value": "131082",

          }
        ]
      },
      {

        "label": "衡水",
        "value": "131100",
        "children": [
          {

            "label": "桃城",
            "value": "131102",

          },
          {

            "label": "枣强",
            "value": "131121",

          },
          {

            "label": "武邑",
            "value": "131122",

          },
          {

            "label": "武强",
            "value": "131123",

          },
          {

            "label": "饶阳",
            "value": "131124",

          },
          {

            "label": "安平",
            "value": "131125",

          },
          {

            "label": "故城",
            "value": "131126",

          },
          {

            "label": "景县",
            "value": "131127",

          },
          {

            "label": "阜城",
            "value": "131128",

          },
          {

            "label": "冀州",
            "value": "131181",

          },
          {

            "label": "深州",
            "value": "131182",

          }
        ]
      }
    ]
  },
  {

    "label": "山西",
    "value": "140000",
    "children": [
      {

        "label": "太原",
        "value": "140100",
        "children": [
          {

            "label": "小店",
            "value": "140105",

          },
          {

            "label": "迎泽",
            "value": "140106",

          },
          {

            "label": "杏花岭",
            "value": "140107",

          },
          {

            "label": "尖草坪",
            "value": "140108",

          },
          {

            "label": "万柏林",
            "value": "140109",

          },
          {

            "label": "晋源",
            "value": "140110",

          },
          {

            "label": "清徐",
            "value": "140121",

          },
          {

            "label": "阳曲",
            "value": "140122",

          },
          {

            "label": "娄烦",
            "value": "140123",

          },
          {

            "label": "古交",
            "value": "140181",

          }
        ]
      },
      {

        "label": "大同",
        "value": "140200",
        "children": [
          {

            "label": "城区",
            "value": "140202",

          },
          {

            "label": "矿区",
            "value": "140203",

          },
          {

            "label": "南郊",
            "value": "140211",

          },
          {

            "label": "新荣",
            "value": "140212",

          },
          {

            "label": "阳高",
            "value": "140221",

          },
          {

            "label": "天镇",
            "value": "140222",

          },
          {

            "label": "广灵",
            "value": "140223",

          },
          {

            "label": "灵丘",
            "value": "140224",

          },
          {

            "label": "浑源",
            "value": "140225",

          },
          {

            "label": "左云",
            "value": "140226",

          },
          {

            "label": "大同",
            "value": "140227",

          }
        ]
      },
      {

        "label": "阳泉",
        "value": "140300",
        "children": [
          {

            "label": "城区",
            "value": "140302",

          },
          {

            "label": "矿区",
            "value": "140303",

          },
          {

            "label": "郊区",
            "value": "140311",

          },
          {

            "label": "平定",
            "value": "140321",

          },
          {

            "label": "盂县",
            "value": "140322",

          }
        ]
      },
      {

        "label": "长治",
        "value": "140400",
        "children": [
          {

            "label": "城区",
            "value": "140402",

          },
          {

            "label": "郊区",
            "value": "140411",

          },
          {

            "label": "长治",
            "value": "140421",

          },
          {

            "label": "襄垣",
            "value": "140423",

          },
          {

            "label": "屯留",
            "value": "140424",

          },
          {

            "label": "平顺",
            "value": "140425",

          },
          {

            "label": "黎城",
            "value": "140426",

          },
          {

            "label": "壶关",
            "value": "140427",

          },
          {

            "label": "长子",
            "value": "140428",

          },
          {

            "label": "武乡",
            "value": "140429",

          },
          {

            "label": "沁县",
            "value": "140430",

          },
          {

            "label": "沁源",
            "value": "140431",

          },
          {

            "label": "潞城",
            "value": "140481",

          }
        ]
      },
      {

        "label": "晋城",
        "value": "140500",
        "children": [
          {

            "label": "城区",
            "value": "140502",

          },
          {

            "label": "沁水",
            "value": "140521",

          },
          {

            "label": "阳城",
            "value": "140522",

          },
          {

            "label": "陵川",
            "value": "140524",

          },
          {

            "label": "泽州",
            "value": "140525",

          },
          {

            "label": "高平",
            "value": "140581",

          }
        ]
      },
      {

        "label": "朔州",
        "value": "140600",
        "children": [
          {

            "label": "朔城",
            "value": "140602",

          },
          {

            "label": "平鲁",
            "value": "140603",

          },
          {

            "label": "山阴",
            "value": "140621",

          },
          {

            "label": "应县",
            "value": "140622",

          },
          {

            "label": "右玉",
            "value": "140623",

          },
          {

            "label": "怀仁",
            "value": "140624",

          }
        ]
      },
      {

        "label": "晋中",
        "value": "140700",
        "children": [
          {

            "label": "榆次",
            "value": "140702",

          },
          {

            "label": "榆社",
            "value": "140721",

          },
          {

            "label": "左权",
            "value": "140722",

          },
          {

            "label": "和顺",
            "value": "140723",

          },
          {

            "label": "昔阳",
            "value": "140724",

          },
          {

            "label": "寿阳",
            "value": "140725",

          },
          {

            "label": "太谷",
            "value": "140726",

          },
          {

            "label": "祁县",
            "value": "140727",

          },
          {

            "label": "平遥",
            "value": "140728",

          },
          {

            "label": "灵石",
            "value": "140729",

          },
          {

            "label": "介休",
            "value": "140781",

          }
        ]
      },
      {

        "label": "运城",
        "value": "140800",
        "children": [
          {

            "label": "盐湖",
            "value": "140802",

          },
          {

            "label": "临猗",
            "value": "140821",

          },
          {

            "label": "万荣",
            "value": "140822",

          },
          {

            "label": "闻喜",
            "value": "140823",

          },
          {

            "label": "稷山",
            "value": "140824",

          },
          {

            "label": "新绛",
            "value": "140825",

          },
          {

            "label": "绛县",
            "value": "140826",

          },
          {

            "label": "垣曲",
            "value": "140827",

          },
          {

            "label": "夏县",
            "value": "140828",

          },
          {

            "label": "平陆",
            "value": "140829",

          },
          {

            "label": "芮城",
            "value": "140830",

          },
          {

            "label": "永济",
            "value": "140881",

          },
          {

            "label": "河津",
            "value": "140882",

          }
        ]
      },
      {

        "label": "忻州",
        "value": "140900",
        "children": [
          {

            "label": "忻府",
            "value": "140902",

          },
          {

            "label": "定襄",
            "value": "140921",

          },
          {

            "label": "五台",
            "value": "140922",

          },
          {

            "label": "代县",
            "value": "140923",

          },
          {

            "label": "繁峙",
            "value": "140924",

          },
          {

            "label": "宁武",
            "value": "140925",

          },
          {

            "label": "静乐",
            "value": "140926",

          },
          {

            "label": "神池",
            "value": "140927",

          },
          {

            "label": "五寨",
            "value": "140928",

          },
          {

            "label": "岢岚",
            "value": "140929",

          },
          {

            "label": "河曲",
            "value": "140930",

          },
          {

            "label": "保德",
            "value": "140931",

          },
          {

            "label": "偏关",
            "value": "140932",

          },
          {

            "label": "原平",
            "value": "140981",

          }
        ]
      },
      {

        "label": "临汾",
        "value": "141000",
        "children": [
          {

            "label": "尧都",
            "value": "141002",

          },
          {

            "label": "曲沃",
            "value": "141021",

          },
          {

            "label": "翼城",
            "value": "141022",

          },
          {

            "label": "襄汾",
            "value": "141023",

          },
          {

            "label": "洪洞",
            "value": "141024",

          },
          {

            "label": "古县",
            "value": "141025",

          },
          {

            "label": "安泽",
            "value": "141026",

          },
          {

            "label": "浮山",
            "value": "141027",

          },
          {

            "label": "吉县",
            "value": "141028",

          },
          {

            "label": "乡宁",
            "value": "141029",

          },
          {

            "label": "大宁",
            "value": "141030",

          },
          {

            "label": "隰县",
            "value": "141031",

          },
          {

            "label": "永和",
            "value": "141032",

          },
          {

            "label": "蒲县",
            "value": "141033",

          },
          {

            "label": "汾西",
            "value": "141034",

          },
          {

            "label": "侯马",
            "value": "141081",

          },
          {

            "label": "霍州",
            "value": "141082",

          }
        ]
      },
      {

        "label": "吕梁",
        "value": "141100",
        "children": [
          {

            "label": "离石",
            "value": "141102",

          },
          {

            "label": "文水",
            "value": "141121",

          },
          {

            "label": "交城",
            "value": "141122",

          },
          {

            "label": "兴县",
            "value": "141123",

          },
          {

            "label": "临县",
            "value": "141124",

          },
          {

            "label": "柳林",
            "value": "141125",

          },
          {

            "label": "石楼",
            "value": "141126",

          },
          {

            "label": "岚县",
            "value": "141127",

          },
          {

            "label": "方山",
            "value": "141128",

          },
          {

            "label": "中阳",
            "value": "141129",

          },
          {

            "label": "交口",
            "value": "141130",

          },
          {

            "label": "孝义",
            "value": "141181",

          },
          {

            "label": "汾阳",
            "value": "141182",

          }
        ]
      }
    ]
  },
  {

    "label": "内蒙古",
    "value": "150000",
    "children": [
      {

        "label": "呼和浩特",
        "value": "150100",
        "children": [
          {

            "label": "新城",
            "value": "150102",

          },
          {

            "label": "回民",
            "value": "150103",

          },
          {

            "label": "玉泉",
            "value": "150104",

          },
          {

            "label": "赛罕",
            "value": "150105",

          },
          {

            "label": "土默特左旗",
            "value": "150121",

          },
          {

            "label": "托克托",
            "value": "150122",

          },
          {

            "label": "和林格尔",
            "value": "150123",

          },
          {

            "label": "清水河",
            "value": "150124",

          },
          {

            "label": "武川",
            "value": "150125",

          }
        ]
      },
      {

        "label": "包头",
        "value": "150200",
        "children": [
          {

            "label": "东河",
            "value": "150202",

          },
          {

            "label": "昆都仑",
            "value": "150203",

          },
          {

            "label": "青山",
            "value": "150204",

          },
          {

            "label": "石拐",
            "value": "150205",

          },
          {

            "label": "白云鄂博矿区",
            "value": "150206",

          },
          {

            "label": "九原",
            "value": "150207",

          },
          {

            "label": "土默特右旗",
            "value": "150221",

          },
          {

            "label": "固阳",
            "value": "150222",

          },
          {

            "label": "达茂旗",
            "value": "150223",

          }
        ]
      },
      {

        "label": "乌海",
        "value": "150300",
        "children": [
          {

            "label": "海勃湾",
            "value": "150302",

          },
          {

            "label": "海南",
            "value": "150303",

          },
          {

            "label": "乌达",
            "value": "150304",

          }
        ]
      },
      {

        "label": "赤峰",
        "value": "150400",
        "children": [
          {

            "label": "红山",
            "value": "150402",

          },
          {

            "label": "元宝山",
            "value": "150403",

          },
          {

            "label": "松山",
            "value": "150404",

          },
          {

            "label": "阿鲁科尔沁旗",
            "value": "150421",

          },
          {

            "label": "巴林左旗",
            "value": "150422",

          },
          {

            "label": "巴林右旗",
            "value": "150423",

          },
          {

            "label": "林西",
            "value": "150424",

          },
          {

            "label": "克什克腾旗",
            "value": "150425",

          },
          {

            "label": "翁牛特旗",
            "value": "150426",

          },
          {

            "label": "喀喇沁旗",
            "value": "150428",

          },
          {

            "label": "宁城",
            "value": "150429",

          },
          {

            "label": "敖汉旗",
            "value": "150430",

          }
        ]
      },
      {

        "label": "通辽",
        "value": "150500",
        "children": [
          {

            "label": "科尔沁",
            "value": "150502",

          },
          {

            "label": "科尔沁左翼中旗",
            "value": "150521",

          },
          {

            "label": "科尔沁左翼后旗",
            "value": "150522",

          },
          {

            "label": "开鲁",
            "value": "150523",

          },
          {

            "label": "库伦旗",
            "value": "150524",

          },
          {

            "label": "奈曼旗",
            "value": "150525",

          },
          {

            "label": "扎鲁特旗",
            "value": "150526",

          },
          {

            "label": "霍林郭勒",
            "value": "150581",

          }
        ]
      },
      {

        "label": "鄂尔多斯",
        "value": "150600",
        "children": [
          {

            "label": "东胜",
            "value": "150602",

          },
          {

            "label": "达拉特旗",
            "value": "150621",

          },
          {

            "label": "准格尔旗",
            "value": "150622",

          },
          {

            "label": "鄂托克前旗",
            "value": "150623",

          },
          {

            "label": "鄂托克旗",
            "value": "150624",

          },
          {

            "label": "杭锦旗",
            "value": "150625",

          },
          {

            "label": "乌审旗",
            "value": "150626",

          },
          {

            "label": "伊金霍洛旗",
            "value": "150627",

          }
        ]
      },
      {

        "label": "呼伦贝尔",
        "value": "150700",
        "children": [
          {

            "label": "海拉尔",
            "value": "150702",

          },
          {

            "label": "扎赉诺尔",
            "value": "150703",

          },
          {

            "label": "阿荣旗",
            "value": "150721",

          },
          {

            "label": "莫旗",
            "value": "150722",

          },
          {

            "label": "鄂伦春",
            "value": "150723",

          },
          {

            "label": "鄂温",
            "value": "150724",

          },
          {

            "label": "陈巴尔虎旗",
            "value": "150725",

          },
          {

            "label": "新巴尔虎左旗",
            "value": "150726",

          },
          {

            "label": "新巴尔虎右旗",
            "value": "150727",

          },
          {

            "label": "满洲里",
            "value": "150781",

          },
          {

            "label": "牙克石",
            "value": "150782",

          },
          {

            "label": "扎兰屯",
            "value": "150783",

          },
          {

            "label": "额尔古纳",
            "value": "150784",

          },
          {

            "label": "根河",
            "value": "150785",

          }
        ]
      },
      {

        "label": "巴彦淖尔",
        "value": "150800",
        "children": [
          {

            "label": "临河",
            "value": "150802",

          },
          {

            "label": "五原",
            "value": "150821",

          },
          {

            "label": "磴口",
            "value": "150822",

          },
          {

            "label": "乌拉特前旗",
            "value": "150823",

          },
          {

            "label": "乌拉特中旗",
            "value": "150824",

          },
          {

            "label": "乌拉特后旗",
            "value": "150825",

          },
          {

            "label": "杭锦后旗",
            "value": "150826",

          }
        ]
      },
      {

        "label": "乌兰察布",
        "value": "150900",
        "children": [
          {

            "label": "集宁",
            "value": "150902",

          },
          {

            "label": "卓资",
            "value": "150921",

          },
          {

            "label": "化德",
            "value": "150922",

          },
          {

            "label": "商都",
            "value": "150923",

          },
          {

            "label": "兴和",
            "value": "150924",

          },
          {

            "label": "凉城",
            "value": "150925",

          },
          {

            "label": "察右前旗",
            "value": "150926",

          },
          {

            "label": "察右中旗",
            "value": "150927",

          },
          {

            "label": "察右后旗",
            "value": "150928",

          },
          {

            "label": "四子王旗",
            "value": "150929",

          },
          {

            "label": "丰镇",
            "value": "150981",

          }
        ]
      },
      {

        "label": "兴安盟",
        "value": "152200",
        "children": [
          {

            "label": "乌兰浩特",
            "value": "152201",

          },
          {

            "label": "阿尔山",
            "value": "152202",

          },
          {

            "label": "科右前旗",
            "value": "152221",

          },
          {

            "label": "科右中旗",
            "value": "152222",

          },
          {

            "label": "扎赉特旗",
            "value": "152223",

          },
          {

            "label": "突泉",
            "value": "152224",

          }
        ]
      },
      {

        "label": "锡林郭勒盟",
        "value": "152500",
        "children": [
          {

            "label": "二连浩特",
            "value": "152501",

          },
          {

            "label": "锡林浩特",
            "value": "152502",

          },
          {

            "label": "阿巴嘎旗",
            "value": "152522",

          },
          {

            "label": "苏尼特左旗",
            "value": "152523",

          },
          {

            "label": "苏尼特右旗",
            "value": "152524",

          },
          {

            "label": "东乌旗",
            "value": "152525",

          },
          {

            "label": "西乌旗",
            "value": "152526",

          },
          {

            "label": "太仆寺旗",
            "value": "152527",

          },
          {

            "label": "镶黄旗",
            "value": "152528",

          },
          {

            "label": "正镶白旗",
            "value": "152529",

          },
          {

            "label": "正蓝旗",
            "value": "152530",

          },
          {

            "label": "多伦",
            "value": "152531",

          }
        ]
      },
      {

        "label": "阿拉善盟",
        "value": "152900",
        "children": [
          {

            "label": "阿拉善左旗",
            "value": "152921",

          },
          {

            "label": "阿拉善右旗",
            "value": "152922",

          },
          {

            "label": "额济纳旗",
            "value": "152923",

          }
        ]
      }
    ]
  },
  {

    "label": "辽宁",
    "value": "210000",
    "children": [
      {

        "label": "沈阳",
        "value": "210100",
        "children": [
          {

            "label": "和平",
            "value": "210102",

          },
          {

            "label": "沈河",
            "value": "210103",

          },
          {

            "label": "大东",
            "value": "210104",

          },
          {

            "label": "皇姑",
            "value": "210105",

          },
          {

            "label": "铁西",
            "value": "210106",

          },
          {

            "label": "苏家屯",
            "value": "210111",

          },
          {

            "label": "浑南",
            "value": "210112",

          },
          {

            "label": "沈北新区",
            "value": "210113",

          },
          {

            "label": "于洪",
            "value": "210114",

          },
          {

            "label": "辽中",
            "value": "210122",

          },
          {

            "label": "康平",
            "value": "210123",

          },
          {

            "label": "法库",
            "value": "210124",

          },
          {

            "label": "新民",
            "value": "210181",

          }
        ]
      },
      {

        "label": "大连",
        "value": "210200",
        "children": [
          {

            "label": "中山",
            "value": "210202",

          },
          {

            "label": "西岗",
            "value": "210203",

          },
          {

            "label": "沙河口",
            "value": "210204",

          },
          {

            "label": "甘井子",
            "value": "210211",

          },
          {

            "label": "旅顺口",
            "value": "210212",

          },
          {

            "label": "金州",
            "value": "210213",

          },
          {

            "label": "长海",
            "value": "210224",

          },
          {

            "label": "瓦房店",
            "value": "210281",

          },
          {

            "label": "普兰店",
            "value": "210282",

          },
          {

            "label": "庄河",
            "value": "210283",

          }
        ]
      },
      {

        "label": "鞍山",
        "value": "210300",
        "children": [
          {

            "label": "铁东",
            "value": "210302",

          },
          {

            "label": "铁西",
            "value": "210303",

          },
          {

            "label": "立山",
            "value": "210304",

          },
          {

            "label": "千山",
            "value": "210311",

          },
          {

            "label": "台安",
            "value": "210321",

          },
          {

            "label": "岫岩",
            "value": "210323",

          },
          {

            "label": "海城",
            "value": "210381",

          }
        ]
      },
      {

        "label": "抚顺",
        "value": "210400",
        "children": [
          {

            "label": "新抚",
            "value": "210402",

          },
          {

            "label": "东洲",
            "value": "210403",

          },
          {

            "label": "望花",
            "value": "210404",

          },
          {

            "label": "顺城",
            "value": "210411",

          },
          {

            "label": "抚顺",
            "value": "210421",

          },
          {

            "label": "新宾",
            "value": "210422",

          },
          {

            "label": "清原",
            "value": "210423",

          }
        ]
      },
      {

        "label": "本溪",
        "value": "210500",
        "children": [
          {

            "label": "平山",
            "value": "210502",

          },
          {

            "label": "溪湖",
            "value": "210503",

          },
          {

            "label": "明山",
            "value": "210504",

          },
          {

            "label": "南芬",
            "value": "210505",

          },
          {

            "label": "本溪",
            "value": "210521",

          },
          {

            "label": "桓仁",
            "value": "210522",

          }
        ]
      },
      {

        "label": "丹东",
        "value": "210600",
        "children": [
          {

            "label": "元宝",
            "value": "210602",

          },
          {

            "label": "振兴",
            "value": "210603",

          },
          {

            "label": "振安",
            "value": "210604",

          },
          {

            "label": "宽甸",
            "value": "210624",

          },
          {

            "label": "东港",
            "value": "210681",

          },
          {

            "label": "凤城",
            "value": "210682",

          }
        ]
      },
      {

        "label": "锦州",
        "value": "210700",
        "children": [
          {

            "label": "古塔",
            "value": "210702",

          },
          {

            "label": "凌河",
            "value": "210703",

          },
          {

            "label": "太和",
            "value": "210711",

          },
          {

            "label": "黑山",
            "value": "210726",

          },
          {

            "label": "义县",
            "value": "210727",

          },
          {

            "label": "凌海",
            "value": "210781",

          },
          {

            "label": "北镇",
            "value": "210782",

          }
        ]
      },
      {

        "label": "营口",
        "value": "210800",
        "children": [
          {

            "label": "站前",
            "value": "210802",

          },
          {

            "label": "西市",
            "value": "210803",

          },
          {

            "label": "鲅鱼圈",
            "value": "210804",

          },
          {

            "label": "老边",
            "value": "210811",

          },
          {

            "label": "盖州",
            "value": "210881",

          },
          {

            "label": "大石桥",
            "value": "210882",

          }
        ]
      },
      {

        "label": "阜新",
        "value": "210900",
        "children": [
          {

            "label": "海州",
            "value": "210902",

          },
          {

            "label": "新邱",
            "value": "210903",

          },
          {

            "label": "太平",
            "value": "210904",

          },
          {

            "label": "清河门",
            "value": "210905",

          },
          {

            "label": "细河",
            "value": "210911",

          },
          {

            "label": "阜新",
            "value": "210921",

          },
          {

            "label": "彰武",
            "value": "210922",

          }
        ]
      },
      {

        "label": "辽阳",
        "value": "211000",
        "children": [
          {

            "label": "白塔",
            "value": "211002",

          },
          {

            "label": "文圣",
            "value": "211003",

          },
          {

            "label": "宏伟",
            "value": "211004",

          },
          {

            "label": "弓长岭",
            "value": "211005",

          },
          {

            "label": "太子河",
            "value": "211011",

          },
          {

            "label": "辽阳",
            "value": "211021",

          },
          {

            "label": "灯塔",
            "value": "211081",

          }
        ]
      },
      {

        "label": "盘锦",
        "value": "211100",
        "children": [
          {

            "label": "双台子",
            "value": "211102",

          },
          {

            "label": "兴隆台",
            "value": "211103",

          },
          {

            "label": "大洼",
            "value": "211121",

          },
          {

            "label": "盘山",
            "value": "211122",

          }
        ]
      },
      {

        "label": "铁岭",
        "value": "211200",
        "children": [
          {

            "label": "银州",
            "value": "211202",

          },
          {

            "label": "清河",
            "value": "211204",

          },
          {

            "label": "铁岭",
            "value": "211221",

          },
          {

            "label": "西丰",
            "value": "211223",

          },
          {

            "label": "昌图",
            "value": "211224",

          },
          {

            "label": "调兵山",
            "value": "211281",

          },
          {

            "label": "开原",
            "value": "211282",

          }
        ]
      },
      {

        "label": "朝阳",
        "value": "211300",
        "children": [
          {

            "label": "双塔",
            "value": "211302",

          },
          {

            "label": "龙城",
            "value": "211303",

          },
          {

            "label": "朝阳",
            "value": "211321",

          },
          {

            "label": "建平",
            "value": "211322",

          },
          {

            "label": "喀喇沁左翼",
            "value": "211324",

          },
          {

            "label": "北票",
            "value": "211381",

          },
          {

            "label": "凌源",
            "value": "211382",

          }
        ]
      },
      {

        "label": "葫芦岛",
        "value": "211400",
        "children": [
          {

            "label": "连山",
            "value": "211402",

          },
          {

            "label": "龙港",
            "value": "211403",

          },
          {

            "label": "南票",
            "value": "211404",

          },
          {

            "label": "绥中",
            "value": "211421",

          },
          {

            "label": "建昌",
            "value": "211422",

          },
          {

            "label": "兴城",
            "value": "211481",

          }
        ]
      },
      {

        "label": "金普新区",
        "value": "211500",
        "children": [
          {

            "label": "金州新区",
            "value": "211501",

          },
          {

            "label": "普湾新区",
            "value": "211502",

          },
          {

            "label": "保税区",
            "value": "211503",

          }
        ]
      }
    ]
  },
  {

    "label": "吉林",
    "value": "220000",
    "children": [
      {

        "label": "长春",
        "value": "220100",
        "children": [
          {

            "label": "南关",
            "value": "220102",

          },
          {

            "label": "宽城",
            "value": "220103",

          },
          {

            "label": "朝阳",
            "value": "220104",

          },
          {

            "label": "二道",
            "value": "220105",

          },
          {

            "label": "绿园",
            "value": "220106",

          },
          {

            "label": "双阳",
            "value": "220112",

          },
          {

            "label": "九台",
            "value": "220113",

          },
          {

            "label": "农安",
            "value": "220122",

          },
          {

            "label": "榆树",
            "value": "220182",

          },
          {

            "label": "德惠",
            "value": "220183",

          }
        ]
      },
      {

        "label": "吉林",
        "value": "220200",
        "children": [
          {

            "label": "昌邑",
            "value": "220202",

          },
          {

            "label": "龙潭",
            "value": "220203",

          },
          {

            "label": "船营",
            "value": "220204",

          },
          {

            "label": "丰满",
            "value": "220211",

          },
          {

            "label": "永吉",
            "value": "220221",

          },
          {

            "label": "蛟河",
            "value": "220281",

          },
          {

            "label": "桦甸",
            "value": "220282",

          },
          {

            "label": "舒兰",
            "value": "220283",

          },
          {

            "label": "磐石",
            "value": "220284",

          }
        ]
      },
      {

        "label": "四平",
        "value": "220300",
        "children": [
          {

            "label": "铁西",
            "value": "220302",

          },
          {

            "label": "铁东",
            "value": "220303",

          },
          {

            "label": "梨树",
            "value": "220322",

          },
          {

            "label": "伊通",
            "value": "220323",

          },
          {

            "label": "公主岭",
            "value": "220381",

          },
          {

            "label": "双辽",
            "value": "220382",

          }
        ]
      },
      {

        "label": "辽源",
        "value": "220400",
        "children": [
          {

            "label": "龙山",
            "value": "220402",

          },
          {

            "label": "西安",
            "value": "220403",

          },
          {

            "label": "东丰",
            "value": "220421",

          },
          {

            "label": "东辽",
            "value": "220422",

          }
        ]
      },
      {

        "label": "通化",
        "value": "220500",
        "children": [
          {

            "label": "东昌",
            "value": "220502",

          },
          {

            "label": "二道江",
            "value": "220503",

          },
          {

            "label": "通化",
            "value": "220521",

          },
          {

            "label": "辉南",
            "value": "220523",

          },
          {

            "label": "柳河",
            "value": "220524",

          },
          {

            "label": "梅河口",
            "value": "220581",

          },
          {

            "label": "集安",
            "value": "220582",

          }
        ]
      },
      {

        "label": "白山",
        "value": "220600",
        "children": [
          {

            "label": "浑江",
            "value": "220602",

          },
          {

            "label": "江源",
            "value": "220605",

          },
          {

            "label": "抚松",
            "value": "220621",

          },
          {

            "label": "靖宇",
            "value": "220622",

          },
          {

            "label": "长白",
            "value": "220623",

          },
          {

            "label": "临江",
            "value": "220681",

          }
        ]
      },
      {

        "label": "松原",
        "value": "220700",
        "children": [
          {

            "label": "宁江",
            "value": "220702",

          },
          {

            "label": "前郭尔罗斯",
            "value": "220721",

          },
          {

            "label": "长岭",
            "value": "220722",

          },
          {

            "label": "乾安",
            "value": "220723",

          },
          {

            "label": "扶余",
            "value": "220781",

          }
        ]
      },
      {

        "label": "白城",
        "value": "220800",
        "children": [
          {

            "label": "洮北",
            "value": "220802",

          },
          {

            "label": "镇赉",
            "value": "220821",

          },
          {

            "label": "通榆",
            "value": "220822",

          },
          {

            "label": "洮南",
            "value": "220881",

          },
          {

            "label": "大安",
            "value": "220882",

          }
        ]
      },
      {

        "label": "延边",
        "value": "222400",
        "children": [
          {

            "label": "延吉",
            "value": "222401",

          },
          {

            "label": "图们",
            "value": "222402",

          },
          {

            "label": "敦化",
            "value": "222403",

          },
          {

            "label": "珲春",
            "value": "222404",

          },
          {

            "label": "龙井",
            "value": "222405",

          },
          {

            "label": "和龙",
            "value": "222406",

          },
          {

            "label": "汪清",
            "value": "222424",

          },
          {

            "label": "安图",
            "value": "222426",

          }
        ]
      }
    ]
  },
  {

    "label": "黑龙江",
    "value": "230000",
    "children": [
      {

        "label": "哈尔滨",
        "value": "230100",
        "children": [
          {

            "label": "道里",
            "value": "230102",

          },
          {

            "label": "南岗",
            "value": "230103",

          },
          {

            "label": "道外",
            "value": "230104",

          },
          {

            "label": "平房",
            "value": "230108",

          },
          {

            "label": "松北",
            "value": "230109",

          },
          {

            "label": "香坊",
            "value": "230110",

          },
          {

            "label": "呼兰",
            "value": "230111",

          },
          {

            "label": "阿城",
            "value": "230112",

          },
          {

            "label": "双城",
            "value": "230113",

          },
          {

            "label": "依兰",
            "value": "230123",

          },
          {

            "label": "方正",
            "value": "230124",

          },
          {

            "label": "宾县",
            "value": "230125",

          },
          {

            "label": "巴彦",
            "value": "230126",

          },
          {

            "label": "木兰",
            "value": "230127",

          },
          {

            "label": "通河",
            "value": "230128",

          },
          {

            "label": "延寿",
            "value": "230129",

          },
          {

            "label": "尚志",
            "value": "230183",

          },
          {

            "label": "五常",
            "value": "230184",

          }
        ]
      },
      {

        "label": "齐齐哈尔",
        "value": "230200",
        "children": [
          {

            "label": "龙沙",
            "value": "230202",

          },
          {

            "label": "建华",
            "value": "230203",

          },
          {

            "label": "铁锋",
            "value": "230204",

          },
          {

            "label": "昂昂溪",
            "value": "230205",

          },
          {

            "label": "富拉尔基",
            "value": "230206",

          },
          {

            "label": "碾子山",
            "value": "230207",

          },
          {

            "label": "梅里斯",
            "value": "230208",

          },
          {

            "label": "龙江",
            "value": "230221",

          },
          {

            "label": "依安",
            "value": "230223",

          },
          {

            "label": "泰来",
            "value": "230224",

          },
          {

            "label": "甘南",
            "value": "230225",

          },
          {

            "label": "富裕",
            "value": "230227",

          },
          {

            "label": "克山",
            "value": "230229",

          },
          {

            "label": "克东",
            "value": "230230",

          },
          {

            "label": "拜泉",
            "value": "230231",

          },
          {

            "label": "讷河",
            "value": "230281",

          }
        ]
      },
      {

        "label": "鸡西",
        "value": "230300",
        "children": [
          {

            "label": "鸡冠",
            "value": "230302",

          },
          {

            "label": "恒山",
            "value": "230303",

          },
          {

            "label": "滴道",
            "value": "230304",

          },
          {

            "label": "梨树",
            "value": "230305",

          },
          {

            "label": "城子河",
            "value": "230306",

          },
          {

            "label": "麻山",
            "value": "230307",

          },
          {

            "label": "鸡东",
            "value": "230321",

          },
          {

            "label": "虎林",
            "value": "230381",

          },
          {

            "label": "密山",
            "value": "230382",

          }
        ]
      },
      {

        "label": "鹤岗",
        "value": "230400",
        "children": [
          {

            "label": "向阳",
            "value": "230402",

          },
          {

            "label": "工农",
            "value": "230403",

          },
          {

            "label": "南山",
            "value": "230404",

          },
          {

            "label": "兴安",
            "value": "230405",

          },
          {

            "label": "东山",
            "value": "230406",

          },
          {

            "label": "兴山",
            "value": "230407",

          },
          {

            "label": "萝北",
            "value": "230421",

          },
          {

            "label": "绥滨",
            "value": "230422",

          }
        ]
      },
      {

        "label": "双鸭山",
        "value": "230500",
        "children": [
          {

            "label": "尖山",
            "value": "230502",

          },
          {

            "label": "岭东",
            "value": "230503",

          },
          {

            "label": "四方台",
            "value": "230505",

          },
          {

            "label": "宝山",
            "value": "230506",

          },
          {

            "label": "集贤",
            "value": "230521",

          },
          {

            "label": "友谊",
            "value": "230522",

          },
          {

            "label": "宝清",
            "value": "230523",

          },
          {

            "label": "饶河",
            "value": "230524",

          }
        ]
      },
      {

        "label": "大庆",
        "value": "230600",
        "children": [
          {

            "label": "萨尔图",
            "value": "230602",

          },
          {

            "label": "龙凤",
            "value": "230603",

          },
          {

            "label": "让胡路",
            "value": "230604",

          },
          {

            "label": "红岗",
            "value": "230605",

          },
          {

            "label": "大同",
            "value": "230606",

          },
          {

            "label": "肇州",
            "value": "230621",

          },
          {

            "label": "肇源",
            "value": "230622",

          },
          {

            "label": "林甸",
            "value": "230623",

          },
          {

            "label": "杜尔伯特",
            "value": "230624",

          }
        ]
      },
      {

        "label": "伊春",
        "value": "230700",
        "children": [
          {

            "label": "伊春",
            "value": "230702",

          },
          {

            "label": "南岔",
            "value": "230703",

          },
          {

            "label": "友好",
            "value": "230704",

          },
          {

            "label": "西林",
            "value": "230705",

          },
          {

            "label": "翠峦",
            "value": "230706",

          },
          {

            "label": "新青",
            "value": "230707",

          },
          {

            "label": "美溪",
            "value": "230708",

          },
          {

            "label": "金山屯",
            "value": "230709",

          },
          {

            "label": "五营",
            "value": "230710",

          },
          {

            "label": "乌马河",
            "value": "230711",

          },
          {

            "label": "汤旺河",
            "value": "230712",

          },
          {

            "label": "带岭",
            "value": "230713",

          },
          {

            "label": "乌伊岭",
            "value": "230714",

          },
          {

            "label": "红星",
            "value": "230715",

          },
          {

            "label": "上甘岭",
            "value": "230716",

          },
          {

            "label": "嘉荫",
            "value": "230722",

          },
          {

            "label": "铁力",
            "value": "230781",

          }
        ]
      },
      {

        "label": "佳木斯",
        "value": "230800",
        "children": [
          {

            "label": "向阳",
            "value": "230803",

          },
          {

            "label": "前进",
            "value": "230804",

          },
          {

            "label": "东风",
            "value": "230805",

          },
          {

            "label": "郊区",
            "value": "230811",

          },
          {

            "label": "桦南",
            "value": "230822",

          },
          {

            "label": "桦川",
            "value": "230826",

          },
          {

            "label": "汤原",
            "value": "230828",

          },
          {

            "label": "抚远",
            "value": "230833",

          },
          {

            "label": "同江",
            "value": "230881",

          },
          {

            "label": "富锦",
            "value": "230882",

          }
        ]
      },
      {

        "label": "七台河",
        "value": "230900",
        "children": [
          {

            "label": "新兴",
            "value": "230902",

          },
          {

            "label": "桃山",
            "value": "230903",

          },
          {

            "label": "茄子河",
            "value": "230904",

          },
          {

            "label": "勃利",
            "value": "230921",

          }
        ]
      },
      {

        "label": "牡丹江",
        "value": "231000",
        "children": [
          {

            "label": "东安",
            "value": "231002",

          },
          {

            "label": "阳明",
            "value": "231003",

          },
          {

            "label": "爱民",
            "value": "231004",

          },
          {

            "label": "西安",
            "value": "231005",

          },
          {

            "label": "东宁",
            "value": "231024",

          },
          {

            "label": "林口",
            "value": "231025",

          },
          {

            "label": "绥芬河",
            "value": "231081",

          },
          {

            "label": "海林",
            "value": "231083",

          },
          {

            "label": "宁安",
            "value": "231084",

          },
          {

            "label": "穆棱",
            "value": "231085",

          }
        ]
      },
      {

        "label": "黑河",
        "value": "231100",
        "children": [
          {

            "label": "爱辉",
            "value": "231102",

          },
          {

            "label": "嫩江",
            "value": "231121",

          },
          {

            "label": "逊克",
            "value": "231123",

          },
          {

            "label": "孙吴",
            "value": "231124",

          },
          {

            "label": "北安",
            "value": "231181",

          },
          {

            "label": "五大连池",
            "value": "231182",

          }
        ]
      },
      {

        "label": "绥化",
        "value": "231200",
        "children": [
          {

            "label": "北林",
            "value": "231202",

          },
          {

            "label": "望奎",
            "value": "231221",

          },
          {

            "label": "兰西",
            "value": "231222",

          },
          {

            "label": "青冈",
            "value": "231223",

          },
          {

            "label": "庆安",
            "value": "231224",

          },
          {

            "label": "明水",
            "value": "231225",

          },
          {

            "label": "绥棱",
            "value": "231226",

          },
          {

            "label": "安达",
            "value": "231281",

          },
          {

            "label": "肇东",
            "value": "231282",

          },
          {

            "label": "海伦",
            "value": "231283",

          }
        ]
      },
      {

        "label": "大兴安岭",
        "value": "232700",
        "children": [
          {

            "label": "加格达奇",
            "value": "232701",

          },
          {

            "label": "新林",
            "value": "232702",

          },
          {

            "label": "松岭",
            "value": "232703",

          },
          {

            "label": "呼中",
            "value": "232704",

          },
          {

            "label": "呼玛",
            "value": "232721",

          },
          {

            "label": "塔河",
            "value": "232722",

          },
          {

            "label": "漠河",
            "value": "232723",

          }
        ]
      }
    ]
  },
  {

    "label": "上海",
    "value": "310000",
    "children": [
      {

        "label": "上海市",
        "value": "310100",
        "children": [
          {

            "label": "黄浦",
            "value": "310101",

          },
          {

            "label": "徐汇",
            "value": "310104",

          },
          {

            "label": "长宁",
            "value": "310105",

          },
          {

            "label": "静安",
            "value": "310106",

          },
          {

            "label": "普陀",
            "value": "310107",

          },
          {

            "label": "闸北",
            "value": "310108",

          },
          {

            "label": "虹口",
            "value": "310109",

          },
          {

            "label": "杨浦",
            "value": "310110",

          },
          {

            "label": "闵行",
            "value": "310112",

          },
          {

            "label": "宝山",
            "value": "310113",

          },
          {

            "label": "嘉定",
            "value": "310114",

          },
          {

            "label": "浦东",
            "value": "310115",

          },
          {

            "label": "金山",
            "value": "310116",

          },
          {

            "label": "松江",
            "value": "310117",

          },
          {

            "label": "青浦",
            "value": "310118",

          },
          {

            "label": "奉贤",
            "value": "310120",

          },
          {

            "label": "崇明",
            "value": "310230",

          }
        ]
      }
    ]
  },
  {

    "label": "江苏",
    "value": "320000",
    "children": [
      {

        "label": "南京",
        "value": "320100",
        "children": [
          {

            "label": "玄武",
            "value": "320102",

          },
          {

            "label": "秦淮",
            "value": "320104",

          },
          {

            "label": "建邺",
            "value": "320105",

          },
          {

            "label": "鼓楼",
            "value": "320106",

          },
          {

            "label": "浦口",
            "value": "320111",

          },
          {

            "label": "栖霞",
            "value": "320113",

          },
          {

            "label": "雨花台",
            "value": "320114",

          },
          {

            "label": "江宁",
            "value": "320115",

          },
          {

            "label": "六合",
            "value": "320116",

          },
          {

            "label": "溧水",
            "value": "320117",

          },
          {

            "label": "高淳",
            "value": "320118",

          }
        ]
      },
      {

        "label": "无锡",
        "value": "320200",
        "children": [
          {

            "label": "崇安",
            "value": "320202",

          },
          {

            "label": "南长",
            "value": "320203",

          },
          {

            "label": "北塘",
            "value": "320204",

          },
          {

            "label": "锡山",
            "value": "320205",

          },
          {

            "label": "惠山",
            "value": "320206",

          },
          {

            "label": "滨湖",
            "value": "320211",

          },
          {

            "label": "江阴",
            "value": "320281",

          },
          {

            "label": "宜兴",
            "value": "320282",

          }
        ]
      },
      {

        "label": "徐州",
        "value": "320300",
        "children": [
          {

            "label": "鼓楼",
            "value": "320302",

          },
          {

            "label": "云龙",
            "value": "320303",

          },
          {

            "label": "贾汪",
            "value": "320305",

          },
          {

            "label": "泉山",
            "value": "320311",

          },
          {

            "label": "铜山",
            "value": "320312",

          },
          {

            "label": "丰县",
            "value": "320321",

          },
          {

            "label": "沛县",
            "value": "320322",

          },
          {

            "label": "睢宁",
            "value": "320324",

          },
          {

            "label": "新沂",
            "value": "320381",

          },
          {

            "label": "邳州",
            "value": "320382",

          }
        ]
      },
      {

        "label": "常州",
        "value": "320400",
        "children": [
          {

            "label": "天宁",
            "value": "320402",

          },
          {

            "label": "钟楼",
            "value": "320404",

          },
          {

            "label": "戚墅堰",
            "value": "320405",

          },
          {

            "label": "新北",
            "value": "320411",

          },
          {

            "label": "武进",
            "value": "320412",

          },
          {

            "label": "溧阳",
            "value": "320481",

          },
          {

            "label": "金坛",
            "value": "320482",

          }
        ]
      },
      {

        "label": "苏州",
        "value": "320500",
        "children": [
          {

            "label": "虎丘",
            "value": "320505",

          },
          {

            "label": "吴中",
            "value": "320506",

          },
          {

            "label": "相城",
            "value": "320507",

          },
          {

            "label": "姑苏",
            "value": "320508",

          },
          {

            "label": "吴江",
            "value": "320509",

          },
          {

            "label": "常熟",
            "value": "320581",

          },
          {

            "label": "张家港",
            "value": "320582",

          },
          {

            "label": "昆山",
            "value": "320583",

          },
          {

            "label": "太仓",
            "value": "320585",

          }
        ]
      },
      {

        "label": "南通",
        "value": "320600",
        "children": [
          {

            "label": "崇川",
            "value": "320602",

          },
          {

            "label": "港闸",
            "value": "320611",

          },
          {

            "label": "通州",
            "value": "320612",

          },
          {

            "label": "海安",
            "value": "320621",

          },
          {

            "label": "如东",
            "value": "320623",

          },
          {

            "label": "启东",
            "value": "320681",

          },
          {

            "label": "如皋",
            "value": "320682",

          },
          {

            "label": "海门",
            "value": "320684",

          }
        ]
      },
      {

        "label": "连云港",
        "value": "320700",
        "children": [
          {

            "label": "连云",
            "value": "320703",

          },
          {

            "label": "海州",
            "value": "320706",

          },
          {

            "label": "赣榆",
            "value": "320707",

          },
          {

            "label": "东海",
            "value": "320722",

          },
          {

            "label": "灌云",
            "value": "320723",

          },
          {

            "label": "灌南",
            "value": "320724",

          }
        ]
      },
      {

        "label": "淮安",
        "value": "320800",
        "children": [
          {

            "label": "清河",
            "value": "320802",

          },
          {

            "label": "淮安",
            "value": "320803",

          },
          {

            "label": "淮阴",
            "value": "320804",

          },
          {

            "label": "清浦",
            "value": "320811",

          },
          {

            "label": "涟水",
            "value": "320826",

          },
          {

            "label": "洪泽",
            "value": "320829",

          },
          {

            "label": "盱眙",
            "value": "320830",

          },
          {

            "label": "金湖",
            "value": "320831",

          }
        ]
      },
      {

        "label": "盐城",
        "value": "320900",
        "children": [
          {

            "label": "亭湖",
            "value": "320902",

          },
          {

            "label": "盐都",
            "value": "320903",

          },
          {

            "label": "响水",
            "value": "320921",

          },
          {

            "label": "滨海",
            "value": "320922",

          },
          {

            "label": "阜宁",
            "value": "320923",

          },
          {

            "label": "射阳",
            "value": "320924",

          },
          {

            "label": "建湖",
            "value": "320925",

          },
          {

            "label": "东台",
            "value": "320981",

          },
          {

            "label": "大丰",
            "value": "320982",

          }
        ]
      },
      {

        "label": "扬州",
        "value": "321000",
        "children": [
          {

            "label": "广陵",
            "value": "321002",

          },
          {

            "label": "邗江",
            "value": "321003",

          },
          {

            "label": "江都",
            "value": "321012",

          },
          {

            "label": "宝应",
            "value": "321023",

          },
          {

            "label": "仪征",
            "value": "321081",

          },
          {

            "label": "高邮",
            "value": "321084",

          }
        ]
      },
      {

        "label": "镇江",
        "value": "321100",
        "children": [
          {

            "label": "京口",
            "value": "321102",

          },
          {

            "label": "润州",
            "value": "321111",

          },
          {

            "label": "丹徒",
            "value": "321112",

          },
          {

            "label": "丹阳",
            "value": "321181",

          },
          {

            "label": "扬中",
            "value": "321182",

          },
          {

            "label": "句容",
            "value": "321183",

          }
        ]
      },
      {

        "label": "泰州",
        "value": "321200",
        "children": [
          {

            "label": "海陵",
            "value": "321202",

          },
          {

            "label": "高港",
            "value": "321203",

          },
          {

            "label": "姜堰",
            "value": "321204",

          },
          {

            "label": "兴化",
            "value": "321281",

          },
          {

            "label": "靖江",
            "value": "321282",

          },
          {

            "label": "泰兴",
            "value": "321283",

          }
        ]
      },
      {

        "label": "宿迁",
        "value": "321300",
        "children": [
          {

            "label": "宿城",
            "value": "321302",

          },
          {

            "label": "宿豫",
            "value": "321311",

          },
          {

            "label": "沭阳",
            "value": "321322",

          },
          {

            "label": "泗阳",
            "value": "321323",

          },
          {

            "label": "泗洪",
            "value": "321324",

          }
        ]
      }
    ]
  },
  {

    "label": "浙江",
    "value": "330000",
    "children": [
      {

        "label": "杭州",
        "value": "330100",
        "children": [
          {

            "label": "钱塘新区",
            "value": "330102",

          },
          {

            "label": "萧山",
            "value": "330109",

          },
          {

            "label": "余杭",
            "value": "330110",

          },
          {

            "label": "桐庐",
            "value": "330122",

          },
          {

            "label": "淳安",
            "value": "330127",

          },
          {

            "label": "建德",
            "value": "330182",

          },
          {

            "label": "富阳",
            "value": "330183",

          },
          {

            "label": "临安",
            "value": "330185",

          }
        ]
      },
      {

        "label": "宁波",
        "value": "330200",
        "children": [
          {

            "label": "海曙",
            "value": "330203",

          },
          {

            "label": "杭州湾",
            "value": "330204",

          },
          {

            "label": "江北",
            "value": "330205",

          },
          {

            "label": "北仑",
            "value": "330206",

          },
          {

            "label": "镇海",
            "value": "330211",

          },
          {

            "label": "鄞州",
            "value": "330212",

          },
          {

            "label": "象山",
            "value": "330225",

          },
          {

            "label": "宁海",
            "value": "330226",

          },
          {

            "label": "余姚",
            "value": "330281",

          },
          {

            "label": "慈溪",
            "value": "330282",

          },
          {

            "label": "奉化",
            "value": "330283",

          }
        ]
      },
      {

        "label": "温州",
        "value": "330300",
        "children": [
          {

            "label": "鹿城",
            "value": "330302",

          },
          {

            "label": "龙湾",
            "value": "330303",

          },
          {

            "label": "瓯海",
            "value": "330304",

          },
          {

            "label": "洞头",
            "value": "330322",

          },
          {

            "label": "永嘉",
            "value": "330324",

          },
          {

            "label": "平阳",
            "value": "330326",

          },
          {

            "label": "苍南",
            "value": "330327",

          },
          {

            "label": "文成",
            "value": "330328",

          },
          {

            "label": "泰顺",
            "value": "330329",

          },
          {

            "label": "瑞安",
            "value": "330381",

          },
          {

            "label": "乐清",
            "value": "330382",

          }
        ]
      },
      {

        "label": "嘉兴",
        "value": "330400",
        "children": [
          {

            "label": "直属局",
            "value": "330411",

          },
          {

            "label": "海盐",
            "value": "330424",

          },
          {

            "label": "海宁",
            "value": "330481",

          },
          {

            "label": "平湖",
            "value": "330482",

          },
          {

            "label": "桐乡",
            "value": "330483",

          },
          {

            "label": "南湖",
            "value": "330484",

          },
          {

            "label": "秀洲",
            "value": "330485",

          }
        ]
      },
      {

        "label": "湖州",
        "value": "330500",
        "children": [
          {

            "label": "直属局",
            "value": "330503",

          },
          {

            "label": "德清",
            "value": "330521",

          },
          {

            "label": "长兴",
            "value": "330522",

          },
          {

            "label": "安吉",
            "value": "330523",

          },
          {

            "label": "吴兴",
            "value": "330524",

          }
        ]
      },
      {

        "label": "绍兴",
        "value": "330600",
        "children": [
          {

            "label": "运管所",
            "value": "330502",

          },
          {

            "label": "袍江",
            "value": "330602",

          },
          {

            "label": "柯桥",
            "value": "330603",

          },
          {

            "label": "上虞",
            "value": "330604",

          },
          {

            "label": "越城",
            "value": "330605",

          },
          {

            "label": "新昌",
            "value": "330624",

          },
          {

            "label": "诸暨",
            "value": "330681",

          },
          {

            "label": "嵊州",
            "value": "330683",

          }
        ]
      },
      {

        "label": "金华",
        "value": "330700",
        "children": [
          {

            "label": "婺城",
            "value": "330702",

          },
          {

            "label": "金东",
            "value": "330703",

          },
          {

            "label": "武义",
            "value": "330723",

          },
          {

            "label": "浦江",
            "value": "330726",

          },
          {

            "label": "磐安",
            "value": "330727",

          },
          {

            "label": "兰溪",
            "value": "330781",

          },
          {

            "label": "义乌",
            "value": "330782",

          },
          {

            "label": "东阳",
            "value": "330783",

          },
          {

            "label": "永康",
            "value": "330784",

          }
        ]
      },
      {

        "label": "衢州",
        "value": "330800",
        "children": [
          {

            "label": "柯城",
            "value": "330802",

          },
          {

            "label": "衢江",
            "value": "330803",

          },
          {

            "label": "常山",
            "value": "330822",

          },
          {

            "label": "开化",
            "value": "330824",

          },
          {

            "label": "龙游",
            "value": "330825",

          },
          {

            "label": "江山",
            "value": "330881",

          }
        ]
      },
      {

        "label": "舟山",
        "value": "330900",
        "children": [
          {

            "label": "定海",
            "value": "330902",

          },
          {

            "label": "普陀",
            "value": "330903",

          },
          {

            "label": "岱山",
            "value": "330921",

          },
          {

            "label": "嵊泗",
            "value": "330922",

          }
        ]
      },
      {

        "label": "台州",
        "value": "331000",
        "children": [
          {

            "label": "市本级",
            "value": "330103",

          },
          {

            "label": "椒江",
            "value": "331002",

          },
          {

            "label": "黄岩",
            "value": "331003",

          },
          {

            "label": "路桥",
            "value": "331004",

          },
          {

            "label": "玉环",
            "value": "331021",

          },
          {

            "label": "三门",
            "value": "331022",

          },
          {

            "label": "天台",
            "value": "331023",

          },
          {

            "label": "仙居",
            "value": "331024",

          },
          {

            "label": "温岭",
            "value": "331081",

          },
          {

            "label": "临海",
            "value": "331082",

          }
        ]
      },
      {

        "label": "丽水",
        "value": "331100",
        "children": [
          {

            "label": "直属局",
            "value": "330104",

          },
          {

            "label": "莲都",
            "value": "331102",

          },
          {

            "label": "青田",
            "value": "331121",

          },
          {

            "label": "缙云",
            "value": "331122",

          },
          {

            "label": "遂昌",
            "value": "331123",

          },
          {

            "label": "松阳",
            "value": "331124",

          },
          {

            "label": "云和",
            "value": "331125",

          },
          {

            "label": "庆元",
            "value": "331126",

          },
          {

            "label": "景宁",
            "value": "331127",

          },
          {

            "label": "龙泉",
            "value": "331181",

          }
        ]
      },
      {

        "label": "舟山新区",
        "value": "331200",

      }
    ]
  },
  {

    "label": "安徽",
    "value": "340000",
    "children": [
      {

        "label": "合肥",
        "value": "340100",
        "children": [
          {

            "label": "瑶海",
            "value": "340102",

          },
          {

            "label": "庐阳",
            "value": "340103",

          },
          {

            "label": "蜀山",
            "value": "340104",

          },
          {

            "label": "包河",
            "value": "340111",

          },
          {

            "label": "长丰",
            "value": "340121",

          },
          {

            "label": "肥东",
            "value": "340122",

          },
          {

            "label": "肥西",
            "value": "340123",

          },
          {

            "label": "庐江",
            "value": "340124",

          },
          {

            "label": "巢湖",
            "value": "340181",

          }
        ]
      },
      {

        "label": "芜湖",
        "value": "340200",
        "children": [
          {

            "label": "镜湖",
            "value": "340202",

          },
          {

            "label": "弋江",
            "value": "340203",

          },
          {

            "label": "鸠江",
            "value": "340207",

          },
          {

            "label": "三山",
            "value": "340208",

          },
          {

            "label": "芜湖",
            "value": "340221",

          },
          {

            "label": "繁昌",
            "value": "340222",

          },
          {

            "label": "南陵",
            "value": "340223",

          },
          {

            "label": "无为",
            "value": "340225",

          }
        ]
      },
      {

        "label": "蚌埠",
        "value": "340300",
        "children": [
          {

            "label": "龙子湖",
            "value": "340302",

          },
          {

            "label": "蚌山",
            "value": "340303",

          },
          {

            "label": "禹会",
            "value": "340304",

          },
          {

            "label": "淮上",
            "value": "340311",

          },
          {

            "label": "怀远",
            "value": "340321",

          },
          {

            "label": "五河",
            "value": "340322",

          },
          {

            "label": "固镇",
            "value": "340323",

          }
        ]
      },
      {

        "label": "淮南",
        "value": "340400",
        "children": [
          {

            "label": "大通",
            "value": "340402",

          },
          {

            "label": "田家庵",
            "value": "340403",

          },
          {

            "label": "谢家集",
            "value": "340404",

          },
          {

            "label": "八公山",
            "value": "340405",

          },
          {

            "label": "潘集",
            "value": "340406",

          },
          {

            "label": "凤台",
            "value": "340421",

          }
        ]
      },
      {

        "label": "马鞍山",
        "value": "340500",
        "children": [
          {

            "label": "花山",
            "value": "340503",

          },
          {

            "label": "雨山",
            "value": "340504",

          },
          {

            "label": "博望",
            "value": "340506",

          },
          {

            "label": "当涂",
            "value": "340521",

          },
          {

            "label": "含山",
            "value": "340522",

          },
          {

            "label": "和县",
            "value": "340523",

          }
        ]
      },
      {

        "label": "淮北",
        "value": "340600",
        "children": [
          {

            "label": "杜集",
            "value": "340602",

          },
          {

            "label": "相山",
            "value": "340603",

          },
          {

            "label": "烈山",
            "value": "340604",

          },
          {

            "label": "濉溪",
            "value": "340621",

          }
        ]
      },
      {

        "label": "铜陵",
        "value": "340700",
        "children": [
          {

            "label": "铜官山",
            "value": "340702",

          },
          {

            "label": "狮子山",
            "value": "340703",

          },
          {

            "label": "郊区",
            "value": "340711",

          },
          {

            "label": "铜陵",
            "value": "340721",

          }
        ]
      },
      {

        "label": "安庆",
        "value": "340800",
        "children": [
          {

            "label": "迎江",
            "value": "340802",

          },
          {

            "label": "大观",
            "value": "340803",

          },
          {

            "label": "宜秀",
            "value": "340811",

          },
          {

            "label": "怀宁",
            "value": "340822",

          },
          {

            "label": "枞阳",
            "value": "340823",

          },
          {

            "label": "潜山",
            "value": "340824",

          },
          {

            "label": "太湖",
            "value": "340825",

          },
          {

            "label": "宿松",
            "value": "340826",

          },
          {

            "label": "望江",
            "value": "340827",

          },
          {

            "label": "岳西",
            "value": "340828",

          },
          {

            "label": "桐城",
            "value": "340881",

          }
        ]
      },
      {

        "label": "黄山",
        "value": "341000",
        "children": [
          {

            "label": "屯溪",
            "value": "341002",

          },
          {

            "label": "黄山",
            "value": "341003",

          },
          {

            "label": "徽州",
            "value": "341004",

          },
          {

            "label": "歙县",
            "value": "341021",

          },
          {

            "label": "休宁",
            "value": "341022",

          },
          {

            "label": "黟县",
            "value": "341023",

          },
          {

            "label": "祁门",
            "value": "341024",

          }
        ]
      },
      {

        "label": "滁州",
        "value": "341100",
        "children": [
          {

            "label": "琅琊",
            "value": "341102",

          },
          {

            "label": "南谯",
            "value": "341103",

          },
          {

            "label": "来安",
            "value": "341122",

          },
          {

            "label": "全椒",
            "value": "341124",

          },
          {

            "label": "定远",
            "value": "341125",

          },
          {

            "label": "凤阳",
            "value": "341126",

          },
          {

            "label": "天长",
            "value": "341181",

          },
          {

            "label": "明光",
            "value": "341182",

          }
        ]
      },
      {

        "label": "阜阳",
        "value": "341200",
        "children": [
          {

            "label": "颍州",
            "value": "341202",

          },
          {

            "label": "颍东",
            "value": "341203",

          },
          {

            "label": "颍泉",
            "value": "341204",

          },
          {

            "label": "临泉",
            "value": "341221",

          },
          {

            "label": "太和",
            "value": "341222",

          },
          {

            "label": "阜南",
            "value": "341225",

          },
          {

            "label": "颍上",
            "value": "341226",

          },
          {

            "label": "界首",
            "value": "341282",

          }
        ]
      },
      {

        "label": "宿州",
        "value": "341300",
        "children": [
          {

            "label": "埇桥",
            "value": "341302",

          },
          {

            "label": "砀山",
            "value": "341321",

          },
          {

            "label": "萧县",
            "value": "341322",

          },
          {

            "label": "灵璧",
            "value": "341323",

          },
          {

            "label": "泗县",
            "value": "341324",

          }
        ]
      },
      {

        "label": "六安",
        "value": "341500",
        "children": [
          {

            "label": "金安",
            "value": "341502",

          },
          {

            "label": "裕安",
            "value": "341503",

          },
          {

            "label": "寿县",
            "value": "341521",

          },
          {

            "label": "霍邱",
            "value": "341522",

          },
          {

            "label": "舒城",
            "value": "341523",

          },
          {

            "label": "金寨",
            "value": "341524",

          },
          {

            "label": "霍山",
            "value": "341525",

          }
        ]
      },
      {

        "label": "亳州",
        "value": "341600",
        "children": [
          {

            "label": "谯城",
            "value": "341602",

          },
          {

            "label": "涡阳",
            "value": "341621",

          },
          {

            "label": "蒙城",
            "value": "341622",

          },
          {

            "label": "利辛",
            "value": "341623",

          }
        ]
      },
      {

        "label": "池州",
        "value": "341700",
        "children": [
          {

            "label": "贵池",
            "value": "341702",

          },
          {

            "label": "东至",
            "value": "341721",

          },
          {

            "label": "石台",
            "value": "341722",

          },
          {

            "label": "青阳",
            "value": "341723",

          }
        ]
      },
      {

        "label": "宣城",
        "value": "341800",
        "children": [
          {

            "label": "宣州",
            "value": "341802",

          },
          {

            "label": "郎溪",
            "value": "341821",

          },
          {

            "label": "广德",
            "value": "341822",

          },
          {

            "label": "泾县",
            "value": "341823",

          },
          {

            "label": "绩溪",
            "value": "341824",

          },
          {

            "label": "旌德",
            "value": "341825",

          },
          {

            "label": "宁国",
            "value": "341881",

          }
        ]
      }
    ]
  },
  {

    "label": "福建",
    "value": "350000",
    "children": [
      {

        "label": "福州",
        "value": "350100",
        "children": [
          {

            "label": "鼓楼",
            "value": "350102",

          },
          {

            "label": "台江",
            "value": "350103",

          },
          {

            "label": "仓山",
            "value": "350104",

          },
          {

            "label": "马尾",
            "value": "350105",

          },
          {

            "label": "晋安",
            "value": "350111",

          },
          {

            "label": "闽侯",
            "value": "350121",

          },
          {

            "label": "连江",
            "value": "350122",

          },
          {

            "label": "罗源",
            "value": "350123",

          },
          {

            "label": "闽清",
            "value": "350124",

          },
          {

            "label": "永泰",
            "value": "350125",

          },
          {

            "label": "平潭",
            "value": "350128",

          },
          {

            "label": "福清",
            "value": "350181",

          },
          {

            "label": "长乐",
            "value": "350182",

          }
        ]
      },
      {

        "label": "厦门",
        "value": "350200",
        "children": [
          {

            "label": "思明",
            "value": "350203",

          },
          {

            "label": "海沧",
            "value": "350205",

          },
          {

            "label": "湖里",
            "value": "350206",

          },
          {

            "label": "集美",
            "value": "350211",

          },
          {

            "label": "同安",
            "value": "350212",

          },
          {

            "label": "翔安",
            "value": "350213",

          }
        ]
      },
      {

        "label": "莆田",
        "value": "350300",
        "children": [
          {

            "label": "城厢",
            "value": "350302",

          },
          {

            "label": "涵江",
            "value": "350303",

          },
          {

            "label": "荔城",
            "value": "350304",

          },
          {

            "label": "秀屿",
            "value": "350305",

          },
          {

            "label": "仙游",
            "value": "350322",

          }
        ]
      },
      {

        "label": "三明",
        "value": "350400",
        "children": [
          {

            "label": "梅列",
            "value": "350402",

          },
          {

            "label": "三元",
            "value": "350403",

          },
          {

            "label": "明溪",
            "value": "350421",

          },
          {

            "label": "清流",
            "value": "350423",

          },
          {

            "label": "宁化",
            "value": "350424",

          },
          {

            "label": "大田",
            "value": "350425",

          },
          {

            "label": "尤溪",
            "value": "350426",

          },
          {

            "label": "沙县",
            "value": "350427",

          },
          {

            "label": "将乐",
            "value": "350428",

          },
          {

            "label": "泰宁",
            "value": "350429",

          },
          {

            "label": "建宁",
            "value": "350430",

          },
          {

            "label": "永安",
            "value": "350481",

          }
        ]
      },
      {

        "label": "泉州",
        "value": "350500",
        "children": [
          {

            "label": "鲤城",
            "value": "350502",

          },
          {

            "label": "丰泽",
            "value": "350503",

          },
          {

            "label": "洛江",
            "value": "350504",

          },
          {

            "label": "泉港",
            "value": "350505",

          },
          {

            "label": "惠安",
            "value": "350521",

          },
          {

            "label": "安溪",
            "value": "350524",

          },
          {

            "label": "永春",
            "value": "350525",

          },
          {

            "label": "德化",
            "value": "350526",

          },
          {

            "label": "金门",
            "value": "350527",

          },
          {

            "label": "石狮",
            "value": "350581",

          },
          {

            "label": "晋江",
            "value": "350582",

          },
          {

            "label": "南安",
            "value": "350583",

          }
        ]
      },
      {

        "label": "漳州",
        "value": "350600",
        "children": [
          {

            "label": "芗城",
            "value": "350602",

          },
          {

            "label": "龙文",
            "value": "350603",

          },
          {

            "label": "云霄",
            "value": "350622",

          },
          {

            "label": "漳浦",
            "value": "350623",

          },
          {

            "label": "诏安",
            "value": "350624",

          },
          {

            "label": "长泰",
            "value": "350625",

          },
          {

            "label": "东山",
            "value": "350626",

          },
          {

            "label": "南靖",
            "value": "350627",

          },
          {

            "label": "平和",
            "value": "350628",

          },
          {

            "label": "华安",
            "value": "350629",

          },
          {

            "label": "龙海",
            "value": "350681",

          }
        ]
      },
      {

        "label": "南平",
        "value": "350700",
        "children": [
          {

            "label": "延平",
            "value": "350702",

          },
          {

            "label": "建阳",
            "value": "350703",

          },
          {

            "label": "顺昌",
            "value": "350721",

          },
          {

            "label": "浦城",
            "value": "350722",

          },
          {

            "label": "光泽",
            "value": "350723",

          },
          {

            "label": "松溪",
            "value": "350724",

          },
          {

            "label": "政和",
            "value": "350725",

          },
          {

            "label": "邵武",
            "value": "350781",

          },
          {

            "label": "武夷山",
            "value": "350782",

          },
          {

            "label": "建瓯",
            "value": "350783",

          }
        ]
      },
      {

        "label": "龙岩",
        "value": "350800",
        "children": [
          {

            "label": "新罗",
            "value": "350802",

          },
          {

            "label": "长汀",
            "value": "350821",

          },
          {

            "label": "永定",
            "value": "350822",

          },
          {

            "label": "上杭",
            "value": "350823",

          },
          {

            "label": "武平",
            "value": "350824",

          },
          {

            "label": "连城",
            "value": "350825",

          },
          {

            "label": "漳平",
            "value": "350881",

          }
        ]
      },
      {

        "label": "宁德",
        "value": "350900",
        "children": [
          {

            "label": "蕉城",
            "value": "350902",

          },
          {

            "label": "霞浦",
            "value": "350921",

          },
          {

            "label": "古田",
            "value": "350922",

          },
          {

            "label": "屏南",
            "value": "350923",

          },
          {

            "label": "寿宁",
            "value": "350924",

          },
          {

            "label": "周宁",
            "value": "350925",

          },
          {

            "label": "柘荣",
            "value": "350926",

          },
          {

            "label": "福安",
            "value": "350981",

          },
          {

            "label": "福鼎",
            "value": "350982",

          }
        ]
      }
    ]
  },
  {

    "label": "江西",
    "value": "360000",
    "children": [
      {

        "label": "南昌",
        "value": "360100",
        "children": [
          {

            "label": "东湖",
            "value": "360102",

          },
          {

            "label": "西湖",
            "value": "360103",

          },
          {

            "label": "青云谱",
            "value": "360104",

          },
          {

            "label": "湾里",
            "value": "360105",

          },
          {

            "label": "青山湖",
            "value": "360111",

          },
          {

            "label": "南昌",
            "value": "360121",

          },
          {

            "label": "新建",
            "value": "360122",

          },
          {

            "label": "安义",
            "value": "360123",

          },
          {

            "label": "进贤",
            "value": "360124",

          }
        ]
      },
      {

        "label": "景德镇",
        "value": "360200",
        "children": [
          {

            "label": "昌江",
            "value": "360202",

          },
          {

            "label": "珠山",
            "value": "360203",

          },
          {

            "label": "浮梁",
            "value": "360222",

          },
          {

            "label": "乐平",
            "value": "360281",

          }
        ]
      },
      {

        "label": "萍乡",
        "value": "360300",
        "children": [
          {

            "label": "安源",
            "value": "360302",

          },
          {

            "label": "湘东",
            "value": "360313",

          },
          {

            "label": "莲花",
            "value": "360321",

          },
          {

            "label": "上栗",
            "value": "360322",

          },
          {

            "label": "芦溪",
            "value": "360323",

          }
        ]
      },
      {

        "label": "九江",
        "value": "360400",
        "children": [
          {

            "label": "庐山",
            "value": "360402",

          },
          {

            "label": "浔阳",
            "value": "360403",

          },
          {

            "label": "九江",
            "value": "360421",

          },
          {

            "label": "武宁",
            "value": "360423",

          },
          {

            "label": "修水",
            "value": "360424",

          },
          {

            "label": "永修",
            "value": "360425",

          },
          {

            "label": "德安",
            "value": "360426",

          },
          {

            "label": "星子",
            "value": "360427",

          },
          {

            "label": "都昌",
            "value": "360428",

          },
          {

            "label": "湖口",
            "value": "360429",

          },
          {

            "label": "彭泽",
            "value": "360430",

          },
          {

            "label": "瑞昌",
            "value": "360481",

          },
          {

            "label": "共青城",
            "value": "360482",

          }
        ]
      },
      {

        "label": "新余",
        "value": "360500",
        "children": [
          {

            "label": "渝水",
            "value": "360502",

          },
          {

            "label": "分宜",
            "value": "360521",

          }
        ]
      },
      {

        "label": "鹰潭",
        "value": "360600",
        "children": [
          {

            "label": "月湖",
            "value": "360602",

          },
          {

            "label": "余江",
            "value": "360622",

          },
          {

            "label": "贵溪",
            "value": "360681",

          }
        ]
      },
      {

        "label": "赣州",
        "value": "360700",
        "children": [
          {

            "label": "章贡",
            "value": "360702",

          },
          {

            "label": "南康",
            "value": "360703",

          },
          {

            "label": "赣县",
            "value": "360721",

          },
          {

            "label": "信丰",
            "value": "360722",

          },
          {

            "label": "大余",
            "value": "360723",

          },
          {

            "label": "上犹",
            "value": "360724",

          },
          {

            "label": "崇义",
            "value": "360725",

          },
          {

            "label": "安远",
            "value": "360726",

          },
          {

            "label": "龙南",
            "value": "360727",

          },
          {

            "label": "定南",
            "value": "360728",

          },
          {

            "label": "全南",
            "value": "360729",

          },
          {

            "label": "宁都",
            "value": "360730",

          },
          {

            "label": "于都",
            "value": "360731",

          },
          {

            "label": "兴国",
            "value": "360732",

          },
          {

            "label": "会昌",
            "value": "360733",

          },
          {

            "label": "寻乌",
            "value": "360734",

          },
          {

            "label": "石城",
            "value": "360735",

          },
          {

            "label": "瑞金",
            "value": "360781",

          }
        ]
      },
      {

        "label": "吉安",
        "value": "360800",
        "children": [
          {

            "label": "吉州",
            "value": "360802",

          },
          {

            "label": "青原",
            "value": "360803",

          },
          {

            "label": "吉安",
            "value": "360821",

          },
          {

            "label": "吉水",
            "value": "360822",

          },
          {

            "label": "峡江",
            "value": "360823",

          },
          {

            "label": "新干",
            "value": "360824",

          },
          {

            "label": "永丰",
            "value": "360825",

          },
          {

            "label": "泰和",
            "value": "360826",

          },
          {

            "label": "遂川",
            "value": "360827",

          },
          {

            "label": "万安",
            "value": "360828",

          },
          {

            "label": "安福",
            "value": "360829",

          },
          {

            "label": "永新",
            "value": "360830",

          },
          {

            "label": "井冈山",
            "value": "360881",

          }
        ]
      },
      {

        "label": "宜春",
        "value": "360900",
        "children": [
          {

            "label": "袁州",
            "value": "360902",

          },
          {

            "label": "奉新",
            "value": "360921",

          },
          {

            "label": "万载",
            "value": "360922",

          },
          {

            "label": "上高",
            "value": "360923",

          },
          {

            "label": "宜丰",
            "value": "360924",

          },
          {

            "label": "靖安",
            "value": "360925",

          },
          {

            "label": "铜鼓",
            "value": "360926",

          },
          {

            "label": "丰城",
            "value": "360981",

          },
          {

            "label": "樟树",
            "value": "360982",

          },
          {

            "label": "高安",
            "value": "360983",

          }
        ]
      },
      {

        "label": "抚州",
        "value": "361000",
        "children": [
          {

            "label": "临川",
            "value": "361002",

          },
          {

            "label": "南城",
            "value": "361021",

          },
          {

            "label": "黎川",
            "value": "361022",

          },
          {

            "label": "南丰",
            "value": "361023",

          },
          {

            "label": "崇仁",
            "value": "361024",

          },
          {

            "label": "乐安",
            "value": "361025",

          },
          {

            "label": "宜黄",
            "value": "361026",

          },
          {

            "label": "金溪",
            "value": "361027",

          },
          {

            "label": "资溪",
            "value": "361028",

          },
          {

            "label": "东乡",
            "value": "361029",

          },
          {

            "label": "广昌",
            "value": "361030",

          }
        ]
      },
      {

        "label": "上饶",
        "value": "361100",
        "children": [
          {

            "label": "信州",
            "value": "361102",

          },
          {

            "label": "上饶",
            "value": "361121",

          },
          {

            "label": "广丰",
            "value": "361122",

          },
          {

            "label": "玉山",
            "value": "361123",

          },
          {

            "label": "铅山",
            "value": "361124",

          },
          {

            "label": "横峰",
            "value": "361125",

          },
          {

            "label": "弋阳",
            "value": "361126",

          },
          {

            "label": "余干",
            "value": "361127",

          },
          {

            "label": "鄱阳",
            "value": "361128",

          },
          {

            "label": "万年",
            "value": "361129",

          },
          {

            "label": "婺源",
            "value": "361130",

          },
          {

            "label": "德兴",
            "value": "361181",

          }
        ]
      }
    ]
  },
  {

    "label": "山东",
    "value": "370000",
    "children": [
      {

        "label": "济南",
        "value": "370100",
        "children": [
          {

            "label": "历下",
            "value": "370102",

          },
          {

            "label": "市中区",
            "value": "370103",

          },
          {

            "label": "槐荫",
            "value": "370104",

          },
          {

            "label": "天桥",
            "value": "370105",

          },
          {

            "label": "历城",
            "value": "370112",

          },
          {

            "label": "长清",
            "value": "370113",

          },
          {

            "label": "平阴",
            "value": "370124",

          },
          {

            "label": "济阳",
            "value": "370125",

          },
          {

            "label": "商河",
            "value": "370126",

          },
          {

            "label": "章丘",
            "value": "370181",

          }
        ]
      },
      {

        "label": "青岛",
        "value": "370200",
        "children": [
          {

            "label": "市南",
            "value": "370202",

          },
          {

            "label": "市北",
            "value": "370203",

          },
          {

            "label": "黄岛",
            "value": "370211",

          },
          {

            "label": "崂山",
            "value": "370212",

          },
          {

            "label": "李沧",
            "value": "370213",

          },
          {

            "label": "城阳",
            "value": "370214",

          },
          {

            "label": "胶州",
            "value": "370281",

          },
          {

            "label": "即墨",
            "value": "370282",

          },
          {

            "label": "平度",
            "value": "370283",

          },
          {

            "label": "莱西",
            "value": "370285",

          },
          {

            "label": "西海岸",
            "value": "370286",

          }
        ]
      },
      {

        "label": "淄博",
        "value": "370300",
        "children": [
          {

            "label": "淄川",
            "value": "370302",

          },
          {

            "label": "张店",
            "value": "370303",

          },
          {

            "label": "博山",
            "value": "370304",

          },
          {

            "label": "临淄",
            "value": "370305",

          },
          {

            "label": "周村",
            "value": "370306",

          },
          {

            "label": "桓台",
            "value": "370321",

          },
          {

            "label": "高青",
            "value": "370322",

          },
          {

            "label": "沂源",
            "value": "370323",

          }
        ]
      },
      {

        "label": "枣庄",
        "value": "370400",
        "children": [
          {

            "label": "市中区",
            "value": "370402",

          },
          {

            "label": "薛城",
            "value": "370403",

          },
          {

            "label": "峄城",
            "value": "370404",

          },
          {

            "label": "台儿庄",
            "value": "370405",

          },
          {

            "label": "山亭",
            "value": "370406",

          },
          {

            "label": "滕州",
            "value": "370481",

          }
        ]
      },
      {

        "label": "东营",
        "value": "370500",
        "children": [
          {

            "label": "东营",
            "value": "370502",

          },
          {

            "label": "河口",
            "value": "370503",

          },
          {

            "label": "垦利",
            "value": "370521",

          },
          {

            "label": "利津",
            "value": "370522",

          },
          {

            "label": "广饶",
            "value": "370523",

          }
        ]
      },
      {

        "label": "烟台",
        "value": "370600",
        "children": [
          {

            "label": "芝罘",
            "value": "370602",

          },
          {

            "label": "福山",
            "value": "370611",

          },
          {

            "label": "牟平",
            "value": "370612",

          },
          {

            "label": "莱山",
            "value": "370613",

          },
          {

            "label": "长岛",
            "value": "370634",

          },
          {

            "label": "龙口",
            "value": "370681",

          },
          {

            "label": "莱阳",
            "value": "370682",

          },
          {

            "label": "莱州",
            "value": "370683",

          },
          {

            "label": "蓬莱",
            "value": "370684",

          },
          {

            "label": "招远",
            "value": "370685",

          },
          {

            "label": "栖霞",
            "value": "370686",

          },
          {

            "label": "海阳",
            "value": "370687",

          }
        ]
      },
      {

        "label": "潍坊",
        "value": "370700",
        "children": [
          {

            "label": "潍城",
            "value": "370702",

          },
          {

            "label": "寒亭",
            "value": "370703",

          },
          {

            "label": "坊子",
            "value": "370704",

          },
          {

            "label": "奎文",
            "value": "370705",

          },
          {

            "label": "临朐",
            "value": "370724",

          },
          {

            "label": "昌乐",
            "value": "370725",

          },
          {

            "label": "青州",
            "value": "370781",

          },
          {

            "label": "诸城",
            "value": "370782",

          },
          {

            "label": "寿光",
            "value": "370783",

          },
          {

            "label": "安丘",
            "value": "370784",

          },
          {

            "label": "高密",
            "value": "370785",

          },
          {

            "label": "昌邑",
            "value": "370786",

          }
        ]
      },
      {

        "label": "济宁",
        "value": "370800",
        "children": [
          {

            "label": "任城",
            "value": "370811",

          },
          {

            "label": "兖州",
            "value": "370812",

          },
          {

            "label": "微山",
            "value": "370826",

          },
          {

            "label": "鱼台",
            "value": "370827",

          },
          {

            "label": "金乡",
            "value": "370828",

          },
          {

            "label": "嘉祥",
            "value": "370829",

          },
          {

            "label": "汶上",
            "value": "370830",

          },
          {

            "label": "泗水",
            "value": "370831",

          },
          {

            "label": "梁山",
            "value": "370832",

          },
          {

            "label": "曲阜",
            "value": "370881",

          },
          {

            "label": "邹城",
            "value": "370883",

          }
        ]
      },
      {

        "label": "泰安",
        "value": "370900",
        "children": [
          {

            "label": "泰山",
            "value": "370902",

          },
          {

            "label": "岱岳",
            "value": "370911",

          },
          {

            "label": "宁阳",
            "value": "370921",

          },
          {

            "label": "东平",
            "value": "370923",

          },
          {

            "label": "新泰",
            "value": "370982",

          },
          {

            "label": "肥城",
            "value": "370983",

          }
        ]
      },
      {

        "label": "威海",
        "value": "371000",
        "children": [
          {

            "label": "环翠",
            "value": "371002",

          },
          {

            "label": "文登",
            "value": "371003",

          },
          {

            "label": "荣成",
            "value": "371082",

          },
          {

            "label": "乳山",
            "value": "371083",

          }
        ]
      },
      {

        "label": "日照",
        "value": "371100",
        "children": [
          {

            "label": "东港",
            "value": "371102",

          },
          {

            "label": "岚山",
            "value": "371103",

          },
          {

            "label": "五莲",
            "value": "371121",

          },
          {

            "label": "莒县",
            "value": "371122",

          }
        ]
      },
      {

        "label": "莱芜",
        "value": "371200",
        "children": [
          {

            "label": "莱城",
            "value": "371202",

          },
          {

            "label": "钢城",
            "value": "371203",

          }
        ]
      },
      {

        "label": "临沂",
        "value": "371300",
        "children": [
          {

            "label": "兰山",
            "value": "371302",

          },
          {

            "label": "罗庄",
            "value": "371311",

          },
          {

            "label": "河东",
            "value": "371312",

          },
          {

            "label": "沂南",
            "value": "371321",

          },
          {

            "label": "郯城",
            "value": "371322",

          },
          {

            "label": "沂水",
            "value": "371323",

          },
          {

            "label": "兰陵",
            "value": "371324",

          },
          {

            "label": "费县",
            "value": "371325",

          },
          {

            "label": "平邑",
            "value": "371326",

          },
          {

            "label": "莒南",
            "value": "371327",

          },
          {

            "label": "蒙阴",
            "value": "371328",

          },
          {

            "label": "临沭",
            "value": "371329",

          }
        ]
      },
      {

        "label": "德州",
        "value": "371400",
        "children": [
          {

            "label": "德城",
            "value": "371402",

          },
          {

            "label": "陵城",
            "value": "371403",

          },
          {

            "label": "宁津",
            "value": "371422",

          },
          {

            "label": "庆云",
            "value": "371423",

          },
          {

            "label": "临邑",
            "value": "371424",

          },
          {

            "label": "齐河",
            "value": "371425",

          },
          {

            "label": "平原",
            "value": "371426",

          },
          {

            "label": "夏津",
            "value": "371427",

          },
          {

            "label": "武城",
            "value": "371428",

          },
          {

            "label": "乐陵",
            "value": "371481",

          },
          {

            "label": "禹城",
            "value": "371482",

          }
        ]
      },
      {

        "label": "聊城",
        "value": "371500",
        "children": [
          {

            "label": "东昌府",
            "value": "371502",

          },
          {

            "label": "阳谷",
            "value": "371521",

          },
          {

            "label": "莘县",
            "value": "371522",

          },
          {

            "label": "茌平",
            "value": "371523",

          },
          {

            "label": "东阿",
            "value": "371524",

          },
          {

            "label": "冠县",
            "value": "371525",

          },
          {

            "label": "高唐",
            "value": "371526",

          },
          {

            "label": "临清",
            "value": "371581",

          }
        ]
      },
      {

        "label": "滨州",
        "value": "371600",
        "children": [
          {

            "label": "滨城",
            "value": "371602",

          },
          {

            "label": "沾化",
            "value": "371603",

          },
          {

            "label": "惠民",
            "value": "371621",

          },
          {

            "label": "阳信",
            "value": "371622",

          },
          {

            "label": "无棣",
            "value": "371623",

          },
          {

            "label": "博兴",
            "value": "371625",

          },
          {

            "label": "邹平",
            "value": "371626",

          },
          {

            "label": "北海新区",
            "value": "371627",

          }
        ]
      },
      {

        "label": "菏泽",
        "value": "371700",
        "children": [
          {

            "label": "牡丹",
            "value": "371702",

          },
          {

            "label": "曹县",
            "value": "371721",

          },
          {

            "label": "单县",
            "value": "371722",

          },
          {

            "label": "成武",
            "value": "371723",

          },
          {

            "label": "巨野",
            "value": "371724",

          },
          {

            "label": "郓城",
            "value": "371725",

          },
          {

            "label": "鄄城",
            "value": "371726",

          },
          {

            "label": "定陶",
            "value": "371727",

          },
          {

            "label": "东明",
            "value": "371728",

          }
        ]
      }
    ]
  },
  {

    "label": "河南",
    "value": "410000",
    "children": [
      {

        "label": "郑州",
        "value": "410100",
        "children": [
          {

            "label": "中原",
            "value": "410102",

          },
          {

            "label": "二七",
            "value": "410103",

          },
          {

            "label": "管城",
            "value": "410104",

          },
          {

            "label": "金水",
            "value": "410105",

          },
          {

            "label": "上街",
            "value": "410106",

          },
          {

            "label": "惠济",
            "value": "410108",

          },
          {

            "label": "中牟",
            "value": "410122",

          },
          {

            "label": "巩义",
            "value": "410181",

          },
          {

            "label": "荥阳",
            "value": "410182",

          },
          {

            "label": "新密",
            "value": "410183",

          },
          {

            "label": "新郑",
            "value": "410184",

          },
          {

            "label": "登封",
            "value": "410185",

          }
        ]
      },
      {

        "label": "开封",
        "value": "410200",
        "children": [
          {

            "label": "龙亭",
            "value": "410202",

          },
          {

            "label": "顺河",
            "value": "410203",

          },
          {

            "label": "鼓楼",
            "value": "410204",

          },
          {

            "label": "禹王台",
            "value": "410205",

          },
          {

            "label": "祥符",
            "value": "410212",

          },
          {

            "label": "杞县",
            "value": "410221",

          },
          {

            "label": "通许",
            "value": "410222",

          },
          {

            "label": "尉氏",
            "value": "410223",

          },
          {

            "label": "兰考",
            "value": "410225",

          }
        ]
      },
      {

        "label": "洛阳",
        "value": "410300",
        "children": [
          {

            "label": "老城",
            "value": "410302",

          },
          {

            "label": "西工",
            "value": "410303",

          },
          {

            "label": "瀍河",
            "value": "410304",

          },
          {

            "label": "涧西",
            "value": "410305",

          },
          {

            "label": "吉利",
            "value": "410306",

          },
          {

            "label": "洛龙",
            "value": "410311",

          },
          {

            "label": "孟津",
            "value": "410322",

          },
          {

            "label": "新安",
            "value": "410323",

          },
          {

            "label": "栾川",
            "value": "410324",

          },
          {

            "label": "嵩县",
            "value": "410325",

          },
          {

            "label": "汝阳",
            "value": "410326",

          },
          {

            "label": "宜阳",
            "value": "410327",

          },
          {

            "label": "洛宁",
            "value": "410328",

          },
          {

            "label": "伊川",
            "value": "410329",

          },
          {

            "label": "偃师",
            "value": "410381",

          }
        ]
      },
      {

        "label": "平顶山",
        "value": "410400",
        "children": [
          {

            "label": "新华",
            "value": "410402",

          },
          {

            "label": "卫东",
            "value": "410403",

          },
          {

            "label": "石龙",
            "value": "410404",

          },
          {

            "label": "湛河",
            "value": "410411",

          },
          {

            "label": "宝丰",
            "value": "410421",

          },
          {

            "label": "叶县",
            "value": "410422",

          },
          {

            "label": "鲁山",
            "value": "410423",

          },
          {

            "label": "郏县",
            "value": "410425",

          },
          {

            "label": "舞钢",
            "value": "410481",

          },
          {

            "label": "汝州",
            "value": "410482",

          }
        ]
      },
      {

        "label": "安阳",
        "value": "410500",
        "children": [
          {

            "label": "文峰",
            "value": "410502",

          },
          {

            "label": "北关",
            "value": "410503",

          },
          {

            "label": "殷都",
            "value": "410505",

          },
          {

            "label": "龙安",
            "value": "410506",

          },
          {

            "label": "安阳",
            "value": "410522",

          },
          {

            "label": "汤阴",
            "value": "410523",

          },
          {

            "label": "滑县",
            "value": "410526",

          },
          {

            "label": "内黄",
            "value": "410527",

          },
          {

            "label": "林州",
            "value": "410581",

          }
        ]
      },
      {

        "label": "鹤壁",
        "value": "410600",
        "children": [
          {

            "label": "鹤山",
            "value": "410602",

          },
          {

            "label": "山城",
            "value": "410603",

          },
          {

            "label": "淇滨",
            "value": "410611",

          },
          {

            "label": "浚县",
            "value": "410621",

          },
          {

            "label": "淇县",
            "value": "410622",

          }
        ]
      },
      {

        "label": "新乡",
        "value": "410700",
        "children": [
          {

            "label": "红旗",
            "value": "410702",

          },
          {

            "label": "卫滨",
            "value": "410703",

          },
          {

            "label": "凤泉",
            "value": "410704",

          },
          {

            "label": "牧野",
            "value": "410711",

          },
          {

            "label": "新乡",
            "value": "410721",

          },
          {

            "label": "获嘉",
            "value": "410724",

          },
          {

            "label": "原阳",
            "value": "410725",

          },
          {

            "label": "延津",
            "value": "410726",

          },
          {

            "label": "封丘",
            "value": "410727",

          },
          {

            "label": "长垣",
            "value": "410728",

          },
          {

            "label": "卫辉",
            "value": "410781",

          },
          {

            "label": "辉县",
            "value": "410782",

          }
        ]
      },
      {

        "label": "焦作",
        "value": "410800",
        "children": [
          {

            "label": "解放",
            "value": "410802",

          },
          {

            "label": "中站",
            "value": "410803",

          },
          {

            "label": "马村",
            "value": "410804",

          },
          {

            "label": "山阳",
            "value": "410811",

          },
          {

            "label": "修武",
            "value": "410821",

          },
          {

            "label": "博爱",
            "value": "410822",

          },
          {

            "label": "武陟",
            "value": "410823",

          },
          {

            "label": "温县",
            "value": "410825",

          },
          {

            "label": "沁阳",
            "value": "410882",

          },
          {

            "label": "孟州",
            "value": "410883",

          }
        ]
      },
      {

        "label": "濮阳",
        "value": "410900",
        "children": [
          {

            "label": "华龙",
            "value": "410902",

          },
          {

            "label": "清丰",
            "value": "410922",

          },
          {

            "label": "南乐",
            "value": "410923",

          },
          {

            "label": "范县",
            "value": "410926",

          },
          {

            "label": "台前",
            "value": "410927",

          },
          {

            "label": "濮阳",
            "value": "410928",

          }
        ]
      },
      {

        "label": "许昌",
        "value": "411000",
        "children": [
          {

            "label": "魏都",
            "value": "411002",

          },
          {

            "label": "许昌",
            "value": "411023",

          },
          {

            "label": "鄢陵",
            "value": "411024",

          },
          {

            "label": "襄城",
            "value": "411025",

          },
          {

            "label": "禹州",
            "value": "411081",

          },
          {

            "label": "长葛",
            "value": "411082",

          }
        ]
      },
      {

        "label": "漯河",
        "value": "411100",
        "children": [
          {

            "label": "源汇",
            "value": "411102",

          },
          {

            "label": "郾城",
            "value": "411103",

          },
          {

            "label": "召陵",
            "value": "411104",

          },
          {

            "label": "舞阳",
            "value": "411121",

          },
          {

            "label": "临颍",
            "value": "411122",

          }
        ]
      },
      {

        "label": "三门峡",
        "value": "411200",
        "children": [
          {

            "label": "湖滨",
            "value": "411202",

          },
          {

            "label": "渑池",
            "value": "411221",

          },
          {

            "label": "陕县",
            "value": "411222",

          },
          {

            "label": "卢氏",
            "value": "411224",

          },
          {

            "label": "义马",
            "value": "411281",

          },
          {

            "label": "灵宝",
            "value": "411282",

          }
        ]
      },
      {

        "label": "南阳",
        "value": "411300",
        "children": [
          {

            "label": "宛城",
            "value": "411302",

          },
          {

            "label": "卧龙",
            "value": "411303",

          },
          {

            "label": "南召",
            "value": "411321",

          },
          {

            "label": "方城",
            "value": "411322",

          },
          {

            "label": "西峡",
            "value": "411323",

          },
          {

            "label": "镇平",
            "value": "411324",

          },
          {

            "label": "内乡",
            "value": "411325",

          },
          {

            "label": "淅川",
            "value": "411326",

          },
          {

            "label": "社旗",
            "value": "411327",

          },
          {

            "label": "唐河",
            "value": "411328",

          },
          {

            "label": "新野",
            "value": "411329",

          },
          {

            "label": "桐柏",
            "value": "411330",

          },
          {

            "label": "邓州",
            "value": "411381",

          }
        ]
      },
      {

        "label": "商丘",
        "value": "411400",
        "children": [
          {

            "label": "梁园",
            "value": "411402",

          },
          {

            "label": "睢阳",
            "value": "411403",

          },
          {

            "label": "民权",
            "value": "411421",

          },
          {

            "label": "睢县",
            "value": "411422",

          },
          {

            "label": "宁陵",
            "value": "411423",

          },
          {

            "label": "柘城",
            "value": "411424",

          },
          {

            "label": "虞城",
            "value": "411425",

          },
          {

            "label": "夏邑",
            "value": "411426",

          },
          {

            "label": "永城",
            "value": "411481",

          }
        ]
      },
      {

        "label": "信阳",
        "value": "411500",
        "children": [
          {

            "label": "浉河",
            "value": "411502",

          },
          {

            "label": "平桥",
            "value": "411503",

          },
          {

            "label": "罗山",
            "value": "411521",

          },
          {

            "label": "光山",
            "value": "411522",

          },
          {

            "label": "新县",
            "value": "411523",

          },
          {

            "label": "商城",
            "value": "411524",

          },
          {

            "label": "固始",
            "value": "411525",

          },
          {

            "label": "潢川",
            "value": "411526",

          },
          {

            "label": "淮滨",
            "value": "411527",

          },
          {

            "label": "息县",
            "value": "411528",

          }
        ]
      },
      {

        "label": "周口",
        "value": "411600",
        "children": [
          {

            "label": "川汇",
            "value": "411602",

          },
          {

            "label": "扶沟",
            "value": "411621",

          },
          {

            "label": "西华",
            "value": "411622",

          },
          {

            "label": "商水",
            "value": "411623",

          },
          {

            "label": "沈丘",
            "value": "411624",

          },
          {

            "label": "郸城",
            "value": "411625",

          },
          {

            "label": "淮阳",
            "value": "411626",

          },
          {

            "label": "太康",
            "value": "411627",

          },
          {

            "label": "鹿邑",
            "value": "411628",

          },
          {

            "label": "项城",
            "value": "411681",

          }
        ]
      },
      {

        "label": "驻马店",
        "value": "411700",
        "children": [
          {

            "label": "驿城",
            "value": "411702",

          },
          {

            "label": "西平",
            "value": "411721",

          },
          {

            "label": "上蔡",
            "value": "411722",

          },
          {

            "label": "平舆",
            "value": "411723",

          },
          {

            "label": "正阳",
            "value": "411724",

          },
          {

            "label": "确山",
            "value": "411725",

          },
          {

            "label": "泌阳",
            "value": "411726",

          },
          {

            "label": "汝南",
            "value": "411727",

          },
          {

            "label": "遂平",
            "value": "411728",

          },
          {

            "label": "新蔡",
            "value": "411729",

          }
        ]
      },
      {

        "label": " ",
        "value": "419000",
        "children": [
          {

            "label": "济源",
            "value": "419001",

          }
        ]
      }
    ]
  },
  {

    "label": "湖北",
    "value": "420000",
    "children": [
      {

        "label": "武汉",
        "value": "420100",
        "children": [
          {

            "label": "江岸",
            "value": "420102",

          },
          {

            "label": "江汉",
            "value": "420103",

          },
          {

            "label": "硚口",
            "value": "420104",

          },
          {

            "label": "汉阳",
            "value": "420105",

          },
          {

            "label": "武昌",
            "value": "420106",

          },
          {

            "label": "青山",
            "value": "420107",

          },
          {

            "label": "洪山",
            "value": "420111",

          },
          {

            "label": "东西湖",
            "value": "420112",

          },
          {

            "label": "汉南",
            "value": "420113",

          },
          {

            "label": "蔡甸",
            "value": "420114",

          },
          {

            "label": "江夏",
            "value": "420115",

          },
          {

            "label": "黄陂",
            "value": "420116",

          },
          {

            "label": "新洲",
            "value": "420117",

          }
        ]
      },
      {

        "label": "黄石",
        "value": "420200",
        "children": [
          {

            "label": "黄石港",
            "value": "420202",

          },
          {

            "label": "西塞山",
            "value": "420203",

          },
          {

            "label": "下陆",
            "value": "420204",

          },
          {

            "label": "铁山",
            "value": "420205",

          },
          {

            "label": "阳新",
            "value": "420222",

          },
          {

            "label": "大冶",
            "value": "420281",

          }
        ]
      },
      {

        "label": "十堰",
        "value": "420300",
        "children": [
          {

            "label": "茅箭",
            "value": "420302",

          },
          {

            "label": "张湾",
            "value": "420303",

          },
          {

            "label": "郧阳",
            "value": "420304",

          },
          {

            "label": "郧西",
            "value": "420322",

          },
          {

            "label": "竹山",
            "value": "420323",

          },
          {

            "label": "竹溪",
            "value": "420324",

          },
          {

            "label": "房县",
            "value": "420325",

          },
          {

            "label": "丹江口",
            "value": "420381",

          }
        ]
      },
      {

        "label": "宜昌",
        "value": "420500",
        "children": [
          {

            "label": "西陵",
            "value": "420502",

          },
          {

            "label": "伍家岗",
            "value": "420503",

          },
          {

            "label": "点军",
            "value": "420504",

          },
          {

            "label": "猇亭",
            "value": "420505",

          },
          {

            "label": "夷陵",
            "value": "420506",

          },
          {

            "label": "远安",
            "value": "420525",

          },
          {

            "label": "兴山",
            "value": "420526",

          },
          {

            "label": "秭归",
            "value": "420527",

          },
          {

            "label": "长阳",
            "value": "420528",

          },
          {

            "label": "五峰",
            "value": "420529",

          },
          {

            "label": "宜都",
            "value": "420581",

          },
          {

            "label": "当阳",
            "value": "420582",

          },
          {

            "label": "枝江",
            "value": "420583",

          }
        ]
      },
      {

        "label": "襄阳",
        "value": "420600",
        "children": [
          {

            "label": "襄城",
            "value": "420602",

          },
          {

            "label": "樊城",
            "value": "420606",

          },
          {

            "label": "襄州",
            "value": "420607",

          },
          {

            "label": "南漳",
            "value": "420624",

          },
          {

            "label": "谷城",
            "value": "420625",

          },
          {

            "label": "保康",
            "value": "420626",

          },
          {

            "label": "老河口",
            "value": "420682",

          },
          {

            "label": "枣阳",
            "value": "420683",

          },
          {

            "label": "宜城",
            "value": "420684",

          }
        ]
      },
      {

        "label": "鄂州",
        "value": "420700",
        "children": [
          {

            "label": "梁子湖",
            "value": "420702",

          },
          {

            "label": "华容",
            "value": "420703",

          },
          {

            "label": "鄂城",
            "value": "420704",

          }
        ]
      },
      {

        "label": "荆门",
        "value": "420800",
        "children": [
          {

            "label": "东宝",
            "value": "420802",

          },
          {

            "label": "掇刀",
            "value": "420804",

          },
          {

            "label": "京山",
            "value": "420821",

          },
          {

            "label": "沙洋",
            "value": "420822",

          },
          {

            "label": "钟祥",
            "value": "420881",

          }
        ]
      },
      {

        "label": "孝感",
        "value": "420900",
        "children": [
          {

            "label": "孝南",
            "value": "420902",

          },
          {

            "label": "孝昌",
            "value": "420921",

          },
          {

            "label": "大悟",
            "value": "420922",

          },
          {

            "label": "云梦",
            "value": "420923",

          },
          {

            "label": "应城",
            "value": "420981",

          },
          {

            "label": "安陆",
            "value": "420982",

          },
          {

            "label": "汉川",
            "value": "420984",

          }
        ]
      },
      {

        "label": "荆州",
        "value": "421000",
        "children": [
          {

            "label": "沙市",
            "value": "421002",

          },
          {

            "label": "荆州",
            "value": "421003",

          },
          {

            "label": "公安",
            "value": "421022",

          },
          {

            "label": "监利",
            "value": "421023",

          },
          {

            "label": "江陵",
            "value": "421024",

          },
          {

            "label": "石首",
            "value": "421081",

          },
          {

            "label": "洪湖",
            "value": "421083",

          },
          {

            "label": "松滋",
            "value": "421087",

          }
        ]
      },
      {

        "label": "黄冈",
        "value": "421100",
        "children": [
          {

            "label": "黄州",
            "value": "421102",

          },
          {

            "label": "团风",
            "value": "421121",

          },
          {

            "label": "红安",
            "value": "421122",

          },
          {

            "label": "罗田",
            "value": "421123",

          },
          {

            "label": "英山",
            "value": "421124",

          },
          {

            "label": "浠水",
            "value": "421125",

          },
          {

            "label": "蕲春",
            "value": "421126",

          },
          {

            "label": "黄梅",
            "value": "421127",

          },
          {

            "label": "麻城",
            "value": "421181",

          },
          {

            "label": "武穴",
            "value": "421182",

          }
        ]
      },
      {

        "label": "咸宁",
        "value": "421200",
        "children": [
          {

            "label": "咸安",
            "value": "421202",

          },
          {

            "label": "嘉鱼",
            "value": "421221",

          },
          {

            "label": "通城",
            "value": "421222",

          },
          {

            "label": "崇阳",
            "value": "421223",

          },
          {

            "label": "通山",
            "value": "421224",

          },
          {

            "label": "赤壁",
            "value": "421281",

          }
        ]
      },
      {

        "label": "随州",
        "value": "421300",
        "children": [
          {

            "label": "曾都",
            "value": "421303",

          },
          {

            "label": "随县",
            "value": "421321",

          },
          {

            "label": "广水",
            "value": "421381",

          }
        ]
      },
      {

        "label": "恩施",
        "value": "422800",
        "children": [
          {

            "label": "恩施",
            "value": "422801",

          },
          {

            "label": "利川",
            "value": "422802",

          },
          {

            "label": "建始",
            "value": "422822",

          },
          {

            "label": "巴东",
            "value": "422823",

          },
          {

            "label": "宣恩",
            "value": "422825",

          },
          {

            "label": "咸丰",
            "value": "422826",

          },
          {

            "label": "来凤",
            "value": "422827",

          },
          {

            "label": "鹤峰",
            "value": "422828",

          }
        ]
      },
      {

        "label": " ",
        "value": "429000",
        "children": [
          {

            "label": "仙桃",
            "value": "429004",

          },
          {

            "label": "潜江",
            "value": "429005",

          },
          {

            "label": "天门",
            "value": "429006",

          },
          {

            "label": "神农架",
            "value": "429021",

          }
        ]
      }
    ]
  },
  {

    "label": "湖南",
    "value": "430000",
    "children": [
      {

        "label": "长沙",
        "value": "430100",
        "children": [
          {

            "label": "芙蓉",
            "value": "430102",

          },
          {

            "label": "天心",
            "value": "430103",

          },
          {

            "label": "岳麓",
            "value": "430104",

          },
          {

            "label": "开福",
            "value": "430105",

          },
          {

            "label": "雨花",
            "value": "430111",

          },
          {

            "label": "望城",
            "value": "430112",

          },
          {

            "label": "长沙",
            "value": "430121",

          },
          {

            "label": "宁乡",
            "value": "430124",

          },
          {

            "label": "浏阳",
            "value": "430181",

          }
        ]
      },
      {

        "label": "株洲",
        "value": "430200",
        "children": [
          {

            "label": "荷塘",
            "value": "430202",

          },
          {

            "label": "芦淞",
            "value": "430203",

          },
          {

            "label": "石峰",
            "value": "430204",

          },
          {

            "label": "天元",
            "value": "430211",

          },
          {

            "label": "株洲",
            "value": "430221",

          },
          {

            "label": "攸县",
            "value": "430223",

          },
          {

            "label": "茶陵",
            "value": "430224",

          },
          {

            "label": "炎陵",
            "value": "430225",

          },
          {

            "label": "醴陵",
            "value": "430281",

          }
        ]
      },
      {

        "label": "湘潭",
        "value": "430300",
        "children": [
          {

            "label": "雨湖",
            "value": "430302",

          },
          {

            "label": "岳塘",
            "value": "430304",

          },
          {

            "label": "湘潭",
            "value": "430321",

          },
          {

            "label": "湘乡",
            "value": "430381",

          },
          {

            "label": "韶山",
            "value": "430382",

          }
        ]
      },
      {

        "label": "衡阳",
        "value": "430400",
        "children": [
          {

            "label": "珠晖",
            "value": "430405",

          },
          {

            "label": "雁峰",
            "value": "430406",

          },
          {

            "label": "石鼓",
            "value": "430407",

          },
          {

            "label": "蒸湘",
            "value": "430408",

          },
          {

            "label": "南岳",
            "value": "430412",

          },
          {

            "label": "衡阳",
            "value": "430421",

          },
          {

            "label": "衡南",
            "value": "430422",

          },
          {

            "label": "衡山",
            "value": "430423",

          },
          {

            "label": "衡东",
            "value": "430424",

          },
          {

            "label": "祁东",
            "value": "430426",

          },
          {

            "label": "耒阳",
            "value": "430481",

          },
          {

            "label": "常宁",
            "value": "430482",

          }
        ]
      },
      {

        "label": "邵阳",
        "value": "430500",
        "children": [
          {

            "label": "双清",
            "value": "430502",

          },
          {

            "label": "大祥",
            "value": "430503",

          },
          {

            "label": "北塔",
            "value": "430511",

          },
          {

            "label": "邵东",
            "value": "430521",

          },
          {

            "label": "新邵",
            "value": "430522",

          },
          {

            "label": "邵阳",
            "value": "430523",

          },
          {

            "label": "隆回",
            "value": "430524",

          },
          {

            "label": "洞口",
            "value": "430525",

          },
          {

            "label": "绥宁",
            "value": "430527",

          },
          {

            "label": "新宁",
            "value": "430528",

          },
          {

            "label": "城步",
            "value": "430529",

          },
          {

            "label": "武冈",
            "value": "430581",

          }
        ]
      },
      {

        "label": "岳阳",
        "value": "430600",
        "children": [
          {

            "label": "岳阳楼",
            "value": "430602",

          },
          {

            "label": "云溪",
            "value": "430603",

          },
          {

            "label": "君山",
            "value": "430611",

          },
          {

            "label": "岳阳",
            "value": "430621",

          },
          {

            "label": "华容",
            "value": "430623",

          },
          {

            "label": "湘阴",
            "value": "430624",

          },
          {

            "label": "平江",
            "value": "430626",

          },
          {

            "label": "汨罗",
            "value": "430681",

          },
          {

            "label": "临湘",
            "value": "430682",

          }
        ]
      },
      {

        "label": "常德",
        "value": "430700",
        "children": [
          {

            "label": "武陵",
            "value": "430702",

          },
          {

            "label": "鼎城",
            "value": "430703",

          },
          {

            "label": "安乡",
            "value": "430721",

          },
          {

            "label": "汉寿",
            "value": "430722",

          },
          {

            "label": "澧县",
            "value": "430723",

          },
          {

            "label": "临澧",
            "value": "430724",

          },
          {

            "label": "桃源",
            "value": "430725",

          },
          {

            "label": "石门",
            "value": "430726",

          },
          {

            "label": "津市",
            "value": "430781",

          }
        ]
      },
      {

        "label": "张家界",
        "value": "430800",
        "children": [
          {

            "label": "永定",
            "value": "430802",

          },
          {

            "label": "武陵源",
            "value": "430811",

          },
          {

            "label": "慈利",
            "value": "430821",

          },
          {

            "label": "桑植",
            "value": "430822",

          }
        ]
      },
      {

        "label": "益阳",
        "value": "430900",
        "children": [
          {

            "label": "资阳",
            "value": "430902",

          },
          {

            "label": "赫山",
            "value": "430903",

          },
          {

            "label": "南县",
            "value": "430921",

          },
          {

            "label": "桃江",
            "value": "430922",

          },
          {

            "label": "安化",
            "value": "430923",

          },
          {

            "label": "沅江",
            "value": "430981",

          }
        ]
      },
      {

        "label": "郴州",
        "value": "431000",
        "children": [
          {

            "label": "北湖",
            "value": "431002",

          },
          {

            "label": "苏仙",
            "value": "431003",

          },
          {

            "label": "桂阳",
            "value": "431021",

          },
          {

            "label": "宜章",
            "value": "431022",

          },
          {

            "label": "永兴",
            "value": "431023",

          },
          {

            "label": "嘉禾",
            "value": "431024",

          },
          {

            "label": "临武",
            "value": "431025",

          },
          {

            "label": "汝城",
            "value": "431026",

          },
          {

            "label": "桂东",
            "value": "431027",

          },
          {

            "label": "安仁",
            "value": "431028",

          },
          {

            "label": "资兴",
            "value": "431081",

          }
        ]
      },
      {

        "label": "永州",
        "value": "431100",
        "children": [
          {

            "label": "零陵",
            "value": "431102",

          },
          {

            "label": "冷水滩",
            "value": "431103",

          },
          {

            "label": "祁阳",
            "value": "431121",

          },
          {

            "label": "东安",
            "value": "431122",

          },
          {

            "label": "双牌",
            "value": "431123",

          },
          {

            "label": "道县",
            "value": "431124",

          },
          {

            "label": "江永",
            "value": "431125",

          },
          {

            "label": "宁远",
            "value": "431126",

          },
          {

            "label": "蓝山",
            "value": "431127",

          },
          {

            "label": "新田",
            "value": "431128",

          },
          {

            "label": "江华",
            "value": "431129",

          }
        ]
      },
      {

        "label": "怀化",
        "value": "431200",
        "children": [
          {

            "label": "鹤城",
            "value": "431202",

          },
          {

            "label": "中方",
            "value": "431221",

          },
          {

            "label": "沅陵",
            "value": "431222",

          },
          {

            "label": "辰溪",
            "value": "431223",

          },
          {

            "label": "溆浦",
            "value": "431224",

          },
          {

            "label": "会同",
            "value": "431225",

          },
          {

            "label": "麻阳",
            "value": "431226",

          },
          {

            "label": "新晃",
            "value": "431227",

          },
          {

            "label": "芷江",
            "value": "431228",

          },
          {

            "label": "靖州",
            "value": "431229",

          },
          {

            "label": "通道",
            "value": "431230",

          },
          {

            "label": "洪江",
            "value": "431281",

          }
        ]
      },
      {

        "label": "娄底",
        "value": "431300",
        "children": [
          {

            "label": "娄星",
            "value": "431302",

          },
          {

            "label": "双峰",
            "value": "431321",

          },
          {

            "label": "新化",
            "value": "431322",

          },
          {

            "label": "冷水江",
            "value": "431381",

          },
          {

            "label": "涟源",
            "value": "431382",

          }
        ]
      },
      {

        "label": "湘西",
        "value": "433100",
        "children": [
          {

            "label": "吉首",
            "value": "433101",

          },
          {

            "label": "泸溪",
            "value": "433122",

          },
          {

            "label": "凤凰",
            "value": "433123",

          },
          {

            "label": "花垣",
            "value": "433124",

          },
          {

            "label": "保靖",
            "value": "433125",

          },
          {

            "label": "古丈",
            "value": "433126",

          },
          {

            "label": "永顺",
            "value": "433127",

          },
          {

            "label": "龙山",
            "value": "433130",

          }
        ]
      }
    ]
  },
  {

    "label": "广东",
    "value": "440000",
    "children": [
      {

        "label": "广州",
        "value": "440100",
        "children": [
          {

            "label": "荔湾",
            "value": "440103",

          },
          {

            "label": "越秀",
            "value": "440104",

          },
          {

            "label": "海珠",
            "value": "440105",

          },
          {

            "label": "天河",
            "value": "440106",

          },
          {

            "label": "白云",
            "value": "440111",

          },
          {

            "label": "黄埔",
            "value": "440112",

          },
          {

            "label": "番禺",
            "value": "440113",

          },
          {

            "label": "花都",
            "value": "440114",

          },
          {

            "label": "南沙",
            "value": "440115",

          },
          {

            "label": "从化",
            "value": "440117",

          },
          {

            "label": "增城",
            "value": "440118",

          }
        ]
      },
      {

        "label": "韶关",
        "value": "440200",
        "children": [
          {

            "label": "武江",
            "value": "440203",

          },
          {

            "label": "浈江",
            "value": "440204",

          },
          {

            "label": "曲江",
            "value": "440205",

          },
          {

            "label": "始兴",
            "value": "440222",

          },
          {

            "label": "仁化",
            "value": "440224",

          },
          {

            "label": "翁源",
            "value": "440229",

          },
          {

            "label": "乳源",
            "value": "440232",

          },
          {

            "label": "新丰",
            "value": "440233",

          },
          {

            "label": "乐昌",
            "value": "440281",

          },
          {

            "label": "南雄",
            "value": "440282",

          }
        ]
      },
      {

        "label": "深圳",
        "value": "440300",
        "children": [
          {

            "label": "罗湖",
            "value": "440303",

          },
          {

            "label": "福田",
            "value": "440304",

          },
          {

            "label": "南山",
            "value": "440305",

          },
          {

            "label": "宝安",
            "value": "440306",

          },
          {

            "label": "龙岗",
            "value": "440307",

          },
          {

            "label": "盐田",
            "value": "440308",

          },
          {

            "label": "光明新区",
            "value": "440309",

          },
          {

            "label": "坪山新区",
            "value": "440310",

          },
          {

            "label": "大鹏新区",
            "value": "440311",

          },
          {

            "label": "龙华新区",
            "value": "440312",

          }
        ]
      },
      {

        "label": "珠海",
        "value": "440400",
        "children": [
          {

            "label": "香洲",
            "value": "440402",

          },
          {

            "label": "斗门",
            "value": "440403",

          },
          {

            "label": "金湾",
            "value": "440404",

          }
        ]
      },
      {

        "label": "汕头",
        "value": "440500",
        "children": [
          {

            "label": "龙湖",
            "value": "440507",

          },
          {

            "label": "金平",
            "value": "440511",

          },
          {

            "label": "濠江",
            "value": "440512",

          },
          {

            "label": "潮阳",
            "value": "440513",

          },
          {

            "label": "潮南",
            "value": "440514",

          },
          {

            "label": "澄海",
            "value": "440515",

          },
          {

            "label": "南澳",
            "value": "440523",

          }
        ]
      },
      {

        "label": "佛山",
        "value": "440600",
        "children": [
          {

            "label": "禅城",
            "value": "440604",

          },
          {

            "label": "南海",
            "value": "440605",

          },
          {

            "label": "顺德",
            "value": "440606",

          },
          {

            "label": "三水",
            "value": "440607",

          },
          {

            "label": "高明",
            "value": "440608",

          }
        ]
      },
      {

        "label": "江门",
        "value": "440700",
        "children": [
          {

            "label": "蓬江",
            "value": "440703",

          },
          {

            "label": "江海",
            "value": "440704",

          },
          {

            "label": "新会",
            "value": "440705",

          },
          {

            "label": "台山",
            "value": "440781",

          },
          {

            "label": "开平",
            "value": "440783",

          },
          {

            "label": "鹤山",
            "value": "440784",

          },
          {

            "label": "恩平",
            "value": "440785",

          }
        ]
      },
      {

        "label": "湛江",
        "value": "440800",
        "children": [
          {

            "label": "赤坎",
            "value": "440802",

          },
          {

            "label": "霞山",
            "value": "440803",

          },
          {

            "label": "坡头",
            "value": "440804",

          },
          {

            "label": "麻章",
            "value": "440811",

          },
          {

            "label": "遂溪",
            "value": "440823",

          },
          {

            "label": "徐闻",
            "value": "440825",

          },
          {

            "label": "廉江",
            "value": "440881",

          },
          {

            "label": "雷州",
            "value": "440882",

          },
          {

            "label": "吴川",
            "value": "440883",

          }
        ]
      },
      {

        "label": "茂名",
        "value": "440900",
        "children": [
          {

            "label": "茂南",
            "value": "440902",

          },
          {

            "label": "电白",
            "value": "440904",

          },
          {

            "label": "高州",
            "value": "440981",

          },
          {

            "label": "化州",
            "value": "440982",

          },
          {

            "label": "信宜",
            "value": "440983",

          }
        ]
      },
      {

        "label": "肇庆",
        "value": "441200",
        "children": [
          {

            "label": "端州",
            "value": "441202",

          },
          {

            "label": "鼎湖",
            "value": "441203",

          },
          {

            "label": "广宁",
            "value": "441223",

          },
          {

            "label": "怀集",
            "value": "441224",

          },
          {

            "label": "封开",
            "value": "441225",

          },
          {

            "label": "德庆",
            "value": "441226",

          },
          {

            "label": "高要",
            "value": "441283",

          },
          {

            "label": "四会",
            "value": "441284",

          }
        ]
      },
      {

        "label": "惠州",
        "value": "441300",
        "children": [
          {

            "label": "惠城",
            "value": "441302",

          },
          {

            "label": "惠阳",
            "value": "441303",

          },
          {

            "label": "博罗",
            "value": "441322",

          },
          {

            "label": "惠东",
            "value": "441323",

          },
          {

            "label": "龙门",
            "value": "441324",

          }
        ]
      },
      {

        "label": "梅州",
        "value": "441400",
        "children": [
          {

            "label": "梅江",
            "value": "441402",

          },
          {

            "label": "梅县",
            "value": "441403",

          },
          {

            "label": "大埔",
            "value": "441422",

          },
          {

            "label": "丰顺",
            "value": "441423",

          },
          {

            "label": "五华",
            "value": "441424",

          },
          {

            "label": "平远",
            "value": "441426",

          },
          {

            "label": "蕉岭",
            "value": "441427",

          },
          {

            "label": "兴宁",
            "value": "441481",

          }
        ]
      },
      {

        "label": "汕尾",
        "value": "441500",
        "children": [
          {

            "label": "城区",
            "value": "441502",

          },
          {

            "label": "海丰",
            "value": "441521",

          },
          {

            "label": "陆河",
            "value": "441523",

          },
          {

            "label": "陆丰",
            "value": "441581",

          }
        ]
      },
      {

        "label": "河源",
        "value": "441600",
        "children": [
          {

            "label": "源城",
            "value": "441602",

          },
          {

            "label": "紫金",
            "value": "441621",

          },
          {

            "label": "龙川",
            "value": "441622",

          },
          {

            "label": "连平",
            "value": "441623",

          },
          {

            "label": "和平",
            "value": "441624",

          },
          {

            "label": "东源",
            "value": "441625",

          }
        ]
      },
      {

        "label": "阳江",
        "value": "441700",
        "children": [
          {

            "label": "江城",
            "value": "441702",

          },
          {

            "label": "阳东",
            "value": "441704",

          },
          {

            "label": "阳西",
            "value": "441721",

          },
          {

            "label": "阳春",
            "value": "441781",

          }
        ]
      },
      {

        "label": "清远",
        "value": "441800",
        "children": [
          {

            "label": "清城",
            "value": "441802",

          },
          {

            "label": "清新",
            "value": "441803",

          },
          {

            "label": "佛冈",
            "value": "441821",

          },
          {

            "label": "阳山",
            "value": "441823",

          },
          {

            "label": "连山",
            "value": "441825",

          },
          {

            "label": "连南",
            "value": "441826",

          },
          {

            "label": "英德",
            "value": "441881",

          },
          {

            "label": "连州",
            "value": "441882",

          }
        ]
      },
      {

        "label": "东莞",
        "value": "441900",
        "children": [
          {

            "label": "莞城",
            "value": "441901",

          },
          {

            "label": "南城",
            "value": "441902",

          },
          {

            "label": "万江",
            "value": "441904",

          },
          {

            "label": "石碣",
            "value": "441905",

          },
          {

            "label": "石龙",
            "value": "441906",

          },
          {

            "label": "茶山",
            "value": "441907",

          },
          {

            "label": "石排",
            "value": "441908",

          },
          {

            "label": "企石",
            "value": "441909",

          },
          {

            "label": "横沥",
            "value": "441910",

          },
          {

            "label": "桥头",
            "value": "441911",

          },
          {

            "label": "谢岗",
            "value": "441912",

          },
          {

            "label": "东坑",
            "value": "441913",

          },
          {

            "label": "常平",
            "value": "441914",

          },
          {

            "label": "寮步",
            "value": "441915",

          },
          {

            "label": "大朗",
            "value": "441916",

          },
          {

            "label": "麻涌",
            "value": "441917",

          },
          {

            "label": "中堂",
            "value": "441918",

          },
          {

            "label": "高埗",
            "value": "441919",

          },
          {

            "label": "樟木头",
            "value": "441920",

          },
          {

            "label": "大岭山",
            "value": "441921",

          },
          {

            "label": "望牛墩",
            "value": "441922",

          },
          {

            "label": "黄江",
            "value": "441923",

          },
          {

            "label": "洪梅",
            "value": "441924",

          },
          {

            "label": "清溪",
            "value": "441925",

          },
          {

            "label": "沙田",
            "value": "441926",

          },
          {

            "label": "道滘",
            "value": "441927",

          },
          {

            "label": "塘厦",
            "value": "441928",

          },
          {

            "label": "虎门",
            "value": "441929",

          },
          {

            "label": "厚街",
            "value": "441930",

          },
          {

            "label": "凤岗",
            "value": "441931",

          },
          {

            "label": "长安",
            "value": "441932",

          }
        ]
      },
      {

        "label": "中山",
        "value": "442000",
        "children": [
          {

            "label": "石岐",
            "value": "442001",

          },
          {

            "label": "南区",
            "value": "442004",

          },
          {

            "label": "五桂山",
            "value": "442005",

          },
          {

            "label": "火炬",
            "value": "442006",

          },
          {

            "label": "黄圃",
            "value": "442007",

          },
          {

            "label": "南头",
            "value": "442008",

          },
          {

            "label": "东凤",
            "value": "442009",

          },
          {

            "label": "阜沙",
            "value": "442010",

          },
          {

            "label": "小榄",
            "value": "442011",

          },
          {

            "label": "东升",
            "value": "442012",

          },
          {

            "label": "古镇",
            "value": "442013",

          },
          {

            "label": "横栏",
            "value": "442014",

          },
          {

            "label": "三角",
            "value": "442015",

          },
          {

            "label": "民众",
            "value": "442016",

          },
          {

            "label": "南朗",
            "value": "442017",

          },
          {

            "label": "港口",
            "value": "442018",

          },
          {

            "label": "大涌",
            "value": "442019",

          },
          {

            "label": "沙溪",
            "value": "442020",

          },
          {

            "label": "三乡",
            "value": "442021",

          },
          {

            "label": "板芙",
            "value": "442022",

          },
          {

            "label": "神湾",
            "value": "442023",

          },
          {

            "label": "坦洲",
            "value": "442024",

          }
        ]
      },
      {

        "label": "潮州",
        "value": "445100",
        "children": [
          {

            "label": "湘桥",
            "value": "445102",

          },
          {

            "label": "潮安",
            "value": "445103",

          },
          {

            "label": "饶平",
            "value": "445122",

          }
        ]
      },
      {

        "label": "揭阳",
        "value": "445200",
        "children": [
          {

            "label": "榕城",
            "value": "445202",

          },
          {

            "label": "揭东",
            "value": "445203",

          },
          {

            "label": "揭西",
            "value": "445222",

          },
          {

            "label": "惠来",
            "value": "445224",

          },
          {

            "label": "普宁",
            "value": "445281",

          }
        ]
      },
      {

        "label": "云浮",
        "value": "445300",
        "children": [
          {

            "label": "云城",
            "value": "445302",

          },
          {

            "label": "云安",
            "value": "445303",

          },
          {

            "label": "新兴",
            "value": "445321",

          },
          {

            "label": "郁南",
            "value": "445322",

          },
          {

            "label": "罗定",
            "value": "445381",

          }
        ]
      }
    ]
  },
  {

    "label": "广西",
    "value": "450000",
    "children": [
      {

        "label": "南宁",
        "value": "450100",
        "children": [
          {

            "label": "兴宁",
            "value": "450102",

          },
          {

            "label": "青秀",
            "value": "450103",

          },
          {

            "label": "江南",
            "value": "450105",

          },
          {

            "label": "西乡塘",
            "value": "450107",

          },
          {

            "label": "良庆",
            "value": "450108",

          },
          {

            "label": "邕宁",
            "value": "450109",

          },
          {

            "label": "武鸣",
            "value": "450122",

          },
          {

            "label": "隆安",
            "value": "450123",

          },
          {

            "label": "马山",
            "value": "450124",

          },
          {

            "label": "上林",
            "value": "450125",

          },
          {

            "label": "宾阳",
            "value": "450126",

          },
          {

            "label": "横县",
            "value": "450127",

          },
          {

            "label": "埌东",
            "value": "450128",

          }
        ]
      },
      {

        "label": "柳州",
        "value": "450200",
        "children": [
          {

            "label": "城中",
            "value": "450202",

          },
          {

            "label": "鱼峰",
            "value": "450203",

          },
          {

            "label": "柳南",
            "value": "450204",

          },
          {

            "label": "柳北",
            "value": "450205",

          },
          {

            "label": "柳江",
            "value": "450221",

          },
          {

            "label": "柳城",
            "value": "450222",

          },
          {

            "label": "鹿寨",
            "value": "450223",

          },
          {

            "label": "融安",
            "value": "450224",

          },
          {

            "label": "融水",
            "value": "450225",

          },
          {

            "label": "三江",
            "value": "450226",

          },
          {

            "label": "柳东",
            "value": "450227",

          }
        ]
      },
      {

        "label": "桂林",
        "value": "450300",
        "children": [
          {

            "label": "秀峰",
            "value": "450302",

          },
          {

            "label": "叠彩",
            "value": "450303",

          },
          {

            "label": "象山",
            "value": "450304",

          },
          {

            "label": "七星",
            "value": "450305",

          },
          {

            "label": "雁山",
            "value": "450311",

          },
          {

            "label": "临桂",
            "value": "450312",

          },
          {

            "label": "阳朔",
            "value": "450321",

          },
          {

            "label": "灵川",
            "value": "450323",

          },
          {

            "label": "全州",
            "value": "450324",

          },
          {

            "label": "兴安",
            "value": "450325",

          },
          {

            "label": "永福",
            "value": "450326",

          },
          {

            "label": "灌阳",
            "value": "450327",

          },
          {

            "label": "龙胜",
            "value": "450328",

          },
          {

            "label": "资源",
            "value": "450329",

          },
          {

            "label": "平乐",
            "value": "450330",

          },
          {

            "label": "荔浦",
            "value": "450331",

          },
          {

            "label": "恭城",
            "value": "450332",

          }
        ]
      },
      {

        "label": "梧州",
        "value": "450400",
        "children": [
          {

            "label": "万秀",
            "value": "450403",

          },
          {

            "label": "长洲",
            "value": "450405",

          },
          {

            "label": "龙圩",
            "value": "450406",

          },
          {

            "label": "苍梧",
            "value": "450421",

          },
          {

            "label": "藤县",
            "value": "450422",

          },
          {

            "label": "蒙山",
            "value": "450423",

          },
          {

            "label": "岑溪",
            "value": "450481",

          }
        ]
      },
      {

        "label": "北海",
        "value": "450500",
        "children": [
          {

            "label": "海城",
            "value": "450502",

          },
          {

            "label": "银海",
            "value": "450503",

          },
          {

            "label": "铁山港",
            "value": "450512",

          },
          {

            "label": "合浦",
            "value": "450521",

          }
        ]
      },
      {

        "label": "防城港",
        "value": "450600",
        "children": [
          {

            "label": "港口",
            "value": "450602",

          },
          {

            "label": "防城",
            "value": "450603",

          },
          {

            "label": "上思",
            "value": "450621",

          },
          {

            "label": "东兴",
            "value": "450681",

          }
        ]
      },
      {

        "label": "钦州",
        "value": "450700",
        "children": [
          {

            "label": "钦南",
            "value": "450702",

          },
          {

            "label": "钦北",
            "value": "450703",

          },
          {

            "label": "灵山",
            "value": "450721",

          },
          {

            "label": "浦北",
            "value": "450722",

          }
        ]
      },
      {

        "label": "贵港",
        "value": "450800",
        "children": [
          {

            "label": "港北",
            "value": "450802",

          },
          {

            "label": "港南",
            "value": "450803",

          },
          {

            "label": "覃塘",
            "value": "450804",

          },
          {

            "label": "平南",
            "value": "450821",

          },
          {

            "label": "桂平",
            "value": "450881",

          }
        ]
      },
      {

        "label": "玉林",
        "value": "450900",
        "children": [
          {

            "label": "玉州",
            "value": "450902",

          },
          {

            "label": "福绵",
            "value": "450903",

          },
          {

            "label": "玉东",
            "value": "450904",

          },
          {

            "label": "容县",
            "value": "450921",

          },
          {

            "label": "陆川",
            "value": "450922",

          },
          {

            "label": "博白",
            "value": "450923",

          },
          {

            "label": "兴业",
            "value": "450924",

          },
          {

            "label": "北流",
            "value": "450981",

          }
        ]
      },
      {

        "label": "百色",
        "value": "451000",
        "children": [
          {

            "label": "右江",
            "value": "451002",

          },
          {

            "label": "田阳",
            "value": "451021",

          },
          {

            "label": "田东",
            "value": "451022",

          },
          {

            "label": "平果",
            "value": "451023",

          },
          {

            "label": "德保",
            "value": "451024",

          },
          {

            "label": "靖西",
            "value": "451025",

          },
          {

            "label": "那坡",
            "value": "451026",

          },
          {

            "label": "凌云",
            "value": "451027",

          },
          {

            "label": "乐业",
            "value": "451028",

          },
          {

            "label": "田林",
            "value": "451029",

          },
          {

            "label": "西林",
            "value": "451030",

          },
          {

            "label": "隆林",
            "value": "451031",

          }
        ]
      },
      {

        "label": "贺州",
        "value": "451100",
        "children": [
          {

            "label": "八步",
            "value": "451102",

          },
          {

            "label": "昭平",
            "value": "451121",

          },
          {

            "label": "钟山",
            "value": "451122",

          },
          {

            "label": "富川",
            "value": "451123",

          },
          {

            "label": "平桂",
            "value": "451124",

          }
        ]
      },
      {

        "label": "河池",
        "value": "451200",
        "children": [
          {

            "label": "金城江",
            "value": "451202",

          },
          {

            "label": "南丹",
            "value": "451221",

          },
          {

            "label": "天峨",
            "value": "451222",

          },
          {

            "label": "凤山",
            "value": "451223",

          },
          {

            "label": "东兰",
            "value": "451224",

          },
          {

            "label": "罗城",
            "value": "451225",

          },
          {

            "label": "环江",
            "value": "451226",

          },
          {

            "label": "巴马",
            "value": "451227",

          },
          {

            "label": "都安",
            "value": "451228",

          },
          {

            "label": "大化",
            "value": "451229",

          },
          {

            "label": "宜州",
            "value": "451281",

          }
        ]
      },
      {

        "label": "来宾",
        "value": "451300",
        "children": [
          {

            "label": "兴宾",
            "value": "451302",

          },
          {

            "label": "忻城",
            "value": "451321",

          },
          {

            "label": "象州",
            "value": "451322",

          },
          {

            "label": "武宣",
            "value": "451323",

          },
          {

            "label": "金秀",
            "value": "451324",

          },
          {

            "label": "合山",
            "value": "451381",

          }
        ]
      },
      {

        "label": "崇左",
        "value": "451400",
        "children": [
          {

            "label": "江州",
            "value": "451402",

          },
          {

            "label": "扶绥",
            "value": "451421",

          },
          {

            "label": "宁明",
            "value": "451422",

          },
          {

            "label": "龙州",
            "value": "451423",

          },
          {

            "label": "大新",
            "value": "451424",

          },
          {

            "label": "天等",
            "value": "451425",

          },
          {

            "label": "凭祥",
            "value": "451481",

          }
        ]
      }
    ]
  },
  {

    "label": "海南",
    "value": "460000",
    "children": [
      {

        "label": "海口",
        "value": "460100",
        "children": [
          {

            "label": "秀英",
            "value": "460105",

          },
          {

            "label": "龙华",
            "value": "460106",

          },
          {

            "label": "琼山",
            "value": "460107",

          },
          {

            "label": "美兰",
            "value": "460108",

          }
        ]
      },
      {

        "label": "三亚",
        "value": "460200",
        "children": [
          {

            "label": "海棠",
            "value": "460202",

          },
          {

            "label": "吉阳",
            "value": "460203",

          },
          {

            "label": "天涯",
            "value": "460204",

          },
          {

            "label": "崖州",
            "value": "460205",

          }
        ]
      },
      {

        "label": "三沙",
        "value": "460300",
        "children": [
          {

            "label": "西沙",
            "value": "460321",

          },
          {

            "label": "南沙",
            "value": "460322",

          },
          {

            "label": "中沙",
            "value": "460323",

          }
        ]
      },
      {

        "label": " ",
        "value": "469000",
        "children": [
          {

            "label": "五指山",
            "value": "469001",

          },
          {

            "label": "琼海",
            "value": "469002",

          },
          {

            "label": "儋州",
            "value": "469003",

          },
          {

            "label": "文昌",
            "value": "469005",

          },
          {

            "label": "万宁",
            "value": "469006",

          },
          {

            "label": "东方",
            "value": "469007",

          },
          {

            "label": "定安",
            "value": "469021",

          },
          {

            "label": "屯昌",
            "value": "469022",

          },
          {

            "label": "澄迈",
            "value": "469023",

          },
          {

            "label": "临高",
            "value": "469024",

          },
          {

            "label": "白沙",
            "value": "469025",

          },
          {

            "label": "昌江",
            "value": "469026",

          },
          {

            "label": "乐东",
            "value": "469027",

          },
          {

            "label": "陵水",
            "value": "469028",

          },
          {

            "label": "保亭",
            "value": "469029",

          },
          {

            "label": "琼中",
            "value": "469030",

          }
        ]
      }
    ]
  },
  {

    "label": "重庆",
    "value": "500000",
    "children": [
      {

        "label": "重庆市",
        "value": "500100",
        "children": [
          {

            "label": "万州",
            "value": "500101",

          },
          {

            "label": "涪陵",
            "value": "500102",

          },
          {

            "label": "渝中",
            "value": "500103",

          },
          {

            "label": "大渡口",
            "value": "500104",

          },
          {

            "label": "江北",
            "value": "500105",

          },
          {

            "label": "沙坪坝",
            "value": "500106",

          },
          {

            "label": "九龙坡",
            "value": "500107",

          },
          {

            "label": "南岸",
            "value": "500108",

          },
          {

            "label": "北碚",
            "value": "500109",

          },
          {

            "label": "綦江",
            "value": "500110",

          },
          {

            "label": "大足",
            "value": "500111",

          },
          {

            "label": "渝北",
            "value": "500112",

          },
          {

            "label": "巴南",
            "value": "500113",

          },
          {

            "label": "黔江",
            "value": "500114",

          },
          {

            "label": "长寿",
            "value": "500115",

          },
          {

            "label": "江津",
            "value": "500116",

          },
          {

            "label": "合川",
            "value": "500117",

          },
          {

            "label": "永川",
            "value": "500118",

          },
          {

            "label": "南川",
            "value": "500119",

          },
          {

            "label": "璧山",
            "value": "500120",

          },
          {

            "label": "铜梁",
            "value": "500151",

          },
          {

            "label": "潼南",
            "value": "500223",

          },
          {

            "label": "荣昌",
            "value": "500226",

          },
          {

            "label": "梁平",
            "value": "500228",

          },
          {

            "label": "城口",
            "value": "500229",

          },
          {

            "label": "丰都",
            "value": "500230",

          },
          {

            "label": "垫江",
            "value": "500231",

          },
          {

            "label": "武隆",
            "value": "500232",

          },
          {

            "label": "忠县",
            "value": "500233",

          },
          {

            "label": "开县",
            "value": "500234",

          },
          {

            "label": "云阳",
            "value": "500235",

          },
          {

            "label": "奉节",
            "value": "500236",

          },
          {

            "label": "巫山",
            "value": "500237",

          },
          {

            "label": "巫溪",
            "value": "500238",

          },
          {

            "label": "石柱",
            "value": "500240",

          },
          {

            "label": "秀山",
            "value": "500241",

          },
          {

            "label": "酉阳",
            "value": "500242",

          },
          {

            "label": "彭水",
            "value": "500243",

          }
        ]
      },
      {

        "label": "两江新区",
        "value": "500300",
        "children": [
          {

            "label": "北部新区",
            "value": "500301",

          },
          {

            "label": "保税港区",
            "value": "500302",

          },
          {

            "label": "工业园区",
            "value": "500303",

          }
        ]
      }
    ]
  },
  {

    "label": "四川",
    "value": "510000",
    "children": [
      {

        "label": "成都",
        "value": "510100",
        "children": [
          {

            "label": "锦江",
            "value": "510104",

          },
          {

            "label": "青羊",
            "value": "510105",

          },
          {

            "label": "金牛",
            "value": "510106",

          },
          {

            "label": "武侯",
            "value": "510107",

          },
          {

            "label": "成华",
            "value": "510108",

          },
          {

            "label": "龙泉驿",
            "value": "510112",

          },
          {

            "label": "青白江",
            "value": "510113",

          },
          {

            "label": "新都",
            "value": "510114",

          },
          {

            "label": "温江",
            "value": "510115",

          },
          {

            "label": "金堂",
            "value": "510121",

          },
          {

            "label": "双流",
            "value": "510122",

          },
          {

            "label": "郫县",
            "value": "510124",

          },
          {

            "label": "大邑",
            "value": "510129",

          },
          {

            "label": "蒲江",
            "value": "510131",

          },
          {

            "label": "新津",
            "value": "510132",

          },
          {

            "label": "都江堰",
            "value": "510181",

          },
          {

            "label": "彭州",
            "value": "510182",

          },
          {

            "label": "邛崃",
            "value": "510183",

          },
          {

            "label": "崇州",
            "value": "510184",

          }
        ]
      },
      {

        "label": "自贡",
        "value": "510300",
        "children": [
          {

            "label": "自流井",
            "value": "510302",

          },
          {

            "label": "贡井",
            "value": "510303",

          },
          {

            "label": "大安",
            "value": "510304",

          },
          {

            "label": "沿滩",
            "value": "510311",

          },
          {

            "label": "荣县",
            "value": "510321",

          },
          {

            "label": "富顺",
            "value": "510322",

          }
        ]
      },
      {

        "label": "攀枝花",
        "value": "510400",
        "children": [
          {

            "label": "东区",
            "value": "510402",

          },
          {

            "label": "西区",
            "value": "510403",

          },
          {

            "label": "仁和",
            "value": "510411",

          },
          {

            "label": "米易",
            "value": "510421",

          },
          {

            "label": "盐边",
            "value": "510422",

          }
        ]
      },
      {

        "label": "泸州",
        "value": "510500",
        "children": [
          {

            "label": "江阳",
            "value": "510502",

          },
          {

            "label": "纳溪",
            "value": "510503",

          },
          {

            "label": "龙马潭",
            "value": "510504",

          },
          {

            "label": "泸县",
            "value": "510521",

          },
          {

            "label": "合江",
            "value": "510522",

          },
          {

            "label": "叙永",
            "value": "510524",

          },
          {

            "label": "古蔺",
            "value": "510525",

          }
        ]
      },
      {

        "label": "德阳",
        "value": "510600",
        "children": [
          {

            "label": "旌阳",
            "value": "510603",

          },
          {

            "label": "中江",
            "value": "510623",

          },
          {

            "label": "罗江",
            "value": "510626",

          },
          {

            "label": "广汉",
            "value": "510681",

          },
          {

            "label": "什邡",
            "value": "510682",

          },
          {

            "label": "绵竹",
            "value": "510683",

          }
        ]
      },
      {

        "label": "绵阳",
        "value": "510700",
        "children": [
          {

            "label": "涪城",
            "value": "510703",

          },
          {

            "label": "游仙",
            "value": "510704",

          },
          {

            "label": "三台",
            "value": "510722",

          },
          {

            "label": "盐亭",
            "value": "510723",

          },
          {

            "label": "安县",
            "value": "510724",

          },
          {

            "label": "梓潼",
            "value": "510725",

          },
          {

            "label": "北川",
            "value": "510726",

          },
          {

            "label": "平武",
            "value": "510727",

          },
          {

            "label": "江油",
            "value": "510781",

          }
        ]
      },
      {

        "label": "广元",
        "value": "510800",
        "children": [
          {

            "label": "利州",
            "value": "510802",

          },
          {

            "label": "昭化",
            "value": "510811",

          },
          {

            "label": "朝天",
            "value": "510812",

          },
          {

            "label": "旺苍",
            "value": "510821",

          },
          {

            "label": "青川",
            "value": "510822",

          },
          {

            "label": "剑阁",
            "value": "510823",

          },
          {

            "label": "苍溪",
            "value": "510824",

          }
        ]
      },
      {

        "label": "遂宁",
        "value": "510900",
        "children": [
          {

            "label": "船山",
            "value": "510903",

          },
          {

            "label": "安居",
            "value": "510904",

          },
          {

            "label": "蓬溪",
            "value": "510921",

          },
          {

            "label": "射洪",
            "value": "510922",

          },
          {

            "label": "大英",
            "value": "510923",

          }
        ]
      },
      {

        "label": "内江",
        "value": "511000",
        "children": [
          {

            "label": "市中区",
            "value": "511002",

          },
          {

            "label": "东兴",
            "value": "511011",

          },
          {

            "label": "威远",
            "value": "511024",

          },
          {

            "label": "资中",
            "value": "511025",

          },
          {

            "label": "隆昌",
            "value": "511028",

          }
        ]
      },
      {

        "label": "乐山",
        "value": "511100",
        "children": [
          {

            "label": "市中区",
            "value": "511102",

          },
          {

            "label": "沙湾",
            "value": "511111",

          },
          {

            "label": "五通桥",
            "value": "511112",

          },
          {

            "label": "金口河",
            "value": "511113",

          },
          {

            "label": "犍为",
            "value": "511123",

          },
          {

            "label": "井研",
            "value": "511124",

          },
          {

            "label": "夹江",
            "value": "511126",

          },
          {

            "label": "沐川",
            "value": "511129",

          },
          {

            "label": "峨边",
            "value": "511132",

          },
          {

            "label": "马边",
            "value": "511133",

          },
          {

            "label": "峨眉山",
            "value": "511181",

          }
        ]
      },
      {

        "label": "南充",
        "value": "511300",
        "children": [
          {

            "label": "顺庆",
            "value": "511302",

          },
          {

            "label": "高坪",
            "value": "511303",

          },
          {

            "label": "嘉陵",
            "value": "511304",

          },
          {

            "label": "南部",
            "value": "511321",

          },
          {

            "label": "营山",
            "value": "511322",

          },
          {

            "label": "蓬安",
            "value": "511323",

          },
          {

            "label": "仪陇",
            "value": "511324",

          },
          {

            "label": "西充",
            "value": "511325",

          },
          {

            "label": "阆中",
            "value": "511381",

          }
        ]
      },
      {

        "label": "眉山",
        "value": "511400",
        "children": [
          {

            "label": "东坡",
            "value": "511402",

          },
          {

            "label": "彭山",
            "value": "511403",

          },
          {

            "label": "仁寿",
            "value": "511421",

          },
          {

            "label": "洪雅",
            "value": "511423",

          },
          {

            "label": "丹棱",
            "value": "511424",

          },
          {

            "label": "青神",
            "value": "511425",

          }
        ]
      },
      {

        "label": "宜宾",
        "value": "511500",
        "children": [
          {

            "label": "翠屏",
            "value": "511502",

          },
          {

            "label": "南溪",
            "value": "511503",

          },
          {

            "label": "宜宾",
            "value": "511521",

          },
          {

            "label": "江安",
            "value": "511523",

          },
          {

            "label": "长宁",
            "value": "511524",

          },
          {

            "label": "高县",
            "value": "511525",

          },
          {

            "label": "珙县",
            "value": "511526",

          },
          {

            "label": "筠连",
            "value": "511527",

          },
          {

            "label": "兴文",
            "value": "511528",

          },
          {

            "label": "屏山",
            "value": "511529",

          }
        ]
      },
      {

        "label": "广安",
        "value": "511600",
        "children": [
          {

            "label": "广安",
            "value": "511602",

          },
          {

            "label": "前锋",
            "value": "511603",

          },
          {

            "label": "岳池",
            "value": "511621",

          },
          {

            "label": "武胜",
            "value": "511622",

          },
          {

            "label": "邻水",
            "value": "511623",

          },
          {

            "label": "华蓥",
            "value": "511681",

          }
        ]
      },
      {

        "label": "达州",
        "value": "511700",
        "children": [
          {

            "label": "通川",
            "value": "511702",

          },
          {

            "label": "达川",
            "value": "511703",

          },
          {

            "label": "宣汉",
            "value": "511722",

          },
          {

            "label": "开江",
            "value": "511723",

          },
          {

            "label": "大竹",
            "value": "511724",

          },
          {

            "label": "渠县",
            "value": "511725",

          },
          {

            "label": "万源",
            "value": "511781",

          }
        ]
      },
      {

        "label": "雅安",
        "value": "511800",
        "children": [
          {

            "label": "雨城",
            "value": "511802",

          },
          {

            "label": "名山",
            "value": "511803",

          },
          {

            "label": "荥经",
            "value": "511822",

          },
          {

            "label": "汉源",
            "value": "511823",

          },
          {

            "label": "石棉",
            "value": "511824",

          },
          {

            "label": "天全",
            "value": "511825",

          },
          {

            "label": "芦山",
            "value": "511826",

          },
          {

            "label": "宝兴",
            "value": "511827",

          }
        ]
      },
      {

        "label": "巴中",
        "value": "511900",
        "children": [
          {

            "label": "巴州",
            "value": "511902",

          },
          {

            "label": "恩阳",
            "value": "511903",

          },
          {

            "label": "通江",
            "value": "511921",

          },
          {

            "label": "南江",
            "value": "511922",

          },
          {

            "label": "平昌",
            "value": "511923",

          }
        ]
      },
      {

        "label": "资阳",
        "value": "512000",
        "children": [
          {

            "label": "雁江",
            "value": "512002",

          },
          {

            "label": "安岳",
            "value": "512021",

          },
          {

            "label": "乐至",
            "value": "512022",

          },
          {

            "label": "简阳",
            "value": "512081",

          }
        ]
      },
      {

        "label": "阿坝",
        "value": "513200",
        "children": [
          {

            "label": "汶川",
            "value": "513221",

          },
          {

            "label": "理县",
            "value": "513222",

          },
          {

            "label": "茂县",
            "value": "513223",

          },
          {

            "label": "松潘",
            "value": "513224",

          },
          {

            "label": "九寨沟",
            "value": "513225",

          },
          {

            "label": "金川",
            "value": "513226",

          },
          {

            "label": "小金",
            "value": "513227",

          },
          {

            "label": "黑水",
            "value": "513228",

          },
          {

            "label": "马尔康",
            "value": "513229",

          },
          {

            "label": "壤塘",
            "value": "513230",

          },
          {

            "label": "阿坝",
            "value": "513231",

          },
          {

            "label": "若尔盖",
            "value": "513232",

          },
          {

            "label": "红原",
            "value": "513233",

          }
        ]
      },
      {

        "label": "甘孜",
        "value": "513300",
        "children": [
          {

            "label": "康定",
            "value": "513321",

          },
          {

            "label": "泸定",
            "value": "513322",

          },
          {

            "label": "丹巴",
            "value": "513323",

          },
          {

            "label": "九龙",
            "value": "513324",

          },
          {

            "label": "雅江",
            "value": "513325",

          },
          {

            "label": "道孚",
            "value": "513326",

          },
          {

            "label": "炉霍",
            "value": "513327",

          },
          {

            "label": "甘孜",
            "value": "513328",

          },
          {

            "label": "新龙",
            "value": "513329",

          },
          {

            "label": "德格",
            "value": "513330",

          },
          {

            "label": "白玉",
            "value": "513331",

          },
          {

            "label": "石渠",
            "value": "513332",

          },
          {

            "label": "色达",
            "value": "513333",

          },
          {

            "label": "理塘",
            "value": "513334",

          },
          {

            "label": "巴塘",
            "value": "513335",

          },
          {

            "label": "乡城",
            "value": "513336",

          },
          {

            "label": "稻城",
            "value": "513337",

          },
          {

            "label": "得荣",
            "value": "513338",

          }
        ]
      },
      {

        "label": "凉山",
        "value": "513400",
        "children": [
          {

            "label": "西昌",
            "value": "513401",

          },
          {

            "label": "木里",
            "value": "513422",

          },
          {

            "label": "盐源",
            "value": "513423",

          },
          {

            "label": "德昌",
            "value": "513424",

          },
          {

            "label": "会理",
            "value": "513425",

          },
          {

            "label": "会东",
            "value": "513426",

          },
          {

            "label": "宁南",
            "value": "513427",

          },
          {

            "label": "普格",
            "value": "513428",

          },
          {

            "label": "布拖",
            "value": "513429",

          },
          {

            "label": "金阳",
            "value": "513430",

          },
          {

            "label": "昭觉",
            "value": "513431",

          },
          {

            "label": "喜德",
            "value": "513432",

          },
          {

            "label": "冕宁",
            "value": "513433",

          },
          {

            "label": "越西",
            "value": "513434",

          },
          {

            "label": "甘洛",
            "value": "513435",

          },
          {

            "label": "美姑",
            "value": "513436",

          },
          {

            "label": "雷波",
            "value": "513437",

          }
        ]
      }
    ]
  },
  {

    "label": "贵州",
    "value": "520000",
    "children": [
      {

        "label": "贵阳",
        "value": "520100",
        "children": [
          {

            "label": "南明",
            "value": "520102",

          },
          {

            "label": "云岩",
            "value": "520103",

          },
          {

            "label": "花溪",
            "value": "520111",

          },
          {

            "label": "乌当",
            "value": "520112",

          },
          {

            "label": "白云",
            "value": "520113",

          },
          {

            "label": "观山湖",
            "value": "520115",

          },
          {

            "label": "开阳",
            "value": "520121",

          },
          {

            "label": "息烽",
            "value": "520122",

          },
          {

            "label": "修文",
            "value": "520123",

          },
          {

            "label": "清镇",
            "value": "520181",

          }
        ]
      },
      {

        "label": "六盘水",
        "value": "520200",
        "children": [
          {

            "label": "钟山",
            "value": "520201",

          },
          {

            "label": "六枝",
            "value": "520203",

          },
          {

            "label": "水城",
            "value": "520221",

          },
          {

            "label": "盘县",
            "value": "520222",

          }
        ]
      },
      {

        "label": "遵义",
        "value": "520300",
        "children": [
          {

            "label": "红花岗",
            "value": "520302",

          },
          {

            "label": "汇川",
            "value": "520303",

          },
          {

            "label": "遵义",
            "value": "520321",

          },
          {

            "label": "桐梓",
            "value": "520322",

          },
          {

            "label": "绥阳",
            "value": "520323",

          },
          {

            "label": "正安",
            "value": "520324",

          },
          {

            "label": "道真",
            "value": "520325",

          },
          {

            "label": "务川",
            "value": "520326",

          },
          {

            "label": "凤冈",
            "value": "520327",

          },
          {

            "label": "湄潭",
            "value": "520328",

          },
          {

            "label": "余庆",
            "value": "520329",

          },
          {

            "label": "习水",
            "value": "520330",

          },
          {

            "label": "赤水",
            "value": "520381",

          },
          {

            "label": "仁怀",
            "value": "520382",

          }
        ]
      },
      {

        "label": "安顺",
        "value": "520400",
        "children": [
          {

            "label": "西秀",
            "value": "520402",

          },
          {

            "label": "平坝",
            "value": "520421",

          },
          {

            "label": "普定",
            "value": "520422",

          },
          {

            "label": "镇宁",
            "value": "520423",

          },
          {

            "label": "关岭",
            "value": "520424",

          },
          {

            "label": "紫云",
            "value": "520425",

          }
        ]
      },
      {

        "label": "毕节",
        "value": "520500",
        "children": [
          {

            "label": "七星关",
            "value": "520502",

          },
          {

            "label": "大方",
            "value": "520521",

          },
          {

            "label": "黔西",
            "value": "520522",

          },
          {

            "label": "金沙",
            "value": "520523",

          },
          {

            "label": "织金",
            "value": "520524",

          },
          {

            "label": "纳雍",
            "value": "520525",

          },
          {

            "label": "威宁",
            "value": "520526",

          },
          {

            "label": "赫章",
            "value": "520527",

          }
        ]
      },
      {

        "label": "铜仁",
        "value": "520600",
        "children": [
          {

            "label": "碧江",
            "value": "520602",

          },
          {

            "label": "万山",
            "value": "520603",

          },
          {

            "label": "江口",
            "value": "520621",

          },
          {

            "label": "玉屏",
            "value": "520622",

          },
          {

            "label": "石阡",
            "value": "520623",

          },
          {

            "label": "思南",
            "value": "520624",

          },
          {

            "label": "印江",
            "value": "520625",

          },
          {

            "label": "德江",
            "value": "520626",

          },
          {

            "label": "沿河",
            "value": "520627",

          },
          {

            "label": "松桃",
            "value": "520628",

          }
        ]
      },
      {

        "label": "黔西南",
        "value": "522300",
        "children": [
          {

            "label": "兴义",
            "value": "522301",

          },
          {

            "label": "兴仁",
            "value": "522322",

          },
          {

            "label": "普安",
            "value": "522323",

          },
          {

            "label": "晴隆",
            "value": "522324",

          },
          {

            "label": "贞丰",
            "value": "522325",

          },
          {

            "label": "望谟",
            "value": "522326",

          },
          {

            "label": "册亨",
            "value": "522327",

          },
          {

            "label": "安龙",
            "value": "522328",

          }
        ]
      },
      {

        "label": "黔东南",
        "value": "522600",
        "children": [
          {

            "label": "凯里",
            "value": "522601",

          },
          {

            "label": "黄平",
            "value": "522622",

          },
          {

            "label": "施秉",
            "value": "522623",

          },
          {

            "label": "三穗",
            "value": "522624",

          },
          {

            "label": "镇远",
            "value": "522625",

          },
          {

            "label": "岑巩",
            "value": "522626",

          },
          {

            "label": "天柱",
            "value": "522627",

          },
          {

            "label": "锦屏",
            "value": "522628",

          },
          {

            "label": "剑河",
            "value": "522629",

          },
          {

            "label": "台江",
            "value": "522630",

          },
          {

            "label": "黎平",
            "value": "522631",

          },
          {

            "label": "榕江",
            "value": "522632",

          },
          {

            "label": "从江",
            "value": "522633",

          },
          {

            "label": "雷山",
            "value": "522634",

          },
          {

            "label": "麻江",
            "value": "522635",

          },
          {

            "label": "丹寨",
            "value": "522636",

          }
        ]
      },
      {

        "label": "黔南",
        "value": "522700",
        "children": [
          {

            "label": "都匀",
            "value": "522701",

          },
          {

            "label": "福泉",
            "value": "522702",

          },
          {

            "label": "荔波",
            "value": "522722",

          },
          {

            "label": "贵定",
            "value": "522723",

          },
          {

            "label": "瓮安",
            "value": "522725",

          },
          {

            "label": "独山",
            "value": "522726",

          },
          {

            "label": "平塘",
            "value": "522727",

          },
          {

            "label": "罗甸",
            "value": "522728",

          },
          {

            "label": "长顺",
            "value": "522729",

          },
          {

            "label": "龙里",
            "value": "522730",

          },
          {

            "label": "惠水",
            "value": "522731",

          },
          {

            "label": "三都",
            "value": "522732",

          }
        ]
      }
    ]
  },
  {

    "label": "云南",
    "value": "530000",
    "children": [
      {

        "label": "昆明",
        "value": "530100",
        "children": [
          {

            "label": "五华",
            "value": "530102",

          },
          {

            "label": "盘龙",
            "value": "530103",

          },
          {

            "label": "官渡",
            "value": "530111",

          },
          {

            "label": "西山",
            "value": "530112",

          },
          {

            "label": "东川",
            "value": "530113",

          },
          {

            "label": "呈贡",
            "value": "530114",

          },
          {

            "label": "晋宁",
            "value": "530122",

          },
          {

            "label": "富民",
            "value": "530124",

          },
          {

            "label": "宜良",
            "value": "530125",

          },
          {

            "label": "石林",
            "value": "530126",

          },
          {

            "label": "嵩明",
            "value": "530127",

          },
          {

            "label": "禄劝",
            "value": "530128",

          },
          {

            "label": "寻甸",
            "value": "530129",

          },
          {

            "label": "安宁",
            "value": "530181",

          }
        ]
      },
      {

        "label": "曲靖",
        "value": "530300",
        "children": [
          {

            "label": "麒麟",
            "value": "530302",

          },
          {

            "label": "马龙",
            "value": "530321",

          },
          {

            "label": "陆良",
            "value": "530322",

          },
          {

            "label": "师宗",
            "value": "530323",

          },
          {

            "label": "罗平",
            "value": "530324",

          },
          {

            "label": "富源",
            "value": "530325",

          },
          {

            "label": "会泽",
            "value": "530326",

          },
          {

            "label": "沾益",
            "value": "530328",

          },
          {

            "label": "宣威",
            "value": "530381",

          }
        ]
      },
      {

        "label": "玉溪",
        "value": "530400",
        "children": [
          {

            "label": "红塔",
            "value": "530402",

          },
          {

            "label": "江川",
            "value": "530421",

          },
          {

            "label": "澄江",
            "value": "530422",

          },
          {

            "label": "通海",
            "value": "530423",

          },
          {

            "label": "华宁",
            "value": "530424",

          },
          {

            "label": "易门",
            "value": "530425",

          },
          {

            "label": "峨山",
            "value": "530426",

          },
          {

            "label": "新平",
            "value": "530427",

          },
          {

            "label": "元江",
            "value": "530428",

          }
        ]
      },
      {

        "label": "保山",
        "value": "530500",
        "children": [
          {

            "label": "隆阳",
            "value": "530502",

          },
          {

            "label": "施甸",
            "value": "530521",

          },
          {

            "label": "腾冲",
            "value": "530522",

          },
          {

            "label": "龙陵",
            "value": "530523",

          },
          {

            "label": "昌宁",
            "value": "530524",

          }
        ]
      },
      {

        "label": "昭通",
        "value": "530600",
        "children": [
          {

            "label": "昭阳",
            "value": "530602",

          },
          {

            "label": "鲁甸",
            "value": "530621",

          },
          {

            "label": "巧家",
            "value": "530622",

          },
          {

            "label": "盐津",
            "value": "530623",

          },
          {

            "label": "大关",
            "value": "530624",

          },
          {

            "label": "永善",
            "value": "530625",

          },
          {

            "label": "绥江",
            "value": "530626",

          },
          {

            "label": "镇雄",
            "value": "530627",

          },
          {

            "label": "彝良",
            "value": "530628",

          },
          {

            "label": "威信",
            "value": "530629",

          },
          {

            "label": "水富",
            "value": "530630",

          }
        ]
      },
      {

        "label": "丽江",
        "value": "530700",
        "children": [
          {

            "label": "古城",
            "value": "530702",

          },
          {

            "label": "玉龙",
            "value": "530721",

          },
          {

            "label": "永胜",
            "value": "530722",

          },
          {

            "label": "华坪",
            "value": "530723",

          },
          {

            "label": "宁蒗",
            "value": "530724",

          }
        ]
      },
      {

        "label": "普洱",
        "value": "530800",
        "children": [
          {

            "label": "思茅",
            "value": "530802",

          },
          {

            "label": "宁洱",
            "value": "530821",

          },
          {

            "label": "墨江",
            "value": "530822",

          },
          {

            "label": "景东",
            "value": "530823",

          },
          {

            "label": "景谷",
            "value": "530824",

          },
          {

            "label": "镇沅",
            "value": "530825",

          },
          {

            "label": "江城",
            "value": "530826",

          },
          {

            "label": "孟连",
            "value": "530827",

          },
          {

            "label": "澜沧",
            "value": "530828",

          },
          {

            "label": "西盟",
            "value": "530829",

          }
        ]
      },
      {

        "label": "临沧",
        "value": "530900",
        "children": [
          {

            "label": "临翔",
            "value": "530902",

          },
          {

            "label": "凤庆",
            "value": "530921",

          },
          {

            "label": "云县",
            "value": "530922",

          },
          {

            "label": "永德",
            "value": "530923",

          },
          {

            "label": "镇康",
            "value": "530924",

          },
          {

            "label": "双江",
            "value": "530925",

          },
          {

            "label": "耿马",
            "value": "530926",

          },
          {

            "label": "沧源",
            "value": "530927",

          }
        ]
      },
      {

        "label": "楚雄",
        "value": "532300",
        "children": [
          {

            "label": "楚雄",
            "value": "532301",

          },
          {

            "label": "双柏",
            "value": "532322",

          },
          {

            "label": "牟定",
            "value": "532323",

          },
          {

            "label": "南华",
            "value": "532324",

          },
          {

            "label": "姚安",
            "value": "532325",

          },
          {

            "label": "大姚",
            "value": "532326",

          },
          {

            "label": "永仁",
            "value": "532327",

          },
          {

            "label": "元谋",
            "value": "532328",

          },
          {

            "label": "武定",
            "value": "532329",

          },
          {

            "label": "禄丰",
            "value": "532331",

          }
        ]
      },
      {

        "label": "红河",
        "value": "532500",
        "children": [
          {

            "label": "个旧",
            "value": "532501",

          },
          {

            "label": "开远",
            "value": "532502",

          },
          {

            "label": "蒙自",
            "value": "532503",

          },
          {

            "label": "弥勒",
            "value": "532504",

          },
          {

            "label": "屏边",
            "value": "532523",

          },
          {

            "label": "建水",
            "value": "532524",

          },
          {

            "label": "石屏",
            "value": "532525",

          },
          {

            "label": "泸西",
            "value": "532527",

          },
          {

            "label": "元阳",
            "value": "532528",

          },
          {

            "label": "红河县",
            "value": "532529",

          },
          {

            "label": "金平",
            "value": "532530",

          },
          {

            "label": "绿春",
            "value": "532531",

          },
          {

            "label": "河口",
            "value": "532532",

          }
        ]
      },
      {

        "label": "文山",
        "value": "532600",
        "children": [
          {

            "label": "文山",
            "value": "532601",

          },
          {

            "label": "砚山",
            "value": "532622",

          },
          {

            "label": "西畴",
            "value": "532623",

          },
          {

            "label": "麻栗坡",
            "value": "532624",

          },
          {

            "label": "马关",
            "value": "532625",

          },
          {

            "label": "丘北",
            "value": "532626",

          },
          {

            "label": "广南",
            "value": "532627",

          },
          {

            "label": "富宁",
            "value": "532628",

          }
        ]
      },
      {

        "label": "西双版纳",
        "value": "532800",
        "children": [
          {

            "label": "景洪",
            "value": "532801",

          },
          {

            "label": "勐海",
            "value": "532822",

          },
          {

            "label": "勐腊",
            "value": "532823",

          }
        ]
      },
      {

        "label": "大理",
        "value": "532900",
        "children": [
          {

            "label": "大理",
            "value": "532901",

          },
          {

            "label": "漾濞",
            "value": "532922",

          },
          {

            "label": "祥云",
            "value": "532923",

          },
          {

            "label": "宾川",
            "value": "532924",

          },
          {

            "label": "弥渡",
            "value": "532925",

          },
          {

            "label": "南涧",
            "value": "532926",

          },
          {

            "label": "巍山",
            "value": "532927",

          },
          {

            "label": "永平",
            "value": "532928",

          },
          {

            "label": "云龙",
            "value": "532929",

          },
          {

            "label": "洱源",
            "value": "532930",

          },
          {

            "label": "剑川",
            "value": "532931",

          },
          {

            "label": "鹤庆",
            "value": "532932",

          }
        ]
      },
      {

        "label": "德宏",
        "value": "533100",
        "children": [
          {

            "label": "瑞丽",
            "value": "533102",

          },
          {

            "label": "芒市",
            "value": "533103",

          },
          {

            "label": "梁河",
            "value": "533122",

          },
          {

            "label": "盈江",
            "value": "533123",

          },
          {

            "label": "陇川",
            "value": "533124",

          }
        ]
      },
      {

        "label": "怒江",
        "value": "533300",
        "children": [
          {

            "label": "泸水",
            "value": "533321",

          },
          {

            "label": "福贡",
            "value": "533323",

          },
          {

            "label": "贡山",
            "value": "533324",

          },
          {

            "label": "兰坪",
            "value": "533325",

          }
        ]
      },
      {

        "label": "迪庆",
        "value": "533400",
        "children": [
          {

            "label": "香格里拉",
            "value": "533421",

          },
          {

            "label": "德钦",
            "value": "533422",

          },
          {

            "label": "维西",
            "value": "533423",

          }
        ]
      }
    ]
  },
  {

    "label": "西藏",
    "value": "540000",
    "children": [
      {

        "label": "拉萨",
        "value": "540100",
        "children": [
          {

            "label": "城关",
            "value": "540102",

          },
          {

            "label": "林周",
            "value": "540121",

          },
          {

            "label": "当雄",
            "value": "540122",

          },
          {

            "label": "尼木",
            "value": "540123",

          },
          {

            "label": "曲水",
            "value": "540124",

          },
          {

            "label": "堆龙德庆",
            "value": "540125",

          },
          {

            "label": "达孜",
            "value": "540126",

          },
          {

            "label": "墨竹工卡",
            "value": "540127",

          }
        ]
      },
      {

        "label": "日喀则",
        "value": "540200",
        "children": [
          {

            "label": "桑珠孜",
            "value": "540202",

          },
          {

            "label": "南木林",
            "value": "540221",

          },
          {

            "label": "江孜",
            "value": "540222",

          },
          {

            "label": "定日",
            "value": "540223",

          },
          {

            "label": "萨迦",
            "value": "540224",

          },
          {

            "label": "拉孜",
            "value": "540225",

          },
          {

            "label": "昂仁",
            "value": "540226",

          },
          {

            "label": "谢通门",
            "value": "540227",

          },
          {

            "label": "白朗",
            "value": "540228",

          },
          {

            "label": "仁布",
            "value": "540229",

          },
          {

            "label": "康马",
            "value": "540230",

          },
          {

            "label": "定结",
            "value": "540231",

          },
          {

            "label": "仲巴",
            "value": "540232",

          },
          {

            "label": "亚东",
            "value": "540233",

          },
          {

            "label": "吉隆",
            "value": "540234",

          },
          {

            "label": "聂拉木",
            "value": "540235",

          },
          {

            "label": "萨嘎",
            "value": "540236",

          },
          {

            "label": "岗巴",
            "value": "540237",

          }
        ]
      },
      {

        "label": "昌都",
        "value": "540300",
        "children": [
          {

            "label": "昌都",
            "value": "540302",

          },
          {

            "label": "江达",
            "value": "540321",

          },
          {

            "label": "贡觉",
            "value": "540322",

          },
          {

            "label": "类乌齐",
            "value": "540323",

          },
          {

            "label": "丁青",
            "value": "540324",

          },
          {

            "label": "察雅",
            "value": "540325",

          },
          {

            "label": "八宿",
            "value": "540326",

          },
          {

            "label": "左贡",
            "value": "540327",

          },
          {

            "label": "芒康",
            "value": "540328",

          },
          {

            "label": "洛隆",
            "value": "540329",

          },
          {

            "label": "边坝",
            "value": "540330",

          }
        ]
      },
      {

        "label": "山南",
        "value": "542200",
        "children": [
          {

            "label": "乃东",
            "value": "542221",

          },
          {

            "label": "扎囊",
            "value": "542222",

          },
          {

            "label": "贡嘎",
            "value": "542223",

          },
          {

            "label": "桑日",
            "value": "542224",

          },
          {

            "label": "琼结",
            "value": "542225",

          },
          {

            "label": "曲松",
            "value": "542226",

          },
          {

            "label": "措美",
            "value": "542227",

          },
          {

            "label": "洛扎",
            "value": "542228",

          },
          {

            "label": "加查",
            "value": "542229",

          },
          {

            "label": "隆子",
            "value": "542231",

          },
          {

            "label": "错那",
            "value": "542232",

          },
          {

            "label": "浪卡子",
            "value": "542233",

          }
        ]
      },
      {

        "label": "那曲",
        "value": "542400",
        "children": [
          {

            "label": "那曲",
            "value": "542421",

          },
          {

            "label": "嘉黎",
            "value": "542422",

          },
          {

            "label": "比如",
            "value": "542423",

          },
          {

            "label": "聂荣",
            "value": "542424",

          },
          {

            "label": "安多",
            "value": "542425",

          },
          {

            "label": "申扎",
            "value": "542426",

          },
          {

            "label": "索县",
            "value": "542427",

          },
          {

            "label": "班戈",
            "value": "542428",

          },
          {

            "label": "巴青",
            "value": "542429",

          },
          {

            "label": "尼玛",
            "value": "542430",

          },
          {

            "label": "双湖",
            "value": "542431",

          }
        ]
      },
      {

        "label": "阿里",
        "value": "542500",
        "children": [
          {

            "label": "普兰",
            "value": "542521",

          },
          {

            "label": "札达",
            "value": "542522",

          },
          {

            "label": "噶尔",
            "value": "542523",

          },
          {

            "label": "日土",
            "value": "542524",

          },
          {

            "label": "革吉",
            "value": "542525",

          },
          {

            "label": "改则",
            "value": "542526",

          },
          {

            "label": "措勤",
            "value": "542527",

          }
        ]
      },
      {

        "label": "林芝",
        "value": "542600",
        "children": [
          {

            "label": "林芝",
            "value": "542621",

          },
          {

            "label": "工布江达",
            "value": "542622",

          },
          {

            "label": "米林",
            "value": "542623",

          },
          {

            "label": "墨脱",
            "value": "542624",

          },
          {

            "label": "波密",
            "value": "542625",

          },
          {

            "label": "察隅",
            "value": "542626",

          },
          {

            "label": "朗县",
            "value": "542627",

          }
        ]
      }
    ]
  },
  {

    "label": "陕西",
    "value": "610000",
    "children": [
      {

        "label": "西安",
        "value": "610100",
        "children": [
          {

            "label": "新城",
            "value": "610102",

          },
          {

            "label": "碑林",
            "value": "610103",

          },
          {

            "label": "莲湖",
            "value": "610104",

          },
          {

            "label": "灞桥",
            "value": "610111",

          },
          {

            "label": "未央",
            "value": "610112",

          },
          {

            "label": "雁塔",
            "value": "610113",

          },
          {

            "label": "阎良",
            "value": "610114",

          },
          {

            "label": "临潼",
            "value": "610115",

          },
          {

            "label": "长安",
            "value": "610116",

          },
          {

            "label": "蓝田",
            "value": "610122",

          },
          {

            "label": "周至",
            "value": "610124",

          },
          {

            "label": "户县",
            "value": "610125",

          },
          {

            "label": "高陵",
            "value": "610126",

          }
        ]
      },
      {

        "label": "铜川",
        "value": "610200",
        "children": [
          {

            "label": "王益",
            "value": "610202",

          },
          {

            "label": "印台",
            "value": "610203",

          },
          {

            "label": "耀州",
            "value": "610204",

          },
          {

            "label": "宜君",
            "value": "610222",

          }
        ]
      },
      {

        "label": "宝鸡",
        "value": "610300",
        "children": [
          {

            "label": "渭滨",
            "value": "610302",

          },
          {

            "label": "金台",
            "value": "610303",

          },
          {

            "label": "陈仓",
            "value": "610304",

          },
          {

            "label": "凤翔",
            "value": "610322",

          },
          {

            "label": "岐山",
            "value": "610323",

          },
          {

            "label": "扶风",
            "value": "610324",

          },
          {

            "label": "眉县",
            "value": "610326",

          },
          {

            "label": "陇县",
            "value": "610327",

          },
          {

            "label": "千阳",
            "value": "610328",

          },
          {

            "label": "麟游",
            "value": "610329",

          },
          {

            "label": "凤县",
            "value": "610330",

          },
          {

            "label": "太白",
            "value": "610331",

          }
        ]
      },
      {

        "label": "咸阳",
        "value": "610400",
        "children": [
          {

            "label": "秦都",
            "value": "610402",

          },
          {

            "label": "杨陵",
            "value": "610403",

          },
          {

            "label": "渭城",
            "value": "610404",

          },
          {

            "label": "三原",
            "value": "610422",

          },
          {

            "label": "泾阳",
            "value": "610423",

          },
          {

            "label": "乾县",
            "value": "610424",

          },
          {

            "label": "礼泉",
            "value": "610425",

          },
          {

            "label": "永寿",
            "value": "610426",

          },
          {

            "label": "彬县",
            "value": "610427",

          },
          {

            "label": "长武",
            "value": "610428",

          },
          {

            "label": "旬邑",
            "value": "610429",

          },
          {

            "label": "淳化",
            "value": "610430",

          },
          {

            "label": "武功",
            "value": "610431",

          },
          {

            "label": "兴平",
            "value": "610481",

          }
        ]
      },
      {

        "label": "渭南",
        "value": "610500",
        "children": [
          {

            "label": "临渭",
            "value": "610502",

          },
          {

            "label": "华县",
            "value": "610521",

          },
          {

            "label": "潼关",
            "value": "610522",

          },
          {

            "label": "大荔",
            "value": "610523",

          },
          {

            "label": "合阳",
            "value": "610524",

          },
          {

            "label": "澄城",
            "value": "610525",

          },
          {

            "label": "蒲城",
            "value": "610526",

          },
          {

            "label": "白水",
            "value": "610527",

          },
          {

            "label": "富平",
            "value": "610528",

          },
          {

            "label": "韩城",
            "value": "610581",

          },
          {

            "label": "华阴",
            "value": "610582",

          }
        ]
      },
      {

        "label": "延安",
        "value": "610600",
        "children": [
          {

            "label": "宝塔",
            "value": "610602",

          },
          {

            "label": "延长",
            "value": "610621",

          },
          {

            "label": "延川",
            "value": "610622",

          },
          {

            "label": "子长",
            "value": "610623",

          },
          {

            "label": "安塞",
            "value": "610624",

          },
          {

            "label": "志丹",
            "value": "610625",

          },
          {

            "label": "吴起",
            "value": "610626",

          },
          {

            "label": "甘泉",
            "value": "610627",

          },
          {

            "label": "富县",
            "value": "610628",

          },
          {

            "label": "洛川",
            "value": "610629",

          },
          {

            "label": "宜川",
            "value": "610630",

          },
          {

            "label": "黄龙",
            "value": "610631",

          },
          {

            "label": "黄陵",
            "value": "610632",

          }
        ]
      },
      {

        "label": "汉中",
        "value": "610700",
        "children": [
          {

            "label": "汉台",
            "value": "610702",

          },
          {

            "label": "南郑",
            "value": "610721",

          },
          {

            "label": "城固",
            "value": "610722",

          },
          {

            "label": "洋县",
            "value": "610723",

          },
          {

            "label": "西乡",
            "value": "610724",

          },
          {

            "label": "勉县",
            "value": "610725",

          },
          {

            "label": "宁强",
            "value": "610726",

          },
          {

            "label": "略阳",
            "value": "610727",

          },
          {

            "label": "镇巴",
            "value": "610728",

          },
          {

            "label": "留坝",
            "value": "610729",

          },
          {

            "label": "佛坪",
            "value": "610730",

          }
        ]
      },
      {

        "label": "榆林",
        "value": "610800",
        "children": [
          {

            "label": "榆阳",
            "value": "610802",

          },
          {

            "label": "神木",
            "value": "610821",

          },
          {

            "label": "府谷",
            "value": "610822",

          },
          {

            "label": "横山",
            "value": "610823",

          },
          {

            "label": "靖边",
            "value": "610824",

          },
          {

            "label": "定边",
            "value": "610825",

          },
          {

            "label": "绥德",
            "value": "610826",

          },
          {

            "label": "米脂",
            "value": "610827",

          },
          {

            "label": "佳县",
            "value": "610828",

          },
          {

            "label": "吴堡",
            "value": "610829",

          },
          {

            "label": "清涧",
            "value": "610830",

          },
          {

            "label": "子洲",
            "value": "610831",

          }
        ]
      },
      {

        "label": "安康",
        "value": "610900",
        "children": [
          {

            "label": "汉滨",
            "value": "610902",

          },
          {

            "label": "汉阴",
            "value": "610921",

          },
          {

            "label": "石泉",
            "value": "610922",

          },
          {

            "label": "宁陕",
            "value": "610923",

          },
          {

            "label": "紫阳",
            "value": "610924",

          },
          {

            "label": "岚皋",
            "value": "610925",

          },
          {

            "label": "平利",
            "value": "610926",

          },
          {

            "label": "镇坪",
            "value": "610927",

          },
          {

            "label": "旬阳",
            "value": "610928",

          },
          {

            "label": "白河",
            "value": "610929",

          }
        ]
      },
      {

        "label": "商洛",
        "value": "611000",
        "children": [
          {

            "label": "商州",
            "value": "611002",

          },
          {

            "label": "洛南",
            "value": "611021",

          },
          {

            "label": "丹凤",
            "value": "611022",

          },
          {

            "label": "商南",
            "value": "611023",

          },
          {

            "label": "山阳",
            "value": "611024",

          },
          {

            "label": "镇安",
            "value": "611025",

          },
          {

            "label": "柞水",
            "value": "611026",

          }
        ]
      },
      {

        "label": "西咸",
        "value": "611100",
        "children": [
          {

            "label": "空港",
            "value": "611101",

          },
          {

            "label": "沣东",
            "value": "611102",

          },
          {

            "label": "秦汉",
            "value": "611103",

          },
          {

            "label": "沣西",
            "value": "611104",

          },
          {

            "label": "泾河",
            "value": "611105",

          }
        ]
      }
    ]
  },
  {

    "label": "甘肃",
    "value": "620000",
    "children": [
      {

        "label": "兰州",
        "value": "620100",
        "children": [
          {

            "label": "城关",
            "value": "620102",

          },
          {

            "label": "七里河",
            "value": "620103",

          },
          {

            "label": "西固",
            "value": "620104",

          },
          {

            "label": "安宁",
            "value": "620105",

          },
          {

            "label": "红古",
            "value": "620111",

          },
          {

            "label": "永登",
            "value": "620121",

          },
          {

            "label": "皋兰",
            "value": "620122",

          },
          {

            "label": "榆中",
            "value": "620123",

          }
        ]
      },
      {

        "label": "嘉峪关",
        "value": "620200",
        "children": [
          {

            "label": "雄关",
            "value": "620201",

          },
          {

            "label": "长城",
            "value": "620202",

          },
          {

            "label": "镜铁",
            "value": "620203",

          }
        ]
      },
      {

        "label": "金昌",
        "value": "620300",
        "children": [
          {

            "label": "金川",
            "value": "620302",

          },
          {

            "label": "永昌",
            "value": "620321",

          }
        ]
      },
      {

        "label": "白银",
        "value": "620400",
        "children": [
          {

            "label": "白银",
            "value": "620402",

          },
          {

            "label": "平川",
            "value": "620403",

          },
          {

            "label": "靖远",
            "value": "620421",

          },
          {

            "label": "会宁",
            "value": "620422",

          },
          {

            "label": "景泰",
            "value": "620423",

          }
        ]
      },
      {

        "label": "天水",
        "value": "620500",
        "children": [
          {

            "label": "秦州",
            "value": "620502",

          },
          {

            "label": "麦积",
            "value": "620503",

          },
          {

            "label": "清水",
            "value": "620521",

          },
          {

            "label": "秦安",
            "value": "620522",

          },
          {

            "label": "甘谷",
            "value": "620523",

          },
          {

            "label": "武山",
            "value": "620524",

          },
          {

            "label": "张家川",
            "value": "620525",

          }
        ]
      },
      {

        "label": "武威",
        "value": "620600",
        "children": [
          {

            "label": "凉州",
            "value": "620602",

          },
          {

            "label": "民勤",
            "value": "620621",

          },
          {

            "label": "古浪",
            "value": "620622",

          },
          {

            "label": "天祝",
            "value": "620623",

          }
        ]
      },
      {

        "label": "张掖",
        "value": "620700",
        "children": [
          {

            "label": "甘州",
            "value": "620702",

          },
          {

            "label": "肃南",
            "value": "620721",

          },
          {

            "label": "民乐",
            "value": "620722",

          },
          {

            "label": "临泽",
            "value": "620723",

          },
          {

            "label": "高台",
            "value": "620724",

          },
          {

            "label": "山丹",
            "value": "620725",

          }
        ]
      },
      {

        "label": "平凉",
        "value": "620800",
        "children": [
          {

            "label": "崆峒",
            "value": "620802",

          },
          {

            "label": "泾川",
            "value": "620821",

          },
          {

            "label": "灵台",
            "value": "620822",

          },
          {

            "label": "崇信",
            "value": "620823",

          },
          {

            "label": "华亭",
            "value": "620824",

          },
          {

            "label": "庄浪",
            "value": "620825",

          },
          {

            "label": "静宁",
            "value": "620826",

          }
        ]
      },
      {

        "label": "酒泉",
        "value": "620900",
        "children": [
          {

            "label": "肃州",
            "value": "620902",

          },
          {

            "label": "金塔",
            "value": "620921",

          },
          {

            "label": "瓜州",
            "value": "620922",

          },
          {

            "label": "肃北",
            "value": "620923",

          },
          {

            "label": "阿克塞",
            "value": "620924",

          },
          {

            "label": "玉门",
            "value": "620981",

          },
          {

            "label": "敦煌",
            "value": "620982",

          }
        ]
      },
      {

        "label": "庆阳",
        "value": "621000",
        "children": [
          {

            "label": "西峰",
            "value": "621002",

          },
          {

            "label": "庆城",
            "value": "621021",

          },
          {

            "label": "环县",
            "value": "621022",

          },
          {

            "label": "华池",
            "value": "621023",

          },
          {

            "label": "合水",
            "value": "621024",

          },
          {

            "label": "正宁",
            "value": "621025",

          },
          {

            "label": "宁县",
            "value": "621026",

          },
          {

            "label": "镇原",
            "value": "621027",

          }
        ]
      },
      {

        "label": "定西",
        "value": "621100",
        "children": [
          {

            "label": "安定",
            "value": "621102",

          },
          {

            "label": "通渭",
            "value": "621121",

          },
          {

            "label": "陇西",
            "value": "621122",

          },
          {

            "label": "渭源",
            "value": "621123",

          },
          {

            "label": "临洮",
            "value": "621124",

          },
          {

            "label": "漳县",
            "value": "621125",

          },
          {

            "label": "岷县",
            "value": "621126",

          }
        ]
      },
      {

        "label": "陇南",
        "value": "621200",
        "children": [
          {

            "label": "武都",
            "value": "621202",

          },
          {

            "label": "成县",
            "value": "621221",

          },
          {

            "label": "文县",
            "value": "621222",

          },
          {

            "label": "宕昌",
            "value": "621223",

          },
          {

            "label": "康县",
            "value": "621224",

          },
          {

            "label": "西和",
            "value": "621225",

          },
          {

            "label": "礼县",
            "value": "621226",

          },
          {

            "label": "徽县",
            "value": "621227",

          },
          {

            "label": "两当",
            "value": "621228",

          }
        ]
      },
      {

        "label": "临夏",
        "value": "622900",
        "children": [
          {

            "label": "临夏",
            "value": "622901",

          },
          {

            "label": "临夏",
            "value": "622921",

          },
          {

            "label": "康乐",
            "value": "622922",

          },
          {

            "label": "永靖",
            "value": "622923",

          },
          {

            "label": "广河",
            "value": "622924",

          },
          {

            "label": "和政",
            "value": "622925",

          },
          {

            "label": "东乡族",
            "value": "622926",

          },
          {

            "label": "积石山",
            "value": "622927",

          }
        ]
      },
      {

        "label": "甘南",
        "value": "623000",
        "children": [
          {

            "label": "合作",
            "value": "623001",

          },
          {

            "label": "临潭",
            "value": "623021",

          },
          {

            "label": "卓尼",
            "value": "623022",

          },
          {

            "label": "舟曲",
            "value": "623023",

          },
          {

            "label": "迭部",
            "value": "623024",

          },
          {

            "label": "玛曲",
            "value": "623025",

          },
          {

            "label": "碌曲",
            "value": "623026",

          },
          {

            "label": "夏河",
            "value": "623027",

          }
        ]
      }
    ]
  },
  {

    "label": "青海",
    "value": "630000",
    "children": [
      {

        "label": "西宁",
        "value": "630100",
        "children": [
          {

            "label": "城东",
            "value": "630102",

          },
          {

            "label": "城中",
            "value": "630103",

          },
          {

            "label": "城西",
            "value": "630104",

          },
          {

            "label": "城北",
            "value": "630105",

          },
          {

            "label": "大通",
            "value": "630121",

          },
          {

            "label": "湟中",
            "value": "630122",

          },
          {

            "label": "湟源",
            "value": "630123",

          }
        ]
      },
      {

        "label": "海东",
        "value": "630200",
        "children": [
          {

            "label": "乐都",
            "value": "630202",

          },
          {

            "label": "平安",
            "value": "630221",

          },
          {

            "label": "民和",
            "value": "630222",

          },
          {

            "label": "互助",
            "value": "630223",

          },
          {

            "label": "化隆",
            "value": "630224",

          },
          {

            "label": "循化",
            "value": "630225",

          }
        ]
      },
      {

        "label": "海北",
        "value": "632200",
        "children": [
          {

            "label": "门源",
            "value": "632221",

          },
          {

            "label": "祁连",
            "value": "632222",

          },
          {

            "label": "海晏",
            "value": "632223",

          },
          {

            "label": "刚察",
            "value": "632224",

          }
        ]
      },
      {

        "label": "黄南",
        "value": "632300",
        "children": [
          {

            "label": "同仁",
            "value": "632321",

          },
          {

            "label": "尖扎",
            "value": "632322",

          },
          {

            "label": "泽库",
            "value": "632323",

          },
          {

            "label": "河南",
            "value": "632324",

          }
        ]
      },
      {

        "label": "海南",
        "value": "632500",
        "children": [
          {

            "label": "共和",
            "value": "632521",

          },
          {

            "label": "同德",
            "value": "632522",

          },
          {

            "label": "贵德",
            "value": "632523",

          },
          {

            "label": "兴海",
            "value": "632524",

          },
          {

            "label": "贵南",
            "value": "632525",

          }
        ]
      },
      {

        "label": "果洛",
        "value": "632600",
        "children": [
          {

            "label": "玛沁",
            "value": "632621",

          },
          {

            "label": "班玛",
            "value": "632622",

          },
          {

            "label": "甘德",
            "value": "632623",

          },
          {

            "label": "达日",
            "value": "632624",

          },
          {

            "label": "久治",
            "value": "632625",

          },
          {

            "label": "玛多",
            "value": "632626",

          }
        ]
      },
      {

        "label": "玉树",
        "value": "632700",
        "children": [
          {

            "label": "玉树",
            "value": "632701",

          },
          {

            "label": "杂多",
            "value": "632722",

          },
          {

            "label": "称多",
            "value": "632723",

          },
          {

            "label": "治多",
            "value": "632724",

          },
          {

            "label": "囊谦",
            "value": "632725",

          },
          {

            "label": "曲麻莱",
            "value": "632726",

          }
        ]
      },
      {

        "label": "海西",
        "value": "632800",
        "children": [
          {

            "label": "格尔木",
            "value": "632801",

          },
          {

            "label": "德令哈",
            "value": "632802",

          },
          {

            "label": "乌兰",
            "value": "632821",

          },
          {

            "label": "都兰",
            "value": "632822",

          },
          {

            "label": "天峻",
            "value": "632823",

          }
        ]
      }
    ]
  },
  {

    "label": "宁夏",
    "value": "640000",
    "children": [
      {

        "label": "银川",
        "value": "640100",
        "children": [
          {

            "label": "兴庆",
            "value": "640104",

          },
          {

            "label": "西夏",
            "value": "640105",

          },
          {

            "label": "金凤",
            "value": "640106",

          },
          {

            "label": "永宁",
            "value": "640121",

          },
          {

            "label": "贺兰",
            "value": "640122",

          },
          {

            "label": "灵武",
            "value": "640181",

          }
        ]
      },
      {

        "label": "石嘴山",
        "value": "640200",
        "children": [
          {

            "label": "大武口",
            "value": "640202",

          },
          {

            "label": "惠农",
            "value": "640205",

          },
          {

            "label": "平罗",
            "value": "640221",

          }
        ]
      },
      {

        "label": "吴忠",
        "value": "640300",
        "children": [
          {

            "label": "利通",
            "value": "640302",

          },
          {

            "label": "红寺堡",
            "value": "640303",

          },
          {

            "label": "盐池",
            "value": "640323",

          },
          {

            "label": "同心",
            "value": "640324",

          },
          {

            "label": "青铜峡",
            "value": "640381",

          }
        ]
      },
      {

        "label": "固原",
        "value": "640400",
        "children": [
          {

            "label": "原州",
            "value": "640402",

          },
          {

            "label": "西吉",
            "value": "640422",

          },
          {

            "label": "隆德",
            "value": "640423",

          },
          {

            "label": "泾源",
            "value": "640424",

          },
          {

            "label": "彭阳",
            "value": "640425",

          }
        ]
      },
      {

        "label": "中卫",
        "value": "640500",
        "children": [
          {

            "label": "沙坡头",
            "value": "640502",

          },
          {

            "label": "中宁",
            "value": "640521",

          },
          {

            "label": "海原",
            "value": "640522",

          }
        ]
      }
    ]
  },
  {

    "label": "新疆",
    "value": "650000",
    "children": [
      {

        "label": "乌鲁木齐",
        "value": "650100",
        "children": [
          {

            "label": "天山",
            "value": "650102",

          },
          {

            "label": "沙依巴克",
            "value": "650103",

          },
          {

            "label": "新市",
            "value": "650104",

          },
          {

            "label": "水磨沟",
            "value": "650105",

          },
          {

            "label": "头屯河",
            "value": "650106",

          },
          {

            "label": "达坂城",
            "value": "650107",

          },
          {

            "label": "米东",
            "value": "650109",

          },
          {

            "label": "乌鲁木齐",
            "value": "650121",

          }
        ]
      },
      {

        "label": "克拉玛依",
        "value": "650200",
        "children": [
          {

            "label": "独山子",
            "value": "650202",

          },
          {

            "label": "克拉玛依",
            "value": "650203",

          },
          {

            "label": "白碱滩",
            "value": "650204",

          },
          {

            "label": "乌尔禾",
            "value": "650205",

          }
        ]
      },
      {

        "label": "吐鲁番",
        "value": "652100",
        "children": [
          {

            "label": "吐鲁番",
            "value": "652101",

          },
          {

            "label": "鄯善",
            "value": "652122",

          },
          {

            "label": "托克逊",
            "value": "652123",

          }
        ]
      },
      {

        "label": "哈密",
        "value": "652200",
        "children": [
          {

            "label": "哈密",
            "value": "652201",

          },
          {

            "label": "巴里坤",
            "value": "652222",

          },
          {

            "label": "伊吾",
            "value": "652223",

          }
        ]
      },
      {

        "label": "昌吉",
        "value": "652300",
        "children": [
          {

            "label": "昌吉",
            "value": "652301",

          },
          {

            "label": "阜康",
            "value": "652302",

          },
          {

            "label": "呼图壁",
            "value": "652323",

          },
          {

            "label": "玛纳斯",
            "value": "652324",

          },
          {

            "label": "奇台",
            "value": "652325",

          },
          {

            "label": "吉木萨尔",
            "value": "652327",

          },
          {

            "label": "木垒",
            "value": "652328",

          }
        ]
      },
      {

        "label": "博尔塔拉",
        "value": "652700",
        "children": [
          {

            "label": "博乐",
            "value": "652701",

          },
          {

            "label": "阿拉山口",
            "value": "652702",

          },
          {

            "label": "精河",
            "value": "652722",

          },
          {

            "label": "温泉",
            "value": "652723",

          }
        ]
      },
      {

        "label": "巴音郭楞",
        "value": "652800",
        "children": [
          {

            "label": "库尔勒",
            "value": "652801",

          },
          {

            "label": "轮台",
            "value": "652822",

          },
          {

            "label": "尉犁",
            "value": "652823",

          },
          {

            "label": "若羌",
            "value": "652824",

          },
          {

            "label": "且末",
            "value": "652825",

          },
          {

            "label": "焉耆",
            "value": "652826",

          },
          {

            "label": "和静",
            "value": "652827",

          },
          {

            "label": "和硕",
            "value": "652828",

          },
          {

            "label": "博湖",
            "value": "652829",

          }
        ]
      },
      {

        "label": "阿克苏",
        "value": "652900",
        "children": [
          {

            "label": "阿克苏",
            "value": "652901",

          },
          {

            "label": "温宿",
            "value": "652922",

          },
          {

            "label": "库车",
            "value": "652923",

          },
          {

            "label": "沙雅",
            "value": "652924",

          },
          {

            "label": "新和",
            "value": "652925",

          },
          {

            "label": "拜城",
            "value": "652926",

          },
          {

            "label": "乌什",
            "value": "652927",

          },
          {

            "label": "阿瓦提",
            "value": "652928",

          },
          {

            "label": "柯坪",
            "value": "652929",

          }
        ]
      },
      {

        "label": "克孜勒苏",
        "value": "653000",
        "children": [
          {

            "label": "阿图什",
            "value": "653001",

          },
          {

            "label": "阿克陶",
            "value": "653022",

          },
          {

            "label": "阿合奇",
            "value": "653023",

          },
          {

            "label": "乌恰",
            "value": "653024",

          }
        ]
      },
      {

        "label": "喀什",
        "value": "653100",
        "children": [
          {

            "label": "喀什",
            "value": "653101",

          },
          {

            "label": "疏附",
            "value": "653121",

          },
          {

            "label": "疏勒",
            "value": "653122",

          },
          {

            "label": "英吉沙",
            "value": "653123",

          },
          {

            "label": "泽普",
            "value": "653124",

          },
          {

            "label": "莎车",
            "value": "653125",

          },
          {

            "label": "叶城",
            "value": "653126",

          },
          {

            "label": "麦盖提",
            "value": "653127",

          },
          {

            "label": "岳普湖",
            "value": "653128",

          },
          {

            "label": "伽师",
            "value": "653129",

          },
          {

            "label": "巴楚",
            "value": "653130",

          },
          {

            "label": "塔什库尔干塔吉克",
            "value": "653131",

          }
        ]
      },
      {

        "label": "和田",
        "value": "653200",
        "children": [
          {

            "label": "和田市",
            "value": "653201",

          },
          {

            "label": "和田县",
            "value": "653221",

          },
          {

            "label": "墨玉",
            "value": "653222",

          },
          {

            "label": "皮山",
            "value": "653223",

          },
          {

            "label": "洛浦",
            "value": "653224",

          },
          {

            "label": "策勒",
            "value": "653225",

          },
          {

            "label": "于田",
            "value": "653226",

          },
          {

            "label": "民丰",
            "value": "653227",

          }
        ]
      },
      {

        "label": "伊犁",
        "value": "654000",
        "children": [
          {

            "label": "伊宁",
            "value": "654002",

          },
          {

            "label": "奎屯",
            "value": "654003",

          },
          {

            "label": "霍尔果斯",
            "value": "654004",

          },
          {

            "label": "伊宁",
            "value": "654021",

          },
          {

            "label": "察布查尔锡伯",
            "value": "654022",

          },
          {

            "label": "霍城",
            "value": "654023",

          },
          {

            "label": "巩留",
            "value": "654024",

          },
          {

            "label": "新源",
            "value": "654025",

          },
          {

            "label": "昭苏",
            "value": "654026",

          },
          {

            "label": "特克斯",
            "value": "654027",

          },
          {

            "label": "尼勒克",
            "value": "654028",

          }
        ]
      },
      {

        "label": "塔城",
        "value": "654200",
        "children": [
          {

            "label": "塔城",
            "value": "654201",

          },
          {

            "label": "乌苏",
            "value": "654202",

          },
          {

            "label": "额敏",
            "value": "654221",

          },
          {

            "label": "沙湾",
            "value": "654223",

          },
          {

            "label": "托里",
            "value": "654224",

          },
          {

            "label": "裕民",
            "value": "654225",

          },
          {

            "label": "和布克赛尔",
            "value": "654226",

          }
        ]
      },
      {

        "label": "阿勒泰",
        "value": "654300",
        "children": [
          {

            "label": "阿勒泰",
            "value": "654301",

          },
          {

            "label": "布尔津",
            "value": "654321",

          },
          {

            "label": "富蕴",
            "value": "654322",

          },
          {

            "label": "福海",
            "value": "654323",

          },
          {

            "label": "哈巴河",
            "value": "654324",

          },
          {

            "label": "青河",
            "value": "654325",

          },
          {

            "label": "吉木乃",
            "value": "654326",

          }
        ]
      },
      {

        "label": " ",
        "value": "659000",
        "children": [
          {

            "label": "石河子",
            "value": "659001",

          },
          {

            "label": "阿拉尔",
            "value": "659002",

          },
          {

            "label": "图木舒克",
            "value": "659003",

          },
          {

            "label": "五家渠",
            "value": "659004",

          },
          {

            "label": "北屯",
            "value": "659005",

          },
          {

            "label": "铁门关",
            "value": "659006",

          },
          {

            "label": "双河",
            "value": "659007",

          }
        ]
      }
    ]
  }
]